import { warningAlert } from "config/sweet-alert/alert";
import {
  COMPASS,
  ARRAY,
  COMPASS_INNER_PANELS_MARGIN_FROM_TOP,
  PRODUCT,
  pixelPerInch,
} from "constants/appConstant";

function generateUniqueId() {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uniqueId = "";

  for (let i = 0; i < 10; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    uniqueId += characters.charAt(randomIndex);
  }

  return uniqueId;
}

const checkInfinityDropLocation = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins
) => {
  const { dragServiceWidth, service } = dragItem.current;
  const rails = [...values.headwalls];

  let services = rails[railIndex]?.services;

  if (service?.is_slide) services = services?.filter((ser) => ser?.is_slide);
  else services = services?.filter((ser) => !ser?.is_slide);
  const dragServicePosition = dragPositions.current;
  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let checkServicesIntersecting = {
    oneTouched: false,
    twoTouched: false,
    startRailTouched: false,
    maxRailTouched: false,
  };
  //center chase calculations
  // const minValue = railDimensionsRef.current?.width / 2 - 192.5; // 40px chase width+ 107 px for 6 inch
  // const maxValue = railDimensionsRef.current?.width / 2 + 192.5;
  const minValue = railDimensionsRef.current?.width / 2 - 230.905; // 123.905px chase width+ 107 px for 6 inch
  const maxValue = railDimensionsRef.current?.width / 2 + 230.905;
  //--------------------------------------------------------------------------//

  //if the service width is greater than rail width
  if (dragServiceWidth > railDimensionsRef.current?.width) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
  }

  for (let i = 0; i < services?.length; i++) {
    const serviceWidth = services[i].gang_width / pixelPerInch;
    if (service.u_id !== services[i].u_id) {
      //calculation for left side drag
      if (
        dragServicePosition.x >= services[i]?.positions?.x &&
        dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
      ) {
        checkServicesIntersecting["oneTouched"] = true;
        const newPosition = services[i]?.positions?.x + serviceWidth;
        if (
          values.chase_position === "center" &&
          newPosition < minValue &&
          newPosition + dragServiceWidth > minValue
        ) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
          return;
        }
        //to check the margins between last service and rail width
        if (
          newPosition + dragServiceWidth <=
          railDimensionsRef.current.width - railMargins.end
        ) {
          newDropLocation = {
            x: services[i]?.positions?.x + serviceWidth,
            y: 0,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
        }
        break;
      } //calulation for right side drag
      else if (
        dragServicePosition.x + dragServiceWidth >= services[i]?.positions?.x &&
        dragServicePosition.x + dragServiceWidth <=
          services[i]?.positions?.x + dragServiceWidth
      ) {
        checkServicesIntersecting["twoTouched"] = true;
        const newPosition = services[i]?.positions?.x - dragServiceWidth;
        if (
          values.chase_position === "center" &&
          newPosition < maxValue &&
          newPosition + dragServiceWidth > maxValue
        ) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
          return;
        }
        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation = {
            x: newPosition,
            y: 0,
          };
          break;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
        }
      }
    }
  }

  const checkServicesOverLap = services?.some((serv) => {
    const serviceWidth = serv.gang_width / pixelPerInch;
    return (
      serv.u_id !== service.u_id &&
      (serv.positions?.x === newDropLocation.x ||
        (newDropLocation.x + dragServiceWidth > serv.positions?.x &&
          newDropLocation.x + dragServiceWidth <
            serv.positions?.x + serviceWidth) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions?.x &&
          newDropLocation.x + dragServiceWidth >=
            serv.positions?.x + serviceWidth))
    );
  });
  if (
    (checkServicesIntersecting.oneTouched &&
      checkServicesIntersecting.twoTouched) ||
    checkServicesOverLap
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
  } else if (
    values.chase_position === "center" &&
    checkServicesIntersecting.oneTouched &&
    newDropLocation.x + dragServiceWidth > minValue &&
    newDropLocation.x < maxValue
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
  } else if (
    values.chase_position === "center" &&
    checkServicesIntersecting.twoTouched &&
    newDropLocation.x < maxValue &&
    newDropLocation.x > minValue
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
  } else if (
    checkServicesIntersecting.oneTouched ||
    checkServicesIntersecting.twoTouched
  )
    dragPositions.current = newDropLocation;
  //to restrict drop 6 inches both side of the center chase
  if (values.chased && values.chase_position === "center") {
    if (
      newDropLocation.x + dragServiceWidth > minValue &&
      newDropLocation.x < maxValue
    ) {
      if (newDropLocation.x < railDimensionsRef.current.width / 2) {
        const newPosition = minValue - dragServiceWidth;
        // if start value is less than the rail start point
        if (newPosition < railMargins.start) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
          return;
        }
        const checkforOtherServiceOnSamePosition = services?.some((serv) => {
          return (
            serv.positions.x === newPosition ||
            (newPosition <= serv.positions.x &&
              newPosition + dragServiceWidth >=
                serv.positions.x + serv.gang_width / pixelPerInch) ||
            (newPosition <= serv.positions.x + serv.gang_width / pixelPerInch &&
              newPosition + dragServiceWidth >=
                serv.positions.x + serv.gang_width / pixelPerInch.toFixed(1))
          );
        });
        if (checkforOtherServiceOnSamePosition) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
          return;
        }
        dragPositions.current = { x: newPosition, y: 0 };
      } else if (newDropLocation.x > railDimensionsRef.current.width / 2) {
        const newPosition = maxValue;
        // if service start value is greater than the rail end point
        if (
          newPosition + dragServiceWidth > railDimensionsRef.current.width ||
          newPosition + dragServiceWidth >
            railDimensionsRef.current.width - railMargins.end
        ) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
          return;
        }
        const checkforOtherServiceOnSamePosition = services?.some((serv) => {
          const serviceWidth = serv.gang_width / pixelPerInch;
          return (
            serv.positions.x === newPosition ||
            (newPosition + dragServiceWidth >= serv.positions.x &&
              newPosition + dragServiceWidth <=
                serv.positions.x + serviceWidth) ||
            (newPosition < serv.positions?.x &&
              newPosition + dragServiceWidth >=
                serv.positions?.x + serviceWidth)
          );
        });
        if (checkforOtherServiceOnSamePosition) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
          return;
        }
        dragPositions.current = { x: newPosition, y: 0 };
      }
    }
  }
  return dropLocation;
};

const checkInfinityDropLocation2 = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  arrow
) => {
  const { dragServiceWidth, service } = dragItem;
  const rails = [...values.headwalls];

  let services = rails[railIndex]?.services;

  if (service?.is_slide) services = services?.filter((ser) => ser?.is_slide);
  else services = services?.filter((ser) => !ser?.is_slide);
  const dragServicePosition = dragPositions.current;
  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  let checkServicesIntersecting = {
    oneTouched: false,
    twoTouched: false,
    startRailTouched: false,
    maxRailTouched: false,
  };
  //center chase calculations
  // const valueToCheck = dragPositions.current.x;
  const minValue = railDimensionsRef.current?.width / 2 - 230.905; // 123.905px chase width+ 107 px for 6 inch
  const maxValue = railDimensionsRef.current?.width / 2 + 230.905;
  //--------------------------------------------------------------------------//

  //if the service width is greater than rail width
  if (
    dragServicePosition.x + dragServiceWidth / pixelPerInch >
    railDimensionsRef.current.width - railMargins.end
  ) {
    // dropLocation = false;
    // warningAlert("Sorry, you cannot place new services here.");
    dragServicePosition.x = dragServicePosition.x - 10;
  }

  for (let i = 0; i < services?.length; i++) {
    const serviceWidth = services[i].gang_width / pixelPerInch;
    if (service.u_id !== services[i].u_id) {
      //calculation for left side drag
      if (
        dragServicePosition.x >=
          services[i]?.positions?.x - dragServiceWidth / pixelPerInch &&
        dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
      ) {
        checkServicesIntersecting["oneTouched"] = true;
        const newPosition = services[i]?.positions?.x + serviceWidth;

        if (
          values.chase_position === "center" &&
          newPosition < minValue &&
          newPosition + dragServiceWidth / pixelPerInch > minValue
        ) {
          newDropLocation = {
            x:
              arrow === "ArrowRight"
                ? services[i]?.positions?.x - dragServiceWidth / pixelPerInch
                : services[i]?.positions?.x + serviceWidth,
            y: 0,
          };
          // dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          // return;
        }
        //to check the margins between last service and rail width

        // if (
        //   newPosition - dragServiceWidth <=
        //   railDimensionsRef.current.width - railMargins.end
        // ) {
        //   newDropLocation = {
        //     x: services[i]?.positions?.x - serviceWidth,
        //     y: 0,
        //   };
        //   // dropLocation = false;
        // }

        if (
          newPosition + dragServiceWidth / pixelPerInch <=
          railDimensionsRef.current.width - railMargins.end
        ) {
          newDropLocation = {
            x:
              arrow === "ArrowRight"
                ? services[i]?.positions?.x - dragServiceWidth / pixelPerInch
                : services[i]?.positions?.x + serviceWidth,
            y: 0,
          };
          // dropLocation = false;
        }

        // if (
        //   newPosition - dragServiceWidth <=
        //   railDimensionsRef.current.width - railMargins.end
        // ) {
        //   newDropLocation = {
        //     x: services[i]?.positions?.x - serviceWidth,
        //     y: 0,
        //   };
        // dropLocation = false;

        // }
        else {
          // dragServicePosition.x = dragServicePosition.x - 10;

          newDropLocation = {
            x:
              arrow === "ArrowRight"
                ? services[i]?.positions?.x - dragServiceWidth / pixelPerInch
                : services[i]?.positions?.x + serviceWidth,
            y: 0,
          };
          // dropLocation = false;
          // warningAlert("Sorry, you cannot place new services here.2");
        }
        break;
      } //calulation for right side drag
      else if (
        dragServicePosition.x + dragServiceWidth / pixelPerInch >=
          services[i]?.positions?.x &&
        dragServicePosition.x + dragServiceWidth / pixelPerInch <=
          services[i]?.positions?.x + serviceWidth
      ) {
        checkServicesIntersecting["twoTouched"] = true;
        const newPosition = dragServicePosition.x - 10;

        if (
          values.chase_position === "center" &&
          newPosition < maxValue &&
          newPosition + dragServiceWidth / pixelPerInch > maxValue
        ) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation = {
            x: newPosition,
            y: 0,
          };
          break;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
      }
    }
  }

  const checkServicesOverLap = services.some((serv) => {
    const serviceWidth = serv.gang_width / pixelPerInch;
    return (
      serv.u_id !== service.u_id &&
      (serv.positions?.x === newDropLocation.x ||
        (newDropLocation.x + dragServiceWidth / pixelPerInch >
          serv.positions?.x &&
          newDropLocation.x + dragServiceWidth / pixelPerInch <
            serv.positions?.x + serviceWidth) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions?.x &&
          newDropLocation.x + dragServiceWidth / pixelPerInch >=
            serv.positions?.x + serviceWidth))
    );
  });

  if (
    (checkServicesIntersecting.oneTouched &&
      checkServicesIntersecting.twoTouched) ||
    checkServicesOverLap
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  } else if (
    values.chase_position === "center" &&
    checkServicesIntersecting.oneTouched &&
    newDropLocation.x + dragServiceWidth / pixelPerInch > minValue &&
    newDropLocation.x < maxValue
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  } else if (
    values.chase_position === "center" &&
    checkServicesIntersecting.twoTouched &&
    newDropLocation.x < maxValue &&
    newDropLocation.x > minValue
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  } else if (
    checkServicesIntersecting.oneTouched ||
    checkServicesIntersecting.twoTouched
  )
    dragPositions.current = newDropLocation;
  //to restrict drop 6 inches both side of the center chase
  if (values.chased && values.chase_position === "center") {
    if (
      newDropLocation.x + dragServiceWidth / pixelPerInch > minValue &&
      newDropLocation.x < maxValue
    ) {
      if (newDropLocation.x < railDimensionsRef.current.width / 2) {
        const newPosition = minValue - dragServiceWidth / pixelPerInch;
        // if start value is less than the rail start point
        if (newPosition < railMargins.start) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        const checkforOtherServiceOnSamePosition = services?.some((serv) => {
          return (
            serv.positions.x === newPosition ||
            (newPosition <= serv.positions.x &&
              newPosition + dragServiceWidth / pixelPerInch >=
                serv.positions.x + serv.gang_width / pixelPerInch) ||
            (newPosition <= serv.positions.x + serv.gang_width / pixelPerInch &&
              newPosition + dragServiceWidth / pixelPerInch >=
                serv.positions.x + serv.gang_width / pixelPerInch.toFixed(1))
          );
        });
        if (checkforOtherServiceOnSamePosition) {
          // dropLocation = false;
          newDropLocation = {
            x:
              arrow === "ArrowRight"
                ? dragServicePosition.x - dragServiceWidth / pixelPerInch
                : dragServicePosition.x + dragServiceWidth / pixelPerInch,
            y: 0,
          };
          warningAlert("Sorry, you cannot place new services here.");
          // return;
        }
        dragPositions.current = { x: newPosition, y: 0 };
      } else if (newDropLocation.x > railDimensionsRef.current.width / 2) {
        const newPosition = maxValue;

        // if service start value is greater than the rail end point
        if (
          newPosition + dragServiceWidth / pixelPerInch >
            railDimensionsRef.current.width ||
          newPosition + dragServiceWidth / pixelPerInch >
            railDimensionsRef.current.width - railMargins.end
        ) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        const checkforOtherServiceOnSamePosition = services?.some((serv) => {
          const serviceWidth = serv.gang_width / pixelPerInch;
          return (
            serv.positions.x === newPosition ||
            (newPosition + dragServiceWidth / pixelPerInch >=
              serv.positions.x &&
              newPosition + dragServiceWidth / pixelPerInch <=
                serv.positions.x + serviceWidth) ||
            (newPosition < serv.positions?.x &&
              newPosition + dragServiceWidth / pixelPerInch >=
                serv.positions?.x + serviceWidth)
          );
        });

        if (checkforOtherServiceOnSamePosition) {
          newDropLocation = {
            x:
              arrow === "ArrowRight"
                ? dragServicePosition.x - dragServiceWidth / pixelPerInch
                : dragServicePosition.x + dragServiceWidth / pixelPerInch,
            y: 0,
          };
          // dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          // return;
        }
        dragPositions.current = { x: newPosition, y: 0 };
      }
    }
  }
  dragItem.service.positions = newDropLocation;

  // onUpdatePosition(newDropLocation);

  return dropLocation;
};

const checkAxiomDropLocation = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  accessory_rails
) => {
  const { dragServiceWidth, dragServiceHeight, service } = dragItem.current;
  const dragServicePosition = dragPositions.current;
  const { headwalls, model, width } = values;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const extraMarginForNormalServices = 31.3392857142; //padding or margin of row from the outer rail for normal services
  const axiomWidth = (width.ft * 12 + width.in) / pixelPerInch;
  if (service?.is_slide)
    services = services?.filter((ser) => {
      if (dragServicePosition.x > railDimensionsRef.current.width / 2)
        return (
          ser?.is_slide && ser.positions.x > railDimensionsRef.current.width / 2
        );
      else
        return (
          ser?.is_slide && ser.positions.x < railDimensionsRef.current.width / 2
        );
    });
  else services = services?.filter((ser) => !ser?.is_slide);
  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let checkServicesIntersecting = {
    leftTouched: false,
    rightTouched: false,
    topTouched: false,
    bottomTouched: false,
    startRailTouched: false,
    maxRailTouched: false,
  };

  //service margin between two services in y axis in px
  const serviceMargin = service?.is_slide ? 0 : 26.78571428571429;
  const slideServiceMargin = 5;

  //for y axis
  for (let i = 0; i < services?.length; i++) {
    let serviceHeight = services[i].height / pixelPerInch;
    if (service?.is_slide) serviceHeight = services[i].height / pixelPerInch;
    if (services[i].u_id !== service?.u_id) {
      //for vaccum bottom drag
      if (
        service?.is_slide &&
        dragServicePosition.y >= services[i]?.positions?.y &&
        dragServicePosition.y <= services[i]?.positions?.y + serviceHeight
      ) {
        checkServicesIntersecting["topTouched"] = true;
        const newPosition =
          services[i]?.positions?.y + dragServiceHeight + slideServiceMargin;
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] =
          dragServicePosition.x < railDimensionsRef.current.width / 2
            ? 0
            : railDimensionsRef.current.width;
        break;
      } else if (
        service?.is_slide &&
        dragServicePosition.y + dragServiceHeight >=
          services[i]?.positions?.y &&
        dragServicePosition.y + dragServiceHeight <=
          services[i]?.positions?.y + dragServiceHeight
      ) {
        checkServicesIntersecting["bottomTouched"] = true;
        const newPosition =
          services[i]?.positions?.y - dragServiceHeight - slideServiceMargin;
        if (newPosition < railMargins.top) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] =
          dragServicePosition.x < railDimensionsRef.current.width / 2
            ? 0
            : railDimensionsRef.current.width;
        break;
      }
      //calculation for bottom drag
      else if (
        dragServicePosition.y >= services[i]?.positions?.y &&
        dragServicePosition.y <= services[i]?.positions?.y + serviceHeight
      ) {
        checkServicesIntersecting["topTouched"] = true;
        newDropLocation["y"] = services[i]?.positions?.y;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      } else if (
        !service?.is_slide &&
        dragServicePosition.y >= services[i]?.positions?.y &&
        dragServicePosition.y <=
          services[i]?.positions?.y + serviceHeight + serviceMargin
      ) {
        checkServicesIntersecting["topTouched"] = true;
        const newPosition =
          services[i]?.positions?.y + serviceHeight + serviceMargin;
        // services[i]?.positions?.y + dragServiceHeight;
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      }

      //calulation for top drag
      else if (
        dragServicePosition.y + serviceHeight >=
          services[i]?.positions?.y + 13.38 && //13.38 because it calculation position from margin instead of the switch
        dragServicePosition.y + serviceHeight <=
          services[i]?.positions?.y + dragServiceHeight
      ) {
        checkServicesIntersecting["bottomTouched"] = true;
        newDropLocation["y"] = services[i]?.positions?.y;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      } else if (
        dragServicePosition.y + dragServiceHeight >=
          services[i]?.positions?.y && //- serviceMargin
        dragServicePosition.y + dragServiceHeight - serviceMargin <=
          services[i]?.positions?.y + dragServiceHeight
      ) {
        checkServicesIntersecting["bottomTouched"] = true;
        const newPosition = services[i]?.positions?.y - dragServiceHeight;
        if (Math.floor(newPosition) < Math.floor(railMargins.top)) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      }
    }
  }

  const checkVerticalServicesOverLap = services?.some((serv) => {
    const serviceHeight = serv.height / pixelPerInch;
    return (
      (serv.u_id !== service.u_id &&
        ((newDropLocation.y !== serv.positions?.y &&
          ((newDropLocation.y + dragServiceHeight > serv.positions?.y &&
            newDropLocation.y + dragServiceHeight <
              serv.positions?.y + serviceHeight + serviceMargin) ||
            (newDropLocation.y > serv.positions?.y &&
              Math.round(newDropLocation.y) <
                Math.round(
                  serv.positions?.y + serviceHeight + serviceMargin
                )))) ||
          (newDropLocation.y === serv.positions?.y &&
            newDropLocation.y > serv.positions?.y &&
            newDropLocation.y <
              serv.positions?.y + serviceHeight + serviceMargin) ||
          newDropLocation.y + dragServiceHeight >
            railDimensionsRef.current.parentHeight)) ||
      (service.is_slide && newDropLocation.y === serv.positions?.y)
    );
  });

  if (checkVerticalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
    return;
  }

  if (!service?.is_slide) {
    //filtering services on the same y axis
    services = services?.filter(
      (serv) => newDropLocation.y === serv?.positions?.y
    );
    //for x-axis
    for (let i = 0; i < services?.length; i++) {
      let serviceWidth;
      if (services[i].category === "Medical Gas Outlet")
        serviceWidth = (services[i].width + 2.375) / pixelPerInch;
      else serviceWidth = (services[i].width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
      if (services[i].u_id !== service.u_id) {
        //calculation for left side drag
        if (
          dragServicePosition.x >= services[i]?.positions?.x &&
          dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
        ) {
          checkServicesIntersecting["leftTouched"] = true;
          // const newPosition = services[i]?.positions?.x + serviceWidth;
          //to manage side margins in case of gas
          let newPosition = 0;
          if (service.category === "Medical Gas Outlet")
            newPosition = services[i]?.positions?.x + serviceWidth;
          else newPosition = services[i]?.positions?.x + serviceWidth;

          if (
            newPosition + dragServiceWidth <=
            railDimensionsRef.current.width - railMargins.end
          )
            newDropLocation["x"] = newPosition;
          else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here .");
          }
          break;
        } //calulation for right side drag
        else if (
          dragServicePosition.x + dragServiceWidth >=
            services[i]?.positions?.x &&
          dragServicePosition.x + dragServiceWidth <=
            services[i]?.positions?.x + dragServiceWidth
        ) {
          checkServicesIntersecting["rightTouched"] = true;
          let newPosition = 0;
          if (service.category === "Medical Gas Outlet")
            newPosition = services[i]?.positions?.x - dragServiceWidth + 2.8;
          //to manage side margins in case of gas
          else
            newPosition = services[i]?.positions?.x - dragServiceWidth - 0.42; //to manage side margins
          if (newPosition > railMargins.start)
            newDropLocation["x"] = newPosition;
          else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here .");
          }
        }
      }
    }
  }

  //updating drag position if service intersect with accessory rail
  const updateDragPosition = checkServiceIntersectingWithAccessoryRail(
    railIndex,
    rails,
    newDropLocation,
    service,
    extraMarginForNormalServices,
    accessory_rails,
    dragServiceWidth,
    dragServiceHeight,
    model,
    width
  );

  if (!updateDragPosition) {
    dropLocation = false;
    warningAlert(
      "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides."
    );
    return;
  }

  if (
    !service.is_slide &&
    (newDropLocation.x < railMargins.start ||
      newDropLocation.x + dragServiceWidth >
        axiomWidth - extraMarginForNormalServices - railMargins.end)
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place services here.");
    return;
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    let serviceWidth;
    if (serv.category === "Medical Gas Outlet")
      serviceWidth = (serv.width + 2.375) / pixelPerInch;
    else serviceWidth = (serv.width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
    if (serv.u_id === service.u_id) return false;
    if (!service.is_slide)
      return (
        serv.positions?.x === newDropLocation.x ||
        (service.category !== "Medical Gas Outlet" &&
          newDropLocation.x + dragServiceWidth > serv.positions?.x &&
          newDropLocation.x + dragServiceWidth <
            serv.positions?.x + serviceWidth) ||
        (service.category === "Medical Gas Outlet" &&
          newDropLocation.x + dragServiceWidth - 2.8 > serv.positions?.x &&
          newDropLocation.x + dragServiceWidth - 2.8 <
            serv.positions?.x + serviceWidth) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions?.x &&
          newDropLocation.x + dragServiceWidth >=
            serv.positions?.x + serviceWidth)
      );
    else if (service.is_slide) return serv.positions?.x === newDropLocation.x;
    else return false;
  });

  if (checkHorizontalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
    return;
  }

  dragPositions.current = newDropLocation;
  return dropLocation;
};

const checkAxiomDropLocation2 = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  accessory_rails,
  arrow,
  prevY
) => {
  const { dragServiceWidth, dragServiceHeight, service } = dragItem;
  const dragServicePosition = dragPositions.current;

  const { headwalls, model, width } = values;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const extraMarginForNormalServices = 31.3392857142; //padding or margin of row from the outer rail for normal services
  const axiomWidth = (width.ft * 12 + width.in) / pixelPerInch;

  if (service?.is_slide)
    services = services?.filter((ser) => {
      if (dragServicePosition.x > railDimensionsRef.current.width / 2)
        return (
          ser?.is_slide && ser.positions.x > railDimensionsRef.current.width / 2
        );
      else
        return (
          ser?.is_slide && ser.positions.x < railDimensionsRef.current.width / 2
        );
    });
  else services = services?.filter((ser) => !ser?.is_slide);
  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let checkServicesIntersecting = {
    leftTouched: false,
    rightTouched: false,
    topTouched: false,
    bottomTouched: false,
    startRailTouched: false,
    maxRailTouched: false,
  };

  //service margin between two services in y axis in px
  const serviceMargin = service?.is_slide ? 0 : 26.78571428571429;
  // const slideServiceMargin = 5;

  //for y axis
  for (let i = 0; i < services?.length; i++) {
    let serviceHeight = services[i].height / pixelPerInch;
    if (service?.is_slide) serviceHeight = services[i].height / pixelPerInch;
    if (services[i].u_id !== service?.u_id) {
      //for vaccum bottom drag
      if (
        service?.is_slide &&
        dragServicePosition.y >= services[i]?.positions?.y &&
        dragServicePosition.y <= services[i]?.positions?.y + serviceHeight
      ) {
        checkServicesIntersecting["topTouched"] = true;
        const newPosition = prevY;

        // services[i]?.positions?.y +
        // dragServiceHeight / pixelPerInch +
        // slideServiceMargin;
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] =
          dragServicePosition.x < railDimensionsRef.current.width / 2
            ? 0
            : railDimensionsRef.current.width;

        break;
      } else if (
        service?.is_slide &&
        dragServicePosition.y + dragServiceHeight / pixelPerInch >=
          services[i]?.positions?.y &&
        dragServicePosition.y + dragServiceHeight / pixelPerInch <=
          services[i]?.positions?.y + dragServiceHeight / pixelPerInch
      ) {
        checkServicesIntersecting["bottomTouched"] = true;
        const newPosition = prevY;

        // services[i]?.positions?.y -
        // dragServiceHeight / pixelPerInch -
        // slideServiceMargin;

        if (newPosition < railMargins.top) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] =
          dragServicePosition.x < railDimensionsRef.current.width / 2
            ? 0
            : railDimensionsRef.current.width;
        break;
      }
      //calculation for bottom drag
      else if (
        dragServicePosition.y >= services[i]?.positions?.y &&
        dragServicePosition.y <= services[i]?.positions?.y + serviceHeight
      ) {
        checkServicesIntersecting["topTouched"] = true;

        newDropLocation["y"] = services[i]?.positions?.y;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      } else if (
        !service?.is_slide &&
        dragServicePosition.y >= services[i]?.positions?.y &&
        dragServicePosition.y <=
          services[i]?.positions?.y + serviceHeight + serviceMargin
      ) {
        checkServicesIntersecting["topTouched"] = true;
        const newPosition =
          services[i]?.positions?.y + serviceHeight + serviceMargin;

        // services[i]?.positions?.y + serviceHeight + serviceMargin;
        // services[i]?.positions?.y + dragServiceHeight;
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      }

      //calulation for top drag
      else if (
        dragServicePosition.y + serviceHeight >=
          services[i]?.positions?.y + 13.38 && //13.38 because it calculation position from margin instead of the switch
        dragServicePosition.y + serviceHeight <=
          services[i]?.positions?.y + dragServiceHeight / pixelPerInch
      ) {
        checkServicesIntersecting["bottomTouched"] = true;
        newDropLocation["y"] = services[i]?.positions?.y;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      } else if (
        dragServicePosition.y + dragServiceHeight / pixelPerInch >=
          services[i]?.positions?.y && //- serviceMargin
        dragServicePosition.y +
          dragServiceHeight / pixelPerInch -
          serviceMargin <=
          services[i]?.positions?.y + dragServiceHeight / pixelPerInch
      ) {
        checkServicesIntersecting["bottomTouched"] = true;
        const newPosition =
          services[i]?.positions?.y - dragServiceHeight / pixelPerInch;

        //
        if (Math.floor(newPosition) < Math.floor(railMargins.top)) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        newDropLocation["y"] = newPosition;
        newDropLocation["x"] = dragServicePosition.x;
        break;
      }
    }
  }

  const checkVerticalServicesOverLap = services?.some((serv) => {
    const serviceHeight = serv.height / pixelPerInch;
    return (
      (serv.u_id !== service.u_id &&
        ((newDropLocation.y !== serv.positions?.y &&
          ((newDropLocation.y + dragServiceHeight / pixelPerInch >
            serv.positions?.y &&
            newDropLocation.y + dragServiceHeight / pixelPerInch <
              serv.positions?.y + serviceHeight + serviceMargin) ||
            (newDropLocation.y > serv.positions?.y &&
              Math.round(newDropLocation.y) <
                Math.round(
                  serv.positions?.y + serviceHeight + serviceMargin
                )))) ||
          (newDropLocation.y === serv.positions?.y &&
            newDropLocation.y > serv.positions?.y &&
            newDropLocation.y <
              serv.positions?.y + serviceHeight + serviceMargin) ||
          newDropLocation.y + dragServiceHeight / pixelPerInch >
            railDimensionsRef.current.parentHeight)) ||
      (service.is_slide && newDropLocation.y === serv.positions?.y)
    );
  });
  if (checkVerticalServicesOverLap && !service?.is_slide) {
    if (arrow === "ArrowDown") newDropLocation.y = prevY;
    // newDropLocation.y - dragServiceHeight / pixelPerInch;
    else if (arrow === "ArrowUp") newDropLocation.y = prevY;
    // newDropLocation.y + dragServiceHeight / pixelPerInch;
    // dropLocation = false;
    // warningAlert("Sorry, you cannot place new services here .989");
    // return;
  }

  if (!service?.is_slide) {
    //filtering services on the same y axis
    services = services?.filter(
      (serv) => newDropLocation.y === serv?.positions?.y
    );
    //for x-axis
    for (let i = 0; i < services?.length; i++) {
      let serviceWidth;
      let dragServiceWidthPixel;

      if (service.category === "Medical Gas Outlet") {
        dragServiceWidthPixel = (service.width + 2.375) / pixelPerInch;
      } else {
        dragServiceWidthPixel = (service.width + 0.125) / pixelPerInch;
      } //0.0625 to manage margins around the service

      if (services[i].category === "Medical Gas Outlet") {
        serviceWidth = (services[i].width + 2.375) / pixelPerInch;
      } else {
        serviceWidth = (services[i].width + 0.125) / pixelPerInch;
      }

      if (services[i].u_id !== service.u_id) {
        //calculation for left side drag
        if (
          dragServicePosition.x >= services[i]?.positions?.x &&
          dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
        ) {
          checkServicesIntersecting["leftTouched"] = true;
          // const newPosition = services[i]?.positions?.x + serviceWidth;
          //to manage side margins in case of gas

          let newPosition = 0;
          if (arrow === "ArrowDown") {
            newDropLocation.y = prevY;
            // newDropLocation.y - dragServiceHeight / pixelPerInch;

            break;
          } else if (arrow === "ArrowUp" && !service?.is_slide) {
            newDropLocation.y = prevY;
            // newDropLocation.y + dragServiceHeight / pixelPerInch;

            break;
          } else if (service.category === "Medical Gas Outlet")
            newPosition = services[i]?.positions?.x + serviceWidth;
          else newPosition = services[i]?.positions?.x + serviceWidth;
          // break;

          if (
            newPosition + dragServiceWidth / pixelPerInch <=
            railDimensionsRef.current.width - railMargins.end
          ) {
            if (arrow === "ArrowDown") newDropLocation.y = prevY;
            // newDropLocation.y - dragServiceHeight / pixelPerInch;
            else if (arrow === "ArrowUp") newDropLocation.y = prevY;
            // newDropLocation.y + dragServiceHeight / pixelPerInch;
            else newDropLocation["x"] = newPosition;
            break;
          } else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here .");
          }
          break;
        } //calulation for right side drag
        else if (
          dragServicePosition.x + dragServiceWidthPixel >=
            services[i]?.positions?.x &&
          dragServicePosition.x + dragServiceWidthPixel <=
            services[i]?.positions?.x + serviceWidth
        ) {
          checkServicesIntersecting["rightTouched"] = true;
          // let newPosition = 0;
          // if (service.category === "Medical Gas Outlet")
          //   newPosition = services[i]?.positions?.x - serviceWidth + 2.8;
          // // to manage side margins in case of gas
          // else newPosition = services[i]?.positions?.x - serviceWidth - 0.42; //to manage side margins
          // if (newPosition > railMargins.start)

          if (arrow === "ArrowDown") {
            newDropLocation.y = prevY;
            // newDropLocation.y - dragServiceHeight / pixelPerInch;
          } else if (arrow === "ArrowUp") {
            newDropLocation.y = prevY;
            // newDropLocation.y + (dragServiceHeight * 2) / pixelPerInch;
          } else newDropLocation["x"] = dragServicePosition.x - 10;
          // else {
          // dropLocation = false;
          // warningAlert("Sorry, you cannot place new services here 12.");
          // }
          break;
        }
      }
    }
  }

  //updating drag position if service intersect with accessory rail
  const updateDragPosition = checkServiceIntersectingWithAccessoryRail(
    railIndex,
    rails,
    newDropLocation,
    service,
    extraMarginForNormalServices,
    accessory_rails,
    dragServiceWidth / pixelPerInch,
    dragServiceHeight / pixelPerInch,
    model,
    width
  );

  if (!updateDragPosition) {
    dropLocation = false;
    warningAlert(
      "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides."
    );
    return;
  }

  if (
    !service.is_slide &&
    (newDropLocation.x < railMargins.start ||
      newDropLocation.x + dragServiceWidth / pixelPerInch >
        axiomWidth - extraMarginForNormalServices - railMargins.end)
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place services here.1117");
    return;
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    let serviceWidth;
    if (serv.category === "Medical Gas Outlet")
      serviceWidth = (serv.width + 2.375) / pixelPerInch;
    else serviceWidth = (serv.width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
    return (
      serv.u_id !== service.u_id &&
      !service.is_slide &&
      (serv.positions?.x === newDropLocation.x ||
        (service.category !== "Medical Gas Outlet" &&
          newDropLocation.x + dragServiceWidth / pixelPerInch >
            serv.positions?.x &&
          newDropLocation.x + dragServiceWidth / pixelPerInch <
            serv.positions?.x + serviceWidth) ||
        (service.category === "Medical Gas Outlet" &&
          newDropLocation.x +
            dragServiceWidth / pixelPerInch -
            2.8 / pixelPerInch >
            serv.positions?.x &&
          newDropLocation.x +
            dragServiceWidth / pixelPerInch -
            2.8 / pixelPerInch <
            serv.positions?.x + serviceWidth) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions?.x &&
          newDropLocation.x + dragServiceWidth / pixelPerInch >=
            serv.positions?.x + serviceWidth)) &&
      service.is_slide &&
      serv.positions?.x === newDropLocation.x
    );
  });

  if (checkHorizontalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
    return;
  }

  const checkExistingServicesOverlappedByMoved = services?.some((serv) => {
    let existingServiceWidth;
    if (serv.category === "Medical Gas Outlet")
      existingServiceWidth = (serv.width + 2.375) / pixelPerInch;
    else existingServiceWidth = (serv.width + 0.125) / pixelPerInch;

    return (
      (serv.u_id !== service.u_id &&
        !service.is_slide &&
        // Start of moved service is inside existing service
        ((newDropLocation.x >= serv.positions?.x &&
          newDropLocation.x < serv.positions?.x + existingServiceWidth) ||
          // End of moved service is inside existing service
          (newDropLocation.x + dragServiceWidth / pixelPerInch >
            serv.positions?.x &&
            newDropLocation.x + dragServiceWidth / pixelPerInch <=
              serv.positions?.x + existingServiceWidth) ||
          // Moved service completely overlaps existing service
          (newDropLocation.x <= serv.positions?.x &&
            newDropLocation.x + dragServiceWidth / pixelPerInch >=
              serv.positions?.x + existingServiceWidth))) ||
      (service.is_slide && serv.positions?.x === newDropLocation.x)
    );
  });

  if (checkExistingServicesOverlappedByMoved && !service?.is_slide) {
    // if (arrow == "ArrowDown") {
    newDropLocation.y = prevY;
    // } else if (arrow == "ArrowUp" && !service?.is_slide) {
    // newDropLocation.y = newDropLocation.y + dragServiceHeight / pixelPerInch;
    // } else dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }

  if (
    newDropLocation.x + dragServiceWidth / pixelPerInch >
    axiomWidth - railMargins.end
  ) {
    newDropLocation.x =
      axiomWidth -
      extraMarginForNormalServices -
      dragServiceWidth / pixelPerInch -
      railMargins.end;
  }
  if (
    newDropLocation.y + dragServiceHeight / pixelPerInch >
    railDimensionsRef.current.parentHeight
  ) {
    newDropLocation.y =
      railDimensionsRef.current.parentHeight - dragServiceHeight / pixelPerInch;
  }

  dragPositions.current = newDropLocation;
  dragItem.service.positions = newDropLocation;

  return dropLocation;
};

const checkCompassDropLocation = (
  rowIndex,
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  accessory_rails
) => {
  const { model, headwalls } = values;
  const { dragServiceWidth, dragServiceHeight, service } = dragItem.current;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const rowWidth = rails[railIndex]?.width;
  const dragServicePosition = dragPositions.current;
  let droppableAreaWidth;

  //update y position according to row index for normal services
  if (!service.is_slide)
    dragServicePosition.y = COMPASS_INNER_PANELS_MARGIN_FROM_TOP[rowIndex];
  // to manage x on the auto cad
  let manageXMargin = 6.78571428571; //0.38inches to
  if (
    service.name.includes("Call") ||
    service.name.includes("Staff") ||
    service.name.includes("Code Blue")
  ) {
    manageXMargin = 8.92857142857;
  }
  if (!service?.is_slide) droppableAreaWidth = (rowWidth - 5.5) / pixelPerInch;
  else droppableAreaWidth = rowWidth / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let checkServicesIntersecting = {
    leftTouched: false,
    rightTouched: false,
    topTouched: false,
    bottomTouched: false,
    startRailTouched: false,
    maxRailTouched: false,
  };
  const extraMarginForNormalServices = 49; //padding or margin of row from the outer rail for normal services
  // const extraMarginForNormalServices = 49.1071428571; //padding or margin of row from the outer rail for normal services

  if (!service?.is_slide && !rowIndex) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  } else if (!service?.is_slide) {
    const normalServices = services?.filter(
      (serv) => serv.rowPosition === rowIndex
    );
    const slideServices = services?.filter((serv) => {
      return (
        serv?.is_slide &&
        ((serv.positions.y >= dragServicePosition.y &&
          serv.positions.y <= dragServicePosition.y + dragServiceHeight) ||
          (serv.positions.y + serv.height / pixelPerInch >=
            dragServicePosition.y &&
            dragServicePosition.y >= serv.positions.y))
      );
    });
    if (normalServices?.length || slideServices?.length)
      services = [...normalServices, ...slideServices];
    else services = [];
  } else {
    services = services?.filter((serv) => {
      return (
        (serv.positions.y >= dragServicePosition.y &&
          serv.positions.y <= dragServicePosition.y + dragServiceHeight) ||
        (serv.positions.y + serv.height / pixelPerInch >=
          dragServicePosition.y &&
          dragServicePosition.y >= serv.positions.y)
      );
    });
  }

  const dropPoints = getDropPoints(rowWidth);

  if (rowIndex !== null && !service?.is_slide) {
    const nearestDropPoint = findNearestValue(dropPoints, newDropLocation.x);
    newDropLocation["x"] = nearestDropPoint - manageXMargin;
  }

  //--------------------------------------------------------------------------//
  //if the service width is greater than rail width
  if (dragServiceWidth > droppableAreaWidth) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
    return;
  }

  if (
    (dragServicePosition.y < COMPASS.SECTION_1_HEIGHT &&
      dragServicePosition.y + dragServiceHeight >= COMPASS.SECTION_1_HEIGHT) ||
    (dragServicePosition.y <
      COMPASS.SECTION_2_HEIGHT + COMPASS.SECTION_1_HEIGHT &&
      dragServicePosition.y + dragServiceHeight >=
        COMPASS.SECTION_2_HEIGHT + COMPASS.SECTION_1_HEIGHT)
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }

  for (let i = 0; i < services?.length; i++) {
    const serviceWidth = services[i].width / pixelPerInch;
    const serviceHeight = services[i].height / pixelPerInch;
    //calculation for left side drag
    //calculation for normal services
    if (
      !service?.is_slide &&
      !services[i]?.is_slide &&
      dragServicePosition.x >= services[i]?.positions?.x &&
      Math.round(dragServicePosition.x) <=
        Math.round(services[i]?.positions?.x + serviceWidth)
    ) {
      checkServicesIntersecting["leftTouched"] = true;

      const newPosition =
        services[i]?.positions?.x + manageXMargin + serviceWidth;
      let nearestDropPoint = findNearestValue(dropPoints, newPosition);
      nearestDropPoint = nearestDropPoint - manageXMargin;
      //add some extra margin for call, staff and code blue
      if (
        services[i].name.includes("Call") ||
        services[i].name.includes("Staff") ||
        services[i].name.includes("Code Blue") ||
        service.name.includes("Call") ||
        service.name.includes("Staff") ||
        service.name.includes("Code Blue")
      )
        nearestDropPoint += 16.183035714;

      //to check the margins between last service and rail width
      if (nearestDropPoint + dragServiceWidth <= droppableAreaWidth) {
        newDropLocation = {
          x: nearestDropPoint,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
      }
    } //calulation for right side drag
    else if (
      !service?.is_slide &&
      !services[i]?.is_slide &&
      dragServicePosition.x + dragServiceWidth >= services[i]?.positions?.x &&
      dragServicePosition.x + dragServiceWidth <=
        services[i]?.positions?.x + dragServiceWidth
    ) {
      checkServicesIntersecting["rightTouched"] = true;

      const newPosition = services[i]?.positions?.x - dragServiceWidth;
      let nearestDropPoint = findNearestValue(dropPoints, newPosition);
      nearestDropPoint = nearestDropPoint - manageXMargin;
      //add some extra margin for call, staff and code blue
      if (
        services[i].name.includes("Call") ||
        services[i].name.includes("Staff") ||
        services[i].name.includes("Code Blue") ||
        service.name.includes("Call") ||
        service.name.includes("Staff") ||
        service.name.includes("Code Blue")
      )
        nearestDropPoint -= 16.183035714;
      //to check the margins between first service and rail width
      if (nearestDropPoint >= railMargins.start) {
        newDropLocation = {
          x: nearestDropPoint,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
      }
    }
    //calculation for slide services if dragged service is slide and service[i] is also slide
    else if (
      service?.is_slide &&
      services[i]?.is_slide &&
      dragServicePosition.x >= services[i]?.positions?.x &&
      dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
    ) {
      checkServicesIntersecting["leftTouched"] = true;
      let newPosition;

      if (
        dragServicePosition.y >= services[i]?.positions?.y + serviceHeight ||
        dragServicePosition.y + dragServiceHeight <= services[i]?.positions?.y
      )
        newPosition = services[i]?.positions?.x;
      else newPosition = services[i]?.positions?.x + serviceWidth;
      //to check the margins between last service and rail width
      if (newPosition + dragServiceWidth <= droppableAreaWidth) {
        newDropLocation = {
          x: newPosition,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
      }
    } //calulation for right side drag
    else if (
      service.is_slide &&
      services[i]?.is_slide &&
      dragServicePosition.x + dragServiceWidth >= services[i]?.positions?.x &&
      dragServicePosition.x + dragServiceWidth <=
        services[i]?.positions?.x + dragServiceWidth
    ) {
      checkServicesIntersecting["rightTouched"] = true;

      let newPosition;
      if (
        dragServicePosition.y > services[i]?.positions?.y + serviceHeight ||
        dragServicePosition.y + dragServiceHeight <= services[i]?.positions?.y
      )
        newPosition = services[i]?.positions?.x;
      else newPosition = services[i]?.positions?.x - serviceWidth;

      //to check the margins between first service and rail width
      if (newPosition >= railMargins.start) {
        newDropLocation = {
          x: newPosition,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
      }
    }
    //calculation for slide services if dragged service is slide and service[i] is normal service
    else if (
      service?.is_slide &&
      !services[i]?.is_slide &&
      dragServicePosition.x >=
        services[i]?.positions?.x + extraMarginForNormalServices &&
      dragServicePosition.x <=
        services[i]?.positions?.x + extraMarginForNormalServices + serviceWidth
    ) {
      let newPosition;

      checkServicesIntersecting["leftTouched"] = true;
      if (
        dragServicePosition.y >= services[i]?.positions?.y + serviceHeight ||
        dragServicePosition.y + dragServiceHeight <= services[i]?.positions?.y
      )
        newPosition = services[i]?.positions?.x;
      else
        newPosition =
          services[i]?.positions?.x +
          extraMarginForNormalServices +
          serviceWidth;
      //to check the margins between last service and rail width
      if (newPosition + dragServiceWidth <= droppableAreaWidth) {
        newDropLocation = {
          x: newPosition,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
      }
    } //calulation for right side drag
    else if (
      service.is_slide &&
      !services[i]?.is_slide &&
      dragServicePosition.x + dragServiceWidth >=
        services[i]?.positions?.x + extraMarginForNormalServices &&
      dragServicePosition.x + dragServiceWidth <=
        services[i]?.positions?.x +
          extraMarginForNormalServices +
          dragServiceWidth
    ) {
      checkServicesIntersecting["rightTouched"] = true;

      let newPosition;
      if (
        dragServicePosition.y > services[i]?.positions?.y + serviceHeight ||
        dragServicePosition.y + dragServiceHeight <= services[i]?.positions?.y
      )
        newPosition = services[i]?.positions?.x;
      else {
        let extraSpace = 0.59285714285;
        if (
          services[i].name.includes("Call") ||
          services[i].name.includes("Staff") ||
          services[i].name.includes("Code Blue")
        )
          extraSpace = 2.41071428571;
        newPosition =
          services[i]?.positions?.x +
          extraMarginForNormalServices -
          dragServiceWidth -
          extraSpace; //to manage extra space on left side for vaccum service
      }
      //to check the margins between first service and rail width
      if (newPosition >= railMargins.start) {
        newDropLocation = {
          x: newPosition,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
      }
    }
    //calculation for slide services if dragged service is normal and service[i] is slide service
    else if (
      !service?.is_slide &&
      services[i]?.is_slide &&
      dragServicePosition.x + extraMarginForNormalServices >=
        services[i]?.positions?.x &&
      dragServicePosition.x + extraMarginForNormalServices <=
        services[i]?.positions?.x + serviceWidth
    ) {
      checkServicesIntersecting["leftTouched"] = true;

      const newPosition =
        services[i]?.positions?.x -
        extraMarginForNormalServices +
        serviceWidth +
        manageXMargin;
      let nearestDropPoint = findNearestValue(dropPoints, newPosition);
      nearestDropPoint = nearestDropPoint - manageXMargin;
      //add some extra margin for call, staff and code blue
      // if (
      //   services[i].name.includes("Call") ||
      //   services[i].name.includes("Staff") ||
      //   services[i].name.includes("Code Blue") ||
      //   service.name.includes("Call") ||
      //   service.name.includes("Staff") ||
      //   service.name.includes("Code Blue")
      // )
      nearestDropPoint += 16.183035714;
      //to check the margins between last service and rail width
      if (nearestDropPoint + dragServiceWidth <= droppableAreaWidth) {
        newDropLocation = {
          x: nearestDropPoint,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here .");
      }
    } //calulation for right side drag
    else if (
      !service?.is_slide &&
      services[i]?.is_slide &&
      dragServicePosition.x + dragServiceWidth + extraMarginForNormalServices >=
        services[i]?.positions?.x &&
      dragServicePosition.x + dragServiceWidth + extraMarginForNormalServices <=
        services[i]?.positions?.x + dragServiceWidth
    ) {
      checkServicesIntersecting["rightTouched"] = true;

      if (services[i].positions.y + serviceHeight > dragServicePosition.y) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
        return;
      }
      const newPosition = services[i]?.positions?.x - dragServiceWidth;
      let nearestDropPoint = findNearestValue(dropPoints, newPosition);
      //add some extra margin for call, staff and code blue
      // if (
      //   services[i].name.includes("Call") ||
      //   services[i].name.includes("Staff") ||
      //   services[i].name.includes("Code Blue") ||
      //   service.name.includes("Call") ||
      //   service.name.includes("Staff") ||
      //   service.name.includes("Code Blue")
      // )
      nearestDropPoint -= 16.183035714;
      //to check the margins between first service and rail width
      if (nearestDropPoint >= railMargins.start) {
        newDropLocation = {
          x: nearestDropPoint,
          y: dragServicePosition.y,
        };
      } else {
        dropLocation = false;
        warningAlert("Sorry, you cannot place new services here.");
      }
    }
  }
  //updating drag position if service intersect with accessory rail
  const updateDragPosition = checkServiceIntersectingWithAccessoryRail(
    railIndex,
    rails,
    newDropLocation,
    service,
    extraMarginForNormalServices,
    accessory_rails,
    dragServiceWidth,
    dragServiceHeight,
    model
  );

  if (!updateDragPosition) {
    dropLocation = false;
    warningAlert(
      "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides."
    );
    return;
  }
  if (
    dragServicePosition.x > droppableAreaWidth ||
    dragServicePosition.x + dragServiceWidth > droppableAreaWidth
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place services here. 1657");
    return;
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    const serviceWidth = serv.width / pixelPerInch;
    if (
      (!serv?.is_slide && !service?.is_slide) ||
      (serv?.is_slide && service?.is_slide)
    ) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x === newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth > serv.positions?.x &&
            newDropLocation.x + dragServiceWidth <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x > serv.positions.x &&
            newDropLocation.x < serv.positions.x + serviceWidth) ||
          (newDropLocation.x < serv.positions.x &&
            newDropLocation.x + dragServiceWidth >
              serv.positions?.x + serviceWidth))
      );
    } else if (!serv?.is_slide && service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x + extraMarginForNormalServices ===
          newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth >
            serv.positions?.x + extraMarginForNormalServices &&
            newDropLocation.x + dragServiceWidth <
              serv.positions?.x +
                serviceWidth +
                extraMarginForNormalServices) ||
          (newDropLocation.x >
            serv.positions.x + extraMarginForNormalServices &&
            newDropLocation.x <
              serv.positions.x + serviceWidth + extraMarginForNormalServices))
      );
    } else if (serv?.is_slide && !service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x ===
          newDropLocation.x + extraMarginForNormalServices ||
          (newDropLocation.x + dragServiceWidth + extraMarginForNormalServices >
            serv.positions?.x &&
            newDropLocation.x +
              dragServiceWidth +
              extraMarginForNormalServices <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x + extraMarginForNormalServices >
            serv.positions.x &&
            newDropLocation.x + extraMarginForNormalServices <
              serv.positions.x + serviceWidth - manageXMargin))
      );
    } else return false;
  });

  if (checkHorizontalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }
  dragPositions.current = newDropLocation;

  return dropLocation;
};

function moveToClosestDropPoint(
  direction,
  rowWidth,
  dragServicePosition,
  manageXMargin,
  dropPoints
) {
  // let dropPoints = getDropPoints(rowWidth);
  const currentX = dragServicePosition.x + manageXMargin;
  dropPoints = dropPoints.sort((a, b) => a - b);

  // Find the closest index
  let closestIndex = dropPoints.findIndex((point, idx) => {
    const nextPoint = dropPoints[idx + 1];

    return (
      currentX >= point && (nextPoint === undefined || currentX < nextPoint)
    );
  });

  // Handle edge cases
  if (closestIndex === -1) {
    closestIndex = 0; // fallback
  }

  // Adjust index based on direction
  if (direction === "ArrowLeft" && closestIndex > 0) {
    closestIndex--;
  } else if (
    direction === "ArrowRight" &&
    closestIndex < dropPoints.length - 1
  ) {
    closestIndex++;
  }

  // Move to new drop point
  const newX = dropPoints[closestIndex] - manageXMargin;

  // Apply the new position (example way to update)
  dragServicePosition.x = newX;
  return newX;
}
function moveToClosestDropPointConsole(
  direction,
  rowWidth,
  dragServicePosition,
  manageXMargin,
  dropPoints
) {
  // let dropPoints = getDropPoints(rowWidth);
  const currentX = dragServicePosition.x + manageXMargin;
  dropPoints = dropPoints.sort((a, b) => a - b);

  // Find the closest index
  let closestIndex = dropPoints.findIndex((point, idx) => {
    const nextPoint = dropPoints[idx + 1];

    return (
      currentX >= point && (nextPoint === undefined || currentX < nextPoint)
    );
  });

  // Handle edge cases
  if (closestIndex === -1) {
    closestIndex = 0; // fallback
  }

  // Adjust index based on direction
  if (direction === "ArrowLeft" && closestIndex > 0) {
    // closestIndex--;
  } else if (
    direction === "ArrowRight" &&
    closestIndex < dropPoints.length - 1
  ) {
    closestIndex++;
  }

  // Move to new drop point
  const newX = dropPoints[closestIndex] - manageXMargin;

  // Apply the new position (example way to update)
  dragServicePosition.x = newX;
  return newX;
}

const checkCompassDropLocation2 = (
  rowIndex,
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  accessory_rails,
  arrow
) => {
  const { model, headwalls } = values;
  const { dragServiceWidth, dragServiceHeight, service } = dragItem;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const rowWidth = rails[railIndex]?.width;
  const dragServicePosition = dragPositions.current;
  let droppableAreaWidth;

  //update y position according to row index for normal services
  if (!service.is_slide)
    dragServicePosition.y = COMPASS_INNER_PANELS_MARGIN_FROM_TOP[rowIndex];
  // to manage x on the auto cad
  let manageXMargin = 6.78571428571; //0.38inches to
  if (
    service.name.includes("Call") ||
    service.name.includes("Staff") ||
    service.name.includes("Code Blue")
  ) {
    manageXMargin = 8.92857142857;
  }
  if (!service?.is_slide) droppableAreaWidth = (rowWidth - 5.5) / pixelPerInch;
  else droppableAreaWidth = rowWidth / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  const extraMarginForNormalServices = 49; //padding or margin of row from the outer rail for normal services
  // const extraMarginForNormalServices = 49.1071428571; //padding or margin of row from the outer rail for normal services

  if (!service?.is_slide && !rowIndex) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
  } else if (!service?.is_slide) {
    const normalServices = services?.filter(
      (serv) => serv.rowPosition === rowIndex
    );
    const slideServices = services?.filter((serv) => {
      return (
        serv?.is_slide &&
        ((serv.positions.y >= dragServicePosition.y &&
          serv.positions.y <=
            dragServicePosition.y + dragServiceHeight / pixelPerInch) ||
          (serv.positions.y + serv.height / pixelPerInch >=
            dragServicePosition.y &&
            dragServicePosition.y >= serv.positions.y))
      );
    });
    if (normalServices?.length || slideServices?.length)
      services = [...normalServices, ...slideServices];
    else services = [];
  } else {
    services = services?.filter((serv) => {
      return (
        (serv.positions.y >= dragServicePosition.y &&
          serv.positions.y <=
            dragServicePosition.y + dragServiceHeight / pixelPerInch) ||
        (serv.positions.y + serv.height / pixelPerInch >=
          dragServicePosition.y &&
          dragServicePosition.y >= serv.positions.y)
      );
    });
  }

  let dropPoints = getDropPoints(rowWidth);

  if (rowIndex !== null && !service?.is_slide) {
    const nearestDropPoint = findNearestValue(dropPoints, newDropLocation.x);
    newDropLocation["x"] = nearestDropPoint - manageXMargin;
  }

  newDropLocation.x = moveToClosestDropPoint(
    arrow,
    rowWidth,
    dragServicePosition,
    manageXMargin,
    dropPoints
  );

  if (
    (dragServicePosition.y < COMPASS.SECTION_1_HEIGHT &&
      dragServicePosition.y + dragServiceHeight / pixelPerInch >=
        COMPASS.SECTION_1_HEIGHT) ||
    (dragServicePosition.y <
      COMPASS.SECTION_2_HEIGHT + COMPASS.SECTION_1_HEIGHT &&
      dragServicePosition.y + dragServiceHeight / pixelPerInch >=
        COMPASS.SECTION_2_HEIGHT + COMPASS.SECTION_1_HEIGHT)
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here .");
  }

  const updateDragPosition = checkServiceIntersectingWithAccessoryRail(
    railIndex,
    rails,
    newDropLocation,
    service,
    extraMarginForNormalServices,
    accessory_rails,
    dragServiceWidth / pixelPerInch,
    dragServiceHeight / pixelPerInch,
    model
  );

  if (!updateDragPosition) {
    dropLocation = false;
    warningAlert(
      "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides."
    );
    return;
  }
  if (
    dragServicePosition.x + dragServiceWidth / pixelPerInch >
    droppableAreaWidth
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place services here.");
    return;
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    const serviceWidth = serv.width / pixelPerInch;
    if (
      (!serv?.is_slide && !service?.is_slide) ||
      (serv?.is_slide && service?.is_slide)
    ) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x === newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth / pixelPerInch >
            serv.positions?.x &&
            newDropLocation.x + dragServiceWidth / pixelPerInch <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x > serv.positions.x &&
            newDropLocation.x < serv.positions.x + serviceWidth) ||
          (newDropLocation.x < serv.positions.x &&
            newDropLocation.x + dragServiceWidth / pixelPerInch >
              serv.positions?.x + serviceWidth))
      );
    } else if (!serv?.is_slide && service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x + extraMarginForNormalServices ===
          newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth / pixelPerInch >
            serv.positions?.x + extraMarginForNormalServices &&
            newDropLocation.x + dragServiceWidth / pixelPerInch <
              serv.positions?.x +
                serviceWidth +
                extraMarginForNormalServices) ||
          (newDropLocation.x >
            serv.positions.x + extraMarginForNormalServices &&
            newDropLocation.x <
              serv.positions.x + serviceWidth + extraMarginForNormalServices))
      );
    } else if (serv?.is_slide && !service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x ===
          newDropLocation.x + extraMarginForNormalServices ||
          (newDropLocation.x +
            dragServiceWidth / pixelPerInch +
            extraMarginForNormalServices >
            serv.positions?.x &&
            newDropLocation.x +
              dragServiceWidth / pixelPerInch +
              extraMarginForNormalServices <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x + extraMarginForNormalServices >
            serv.positions.x &&
            newDropLocation.x + extraMarginForNormalServices <
              serv.positions.x + serviceWidth - manageXMargin))
      );
    } else return false;
  });

  if (checkHorizontalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  } else {
    dragPositions.current = newDropLocation;
    dragItem.service.positions = newDropLocation;
  }
  return dropLocation;
};

const checkArrayDropLocation = (
  rowIndex,
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef,
  accessory_rails
) => {
  const { ceiling_height, model } = values;
  const { dragServiceWidth, dragServiceHeight, service } = dragItem.current;
  const rails = [...values.headwalls];
  const servicesArr = rails[railIndex]?.services;
  const rowWidth = rails[railIndex]?.width;
  const dragServicePosition = dragPositions.current;
  let droppableAreaWidth;
  if (!service?.is_slide)
    droppableAreaWidth = (rowWidth * 12 - 3.25) / pixelPerInch;

  //service margin between two services in y axis in px
  const serviceMargin = 13.3928571429;

  const railHeight = ceiling_height.ft * 12 + ceiling_height.in - 6;
  const section1 = (railHeight - 60) / pixelPerInch;
  const section2 = (railHeight - 30) / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let checkServicesIntersecting = {
    leftTouched: false,
    rightTouched: false,
    topTouched: false,
    bottomTouched: false,
    startRailTouched: false,
    maxRailTouched: false,
  };

  if (!rowIndex && !railIndex) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
    return;
  }

  if (
    service?.is_slide &&
    ((dragServicePosition.y < section1 &&
      dragServicePosition.y + dragServiceHeight >= section1) ||
      (dragServicePosition.y < section2 &&
        dragServicePosition.y + dragServiceHeight >= section2))
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  } else if (
    (!service?.is_slide && !rowIndex) ||
    (!dragServicePosition.y && !dragServicePosition.x)
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }

  //find the rowIndex on the basis of the drag position of slide service
  if (service?.is_slide) {
    if (dragServicePosition.y < section1) {
      rowIndex = 1;
    } else if (
      dragServicePosition.y < section2 &&
      dragServicePosition.y > section1
    ) {
      rowIndex = 2;
    } else if (
      dragServicePosition.y > section2 &&
      dragServicePosition.y < railHeight / pixelPerInch
    ) {
      rowIndex = 3;
    }
  }

  //to manage the y axis while user dragging normal services

  let manageServiceY = 0;
  if (rowIndex === 1) manageServiceY = 2.875 / pixelPerInch;
  else if (rowIndex === 2) {
    const ceilingHeight = ceiling_height.ft * 12 + ceiling_height.in;
    manageServiceY = (ceilingHeight - 64) / pixelPerInch;
  } else if (rowIndex === 3) {
    const ceilingHeight = ceiling_height.ft * 12 + ceiling_height.in;
    manageServiceY = (ceilingHeight - 34) / pixelPerInch;
  }

  let services = servicesArr?.filter(
    (ser) => !ser.is_slide && ser.rowPosition === rowIndex
  );

  if (!services.length) newDropLocation["y"] = dragServicePosition.y;

  const extraMarginForNormalServices = 31.25; //padding or margin of row from the outer rail for normal services
  if (!service?.is_slide) {
    //for y axis
    for (let i = 0; i < services?.length; i++) {
      const serviceHeight = services[i].height / pixelPerInch;
      if (services[i].u_id !== service.u_id) {
        //calculation for bottom drag
        if (
          !services[i].is_slide &&
          !service?.is_slide &&
          dragServicePosition.y >= services[i]?.positions?.y &&
          dragServicePosition.y <= services[i]?.positions?.y + serviceHeight
        ) {
          // console.log("workingy1");
          checkServicesIntersecting["topTouched"] = true;
          newDropLocation["y"] = services[i]?.positions?.y;
          newDropLocation["x"] = dragServicePosition.x;
          break;
        } else if (
          !services[i].is_slide &&
          !service?.is_slide &&
          dragServicePosition.y >= services[i]?.positions?.y &&
          dragServicePosition.y <=
            services[i]?.positions?.y + serviceHeight + serviceMargin
        ) {
          // console.log("workingy2");
          checkServicesIntersecting["topTouched"] = true;
          const newPosition =
            services[i]?.positions?.y + serviceHeight + serviceMargin;
          newDropLocation["y"] = newPosition;
          newDropLocation["x"] = dragServicePosition.x;
          break;
        }
        //calulation for top drag
        else if (
          !services[i].is_slide &&
          !service?.is_slide &&
          dragServicePosition.y + dragServiceHeight >=
            services[i]?.positions?.y + serviceMargin &&
          dragServicePosition.y + dragServiceHeight <=
            services[i]?.positions?.y + serviceHeight
        ) {
          // console.log("workingy3");
          checkServicesIntersecting["bottomTouched"] = true;
          newDropLocation["y"] = services[i]?.positions?.y;
          newDropLocation["x"] = dragServicePosition.x;
          break;
        } else if (
          !services[i].is_slide &&
          !service?.is_slide &&
          dragServicePosition.y + dragServiceHeight >=
            services[i]?.positions?.y - serviceMargin &&
          dragServicePosition.y + dragServiceHeight - serviceMargin <=
            services[i]?.positions?.y + dragServiceHeight
        ) {
          // console.log("workingy4");
          checkServicesIntersecting["bottomTouched"] = true;
          const newPosition =
            services[i]?.positions?.y - dragServiceHeight - serviceMargin;
          if (Math.floor(newPosition) < Math.floor(railMargins.top)) {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here.");
            return;
          }
          newDropLocation["y"] = newPosition;
          newDropLocation["x"] = dragServicePosition.x;
          break;
        }
      }
    }

    const checkVerticalServicesOverLap = services.some((serv) => {
      const serviceHeight = serv.height / pixelPerInch;
      return (
        serv.u_id !== service.u_id &&
        ((newDropLocation.y !== serv.positions?.y &&
          newDropLocation.y + dragServiceHeight > serv.positions?.y &&
          newDropLocation.y + dragServiceHeight <
            serv.positions?.y + serviceHeight + serviceMargin) ||
          (newDropLocation.y > serv.positions?.y &&
            newDropLocation.y <
              serv.positions?.y + serviceHeight + serviceMargin) ||
          (newDropLocation.y === serv.positions?.y &&
            newDropLocation.y > serv.positions?.y &&
            newDropLocation.y <
              serv.positions?.y + serviceHeight + serviceMargin))
      );
    });
    // console.log({ checkVerticalServicesOverLap });
    if (checkVerticalServicesOverLap) {
      dropLocation = false;
      warningAlert("Sorry, you cannot place new services here .");
      return;
    }
  }
  // if service dropped away from other services
  if (!newDropLocation.y) newDropLocation["y"] = dragServicePosition.y;

  //filter normal services while dragging simple service
  if (!service?.is_slide)
    services = services.filter((ser) => ser.positions.y === newDropLocation.y);
  //filtering normal services while dragging slide service
  else
    services = services.filter((ser) => {
      const servHeight = ser.height / pixelPerInch;
      return (
        (ser.positions.y + manageServiceY <= newDropLocation.y &&
          ser.positions.y + servHeight + manageServiceY >= newDropLocation.y) || //for top
        (ser.positions.y + manageServiceY <=
          newDropLocation.y + dragServiceHeight &&
          ser.positions.y + manageServiceY >= newDropLocation.y)
      );
    });
  // console.log({services})
  //filtering slide services based on the position of service
  let slideServices = [];
  if (!service?.is_slide)
    slideServices = servicesArr.filter((ser) => {
      const servHeight = ser.height / pixelPerInch;
      return (
        ser?.is_slide &&
        ((ser.positions.y <= newDropLocation.y + manageServiceY &&
          ser.positions.y + servHeight >= newDropLocation.y + manageServiceY) || //for top
          (ser.positions.y <=
            newDropLocation.y + dragServiceHeight + manageServiceY &&
            ser.positions.y >= newDropLocation.y + manageServiceY))
      );
    });
  else {
    slideServices = servicesArr.filter((ser) => {
      const servHeight = ser.height / pixelPerInch;
      return (
        ser?.is_slide &&
        ((ser.positions.y <= newDropLocation.y &&
          ser.positions.y + servHeight >= newDropLocation.y) || //for top
          (ser.positions.y <= newDropLocation.y + dragServiceHeight &&
            ser.positions.y >= newDropLocation.y))
      );
    });
  }

  services = [...services, ...slideServices];

  //for x-axis
  for (let i = 0; i < services?.length; i++) {
    const serviceWidth = services[i].width / pixelPerInch;
    const serviceHeight = services[i].height / pixelPerInch;
    //calculation for left side drag
    //calculation for normal services
    if (services[i].u_id !== service.u_id) {
      if (
        !service?.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x >= services[i]?.positions?.x &&
        dragServicePosition.x <=
          services[i]?.positions?.x + serviceWidth + railMargins.between
      ) {
        checkServicesIntersecting["leftTouched"] = true;

        const newPosition =
          services[i]?.positions?.x + serviceWidth + railMargins.between;
        //to check the margins between last service and rail width
        if (newPosition + dragServiceWidth <= droppableAreaWidth)
          newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        !service?.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x + dragServiceWidth >=
          services[i]?.positions?.x - railMargins.between - serviceWidth &&
        dragServicePosition.x + dragServiceWidth <=
          services[i]?.positions?.x + serviceWidth
      ) {
        // console.log("2")
        checkServicesIntersecting["rightTouched"] = true;
        const newPosition =
          services[i]?.positions?.x - dragServiceWidth - railMargins.between;
        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start)
          newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }
      //calculation for slide services if dragged service is slide and service[i] is also slide
      else if (
        service?.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x >= services[i]?.positions?.x &&
        dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
      ) {
        // console.log("3")
        checkServicesIntersecting["leftTouched"] = true;
        let newPosition;
        if (
          dragServicePosition.y >= services[i]?.positions?.y + serviceHeight ||
          dragServicePosition.y + dragServiceHeight <= services[i]?.positions?.y
        )
          newPosition = services[i]?.positions?.x;
        else newPosition = services[i]?.positions?.x + serviceWidth;
        //to check the margins between last service and rail width
        if (newPosition + dragServiceWidth <= railDimensionsRef.current.width) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        service.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x + dragServiceWidth >= services[i]?.positions?.x &&
        dragServicePosition.x + dragServiceWidth <=
          services[i]?.positions?.x + dragServiceWidth
      ) {
        // console.log("4")
        checkServicesIntersecting["rightTouched"] = true;
        let newPosition;
        if (
          dragServicePosition.y > services[i]?.positions?.y + serviceHeight ||
          dragServicePosition.y + dragServiceHeight <= services[i]?.positions?.y
        )
          newPosition = services[i]?.positions?.x;
        else newPosition = services[i]?.positions?.x - serviceWidth;

        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }
      //calculation for slide services if dragged service is slide and service[i] is normal service
      else if (
        service?.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x >=
          services[i]?.positions?.x + extraMarginForNormalServices &&
        dragServicePosition.x <=
          services[i]?.positions?.x +
            extraMarginForNormalServices +
            serviceWidth
      ) {
        // console.log("5")
        let newPosition;
        checkServicesIntersecting["leftTouched"] = true;
        if (
          dragServicePosition.y >=
            services[i]?.positions?.y + serviceHeight + manageServiceY ||
          dragServicePosition.y + dragServiceHeight <=
            services[i]?.positions?.y + manageServiceY
        )
          newPosition = services[i]?.positions?.x;
        else
          newPosition =
            services[i]?.positions?.x +
            extraMarginForNormalServices +
            serviceWidth;
        //to check the margins between last service and rail width
        if (newPosition + dragServiceWidth <= railDimensionsRef.current.width) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        service.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x + dragServiceWidth >=
          services[i]?.positions?.x + extraMarginForNormalServices &&
        dragServicePosition.x + dragServiceWidth <=
          services[i]?.positions?.x +
            extraMarginForNormalServices +
            dragServiceWidth
      ) {
        // console.log("6")
        checkServicesIntersecting["rightTouched"] = true;
        let newPosition;
        if (
          dragServicePosition.y > services[i]?.positions?.y + serviceHeight ||
          dragServicePosition.y + dragServiceHeight <= services[i]?.positions?.y
        )
          newPosition = services[i]?.positions?.x;
        else
          newPosition =
            services[i]?.positions?.x +
            extraMarginForNormalServices -
            dragServiceWidth;

        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }

      //calculation for slide services if dragged service is normal and service[i] is slide service
      else if (
        !service?.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x + extraMarginForNormalServices >=
          services[i]?.positions?.x &&
        dragServicePosition.x + extraMarginForNormalServices <=
          services[i]?.positions?.x + serviceWidth
      ) {
        // console.log("7")
        checkServicesIntersecting["leftTouched"] = true;
        const newPosition =
          services[i]?.positions?.x -
          extraMarginForNormalServices +
          serviceWidth;
        //to manage the normal service width with the slide service
        let newArr = JSON.parse(JSON.stringify(services));
        newArr[i].positions.x =
          services[i]?.positions?.x - extraMarginForNormalServices;
        //to check the margins between last service and rail width
        if (newPosition + dragServiceWidth <= droppableAreaWidth) {
          newDropLocation["x"] = newPosition;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        !service?.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x +
          dragServiceWidth +
          extraMarginForNormalServices >=
          services[i]?.positions?.x &&
        dragServicePosition.x +
          dragServiceWidth +
          extraMarginForNormalServices <=
          services[i]?.positions?.x + dragServiceWidth
      ) {
        // console.log("8")
        checkServicesIntersecting["rightTouched"] = true;
        const newPosition =
          services[i]?.positions?.x -
          extraMarginForNormalServices -
          dragServiceWidth;
        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation["x"] = newPosition;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }
    }
  }

  //updating drag position if service intersect with accessory rail
  const updateDragPosition = checkServiceIntersectingWithAccessoryRail(
    railIndex,
    rails,
    newDropLocation,
    service,
    extraMarginForNormalServices,
    accessory_rails,
    dragServiceWidth,
    dragServiceHeight,
    model,
    manageServiceY
  );

  if (!updateDragPosition) {
    dropLocation = false;
    warningAlert(
      "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides."
    );
    return;
  }

  if (
    newDropLocation.x + dragServiceWidth > droppableAreaWidth ||
    newDropLocation.x < 0
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
    return;
  }

  const checkHorizontalServicesOverLap = services.some((serv) => {
    const serviceWidth = serv.width / pixelPerInch;
    if (
      (!serv?.is_slide && !service?.is_slide) ||
      (serv?.is_slide && service?.is_slide)
    ) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x === newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth > serv.positions?.x &&
            newDropLocation.x + dragServiceWidth <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x > serv.positions.x &&
            newDropLocation.x < serv.positions.x + serviceWidth) ||
          (newDropLocation.x < serv.positions.x &&
            newDropLocation.x + dragServiceWidth >
              serv.positions?.x + serviceWidth))
      );
    } else if (!serv?.is_slide && service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x + extraMarginForNormalServices ===
          newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth >
            serv.positions?.x + extraMarginForNormalServices &&
            newDropLocation.x + dragServiceWidth <
              serv.positions?.x +
                serviceWidth +
                extraMarginForNormalServices) ||
          (newDropLocation.x >
            serv.positions.x + extraMarginForNormalServices &&
            newDropLocation.x <
              serv.positions.x + serviceWidth + extraMarginForNormalServices))
      );
    } else if (serv?.is_slide && !service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x ===
          newDropLocation.x + extraMarginForNormalServices ||
          (newDropLocation.x + dragServiceWidth + extraMarginForNormalServices >
            serv.positions?.x &&
            newDropLocation.x +
              dragServiceWidth +
              extraMarginForNormalServices <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x + extraMarginForNormalServices >
            serv.positions.x &&
            newDropLocation.x + extraMarginForNormalServices <
              serv.positions.x + serviceWidth) ||
          //service overlapping over slide service
          (newDropLocation.x + extraMarginForNormalServices <
            serv.positions.x &&
            newDropLocation.x +
              extraMarginForNormalServices +
              dragServiceWidth >
              serv.positions.x + serviceWidth))
      );
    } else return false;
  });
  if (checkHorizontalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
    return;
  }
  if (
    (checkServicesIntersecting.leftTouched &&
      checkServicesIntersecting.rightTouched) ||
    (checkServicesIntersecting.topTouched &&
      checkServicesIntersecting.bottomTouched)
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }
  // else if (
  //   checkServicesIntersecting.leftTouched ||
  //   checkServicesIntersecting.rightTouched ||
  //   checkServicesIntersecting.topTouched ||
  //   checkServicesIntersecting.bottomTouched
  // )
  dragPositions.current = newDropLocation;
  return dropLocation;
};

const checkArrayDropLocation2 = (
  rowIndex,
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef,
  accessory_rails,
  arrow,
  prevY
) => {
  const { ceiling_height, model } = values;
  const { dragServiceWidth, dragServiceHeight, service } = dragItem;
  const rails = [...values.headwalls];
  const servicesArr = rails[railIndex]?.services;
  const rowWidth = rails[railIndex]?.width;
  const dragServicePosition = dragPositions.current;
  let droppableAreaWidth;
  if (!service?.is_slide)
    droppableAreaWidth = (rowWidth * 12 - 3.25) / pixelPerInch;

  //service margin between two services in y axis in px
  const serviceMargin = 13.3928571429;

  const railHeight = ceiling_height.ft * 12 + ceiling_height.in - 6;
  const section1 = (railHeight - 60) / pixelPerInch;
  const section2 = (railHeight - 30) / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let checkServicesIntersecting = {
    leftTouched: false,
    rightTouched: false,
    topTouched: false,
    bottomTouched: false,
    startRailTouched: false,
    maxRailTouched: false,
  };

  if (!service?.is_slide && !rowIndex && !railIndex) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
    return;
  }

  if (
    service?.is_slide &&
    ((dragServicePosition.y < section1 - 20 &&
      dragServicePosition.y + dragServiceHeight / pixelPerInch >=
        section1 - 20) ||
      (dragServicePosition.y < section2 &&
        dragServicePosition.y + dragServiceHeight / pixelPerInch >=
          section2 - 20) ||
      dragServicePosition.y + dragServiceHeight / pixelPerInch >
        railHeight / pixelPerInch - 10)
  ) {
    if (arrow === "ArrowDown") {
      dragServicePosition.y = prevY;
      newDropLocation.y = prevY;
      // dragServicePosition.y - dragServiceHeight / pixelPerInch;
    } else if (arrow === "ArrowUp") {
      dragServicePosition.y = prevY;
      newDropLocation.y = prevY;
    }
    // dragServicePosition.y + dragServiceHeight / pixelPerInch;
    // dragServicePosition.y = dragServicePosition.y + dragServiceHeight/ pixelPerInch;
    else dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  } else if (
    (!service?.is_slide && !rowIndex) ||
    (!dragServicePosition.y && !dragServicePosition.x)
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }

  //find the rowIndex on the basis of the drag position of slide service
  if (service?.is_slide) {
    if (dragServicePosition.y < section1) {
      rowIndex = 1;
    } else if (
      dragServicePosition.y < section2 &&
      dragServicePosition.y > section1
    ) {
      rowIndex = 2;
    } else if (
      dragServicePosition.y > section2 &&
      dragServicePosition.y < railHeight / pixelPerInch
    ) {
      rowIndex = 3;
    }
  }

  //to manage the y axis while user dragging normal services

  let manageServiceY = 0;
  if (rowIndex === 1) manageServiceY = 2.875 / pixelPerInch;
  else if (rowIndex === 2) {
    const ceilingHeight = ceiling_height.ft * 12 + ceiling_height.in;
    manageServiceY = (ceilingHeight - 64) / pixelPerInch;
  } else if (rowIndex === 3) {
    const ceilingHeight = ceiling_height.ft * 12 + ceiling_height.in;
    manageServiceY = (ceilingHeight - 34) / pixelPerInch;
  }

  let services = servicesArr?.filter(
    (ser) => !ser.is_slide && ser.rowPosition === rowIndex
  );

  if (!services.length) newDropLocation["y"] = dragServicePosition.y;

  const extraMarginForNormalServices = 31.25; //padding or margin of row from the outer rail for normal services
  if (!service?.is_slide) {
    for (let i = 0; i < services?.length; i++) {
      const serviceHeight = services[i].height / pixelPerInch;
      if (services[i].u_id !== service.u_id) {
        // if (arrow === "ArrowUp") {
        if (
          (!services[i].is_slide &&
            !service?.is_slide &&
            newDropLocation.y < services[i].positions.y + serviceHeight &&
            newDropLocation.y > services[i].positions.y) ||
          (services[i].positions.y > newDropLocation.y &&
            services[i].positions.y <
              newDropLocation.y + dragServiceHeight / pixelPerInch)
        ) {
          newDropLocation.y = services[i].positions.y;
          if (Math.floor(newDropLocation.y) < Math.floor(railMargins.top)) {
            // dropLocation = false;
            newDropLocation.y = prevY;
            newDropLocation["x"] = dragServicePosition.x;
            warningAlert("Sorry, you cannot place new services here.");
            // return;
          }
          if (
            (!services[i].is_slide &&
              !service?.is_slide &&
              newDropLocation.y + dragServiceHeight / pixelPerInch >
                services[i].positions.y &&
              newDropLocation.y + dragServiceHeight / pixelPerInch <
                services[i].positions.y + serviceMargin + serviceHeight) ||
            (services[i].positions.y > newDropLocation.y &&
              services[i].positions.y <
                newDropLocation.y + dragServiceHeight / pixelPerInch)
          ) {
            newDropLocation.y = services[i].positions.y;
            if (Math.floor(newDropLocation.y) >= 360) {
              // dropLocation = false;
              newDropLocation.y = prevY;
              newDropLocation["x"] = dragServicePosition.x;
              warningAlert("Sorry, you cannot place new services here.");
              // return;
            }
          }
        }
      }
    }
  }
  // if service dropped away from other services
  if (!newDropLocation.y) newDropLocation["y"] = dragServicePosition.y;

  //filter normal services while dragging simple service
  if (!service?.is_slide)
    services = services.filter((ser) => ser.positions.y === newDropLocation.y);
  //filtering normal services while dragging slide service
  else
    services = services.filter((ser) => {
      const servHeight = ser.height / pixelPerInch;
      return (
        (ser.positions.y + manageServiceY <= newDropLocation.y &&
          ser.positions.y + servHeight + manageServiceY >= newDropLocation.y) || //for top
        (ser.positions.y + manageServiceY <=
          newDropLocation.y + dragServiceHeight / pixelPerInch &&
          ser.positions.y + manageServiceY >= newDropLocation.y)
      );
    });
  // console.log({services})
  //filtering slide services based on the position of service
  let slideServices = [];
  if (!service?.is_slide)
    slideServices = servicesArr.filter((ser) => {
      const servHeight = ser.height / pixelPerInch;
      return (
        ser?.is_slide &&
        ((ser.positions.y <= newDropLocation.y + manageServiceY &&
          ser.positions.y + servHeight >= newDropLocation.y + manageServiceY) || //for top
          (ser.positions.y <=
            newDropLocation.y +
              dragServiceHeight / pixelPerInch +
              manageServiceY &&
            ser.positions.y >= newDropLocation.y + manageServiceY))
      );
    });
  else {
    slideServices = servicesArr.filter((ser) => {
      const servHeight = ser.height / pixelPerInch;
      return (
        ser?.is_slide &&
        ((ser.positions.y <= newDropLocation.y &&
          ser.positions.y + servHeight >= newDropLocation.y) || //for top
          (ser.positions.y <=
            newDropLocation.y + dragServiceHeight / pixelPerInch &&
            ser.positions.y >= newDropLocation.y))
      );
    });
  }

  services = [...services, ...slideServices];

  //for x-axis
  for (let i = 0; i < services?.length; i++) {
    const serviceWidth = services[i].width / pixelPerInch;
    const serviceHeight = services[i].height / pixelPerInch;
    //calculation for left side drag
    //calculation for normal services
    if (services[i].u_id !== service.u_id) {
      if (
        !service?.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x >= services[i]?.positions?.x &&
        dragServicePosition.x <=
          services[i]?.positions?.x + serviceWidth + railMargins.between
      ) {
        checkServicesIntersecting["leftTouched"] = true;

        const newPosition =
          services[i]?.positions?.x + serviceWidth + railMargins.between;
        //to check the margins between last service and rail width
        if (newPosition + dragServiceWidth <= droppableAreaWidth)
          newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        !service?.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x >=
          services[i]?.positions?.x -
            railMargins.between -
            dragServiceWidth / pixelPerInch &&
        dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
      ) {
        checkServicesIntersecting["rightTouched"] = true;
        const newPosition =
          services[i]?.positions?.x -
          dragServiceWidth / pixelPerInch -
          railMargins.between;
        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start)
          newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }
      //calculation for slide services if dragged service is slide and service[i] is also slide
      else if (
        service?.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x >= services[i]?.positions?.x &&
        dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
      ) {
        checkServicesIntersecting["leftTouched"] = true;
        let newPosition;
        if (
          dragServicePosition.y >= services[i]?.positions?.y + serviceHeight ||
          dragServicePosition.y + dragServiceHeight / pixelPerInch <=
            services[i]?.positions?.y
        )
          newPosition = services[i]?.positions?.x;
        else newPosition = services[i]?.positions?.x + serviceWidth;
        //to check the margins between last service and rail width
        if (
          newPosition + dragServiceWidth / pixelPerInch <=
          railDimensionsRef.current.width
        ) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        service.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x + dragServiceWidth / pixelPerInch >=
          services[i]?.positions?.x &&
        dragServicePosition.x + dragServiceWidth / pixelPerInch <=
          services[i]?.positions?.x + dragServiceWidth / pixelPerInch
      ) {
        checkServicesIntersecting["rightTouched"] = true;
        let newPosition;
        if (
          dragServicePosition.y > services[i]?.positions?.y + serviceHeight ||
          dragServicePosition.y + dragServiceHeight / pixelPerInch <=
            services[i]?.positions?.y
        )
          newPosition = services[i]?.positions?.x;
        else newPosition = services[i]?.positions?.x - serviceWidth;

        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }
      //calculation for slide services if dragged service is slide and service[i] is normal service
      else if (
        service?.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x >=
          services[i]?.positions?.x + extraMarginForNormalServices &&
        dragServicePosition.x <=
          services[i]?.positions?.x +
            extraMarginForNormalServices +
            serviceWidth
      ) {
        let newPosition;
        checkServicesIntersecting["leftTouched"] = true;
        if (
          dragServicePosition.y >=
            services[i]?.positions?.y + serviceHeight + manageServiceY ||
          dragServicePosition.y + dragServiceHeight / pixelPerInch <=
            services[i]?.positions?.y + manageServiceY
        )
          newPosition = services[i]?.positions?.x;
        else
          newPosition =
            services[i]?.positions?.x +
            extraMarginForNormalServices +
            serviceWidth;
        //to check the margins between last service and rail width
        if (
          newPosition + dragServiceWidth / pixelPerInch <=
          railDimensionsRef.current.width
        ) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        service.is_slide &&
        !services[i]?.is_slide &&
        dragServicePosition.x + dragServiceWidth / pixelPerInch >=
          services[i]?.positions?.x + extraMarginForNormalServices &&
        dragServicePosition.x + dragServiceWidth / pixelPerInch <=
          services[i]?.positions?.x +
            extraMarginForNormalServices +
            dragServiceWidth / pixelPerInch
      ) {
        checkServicesIntersecting["rightTouched"] = true;
        let newPosition;
        if (
          dragServicePosition.y > services[i]?.positions?.y + serviceHeight ||
          dragServicePosition.y + dragServiceHeight / pixelPerInch <=
            services[i]?.positions?.y
        )
          newPosition = services[i]?.positions?.x;
        else
          newPosition =
            services[i]?.positions?.x +
            extraMarginForNormalServices -
            dragServiceWidth / pixelPerInch;

        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation = {
            x: newPosition,
            y: dragServicePosition.y,
          };
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }

      //calculation for slide services if dragged service is normal and service[i] is slide service
      else if (
        !service?.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x + extraMarginForNormalServices >=
          services[i]?.positions?.x &&
        dragServicePosition.x + extraMarginForNormalServices <=
          services[i]?.positions?.x + serviceWidth
      ) {
        checkServicesIntersecting["leftTouched"] = true;
        const newPosition =
          services[i]?.positions?.x -
          extraMarginForNormalServices +
          serviceWidth;
        //to manage the normal service width with the slide service
        let newArr = JSON.parse(JSON.stringify(services));
        newArr[i].positions.x =
          services[i]?.positions?.x - extraMarginForNormalServices;
        //to check the margins between last service and rail width
        if (
          newPosition + dragServiceWidth / pixelPerInch <=
          droppableAreaWidth
        ) {
          newDropLocation["x"] = newPosition;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        !service?.is_slide &&
        services[i]?.is_slide &&
        dragServicePosition.x +
          dragServiceWidth / pixelPerInch +
          extraMarginForNormalServices >=
          services[i]?.positions?.x &&
        dragServicePosition.x +
          dragServiceWidth / pixelPerInch +
          extraMarginForNormalServices <=
          services[i]?.positions?.x + dragServiceWidth / pixelPerInch
      ) {
        checkServicesIntersecting["rightTouched"] = true;
        const newPosition =
          services[i]?.positions?.x -
          extraMarginForNormalServices -
          dragServiceWidth / pixelPerInch;
        //to check the margins between first service and rail width
        if (newPosition >= railMargins.start) {
          newDropLocation["x"] = newPosition;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }
    }
  }

  //updating drag position if service intersect with accessory rail
  const updateDragPosition = checkServiceIntersectingWithAccessoryRail(
    railIndex,
    rails,
    newDropLocation,
    service,
    extraMarginForNormalServices,
    accessory_rails,
    dragServiceWidth / pixelPerInch,
    dragServiceHeight / pixelPerInch,
    model,
    manageServiceY
  );

  if (!updateDragPosition) {
    dropLocation = false;
    warningAlert(
      "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides."
    );
    return;
  }

  if (
    newDropLocation.x + dragServiceWidth / pixelPerInch > droppableAreaWidth ||
    newDropLocation.x < 0
  ) {
    // dropLocation = false;
    newDropLocation.y = prevY;
    newDropLocation.x = dragServicePosition.x;
    warningAlert("Sorry, you cannot place new services here.");
    // return;
  }

  const checkHorizontalServicesOverLap = services.some((serv) => {
    const serviceWidth = serv.width / pixelPerInch;
    if (
      (!serv?.is_slide && !service?.is_slide) ||
      (serv?.is_slide && service?.is_slide)
    ) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x === newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth / pixelPerInch >
            serv.positions?.x &&
            newDropLocation.x + dragServiceWidth / pixelPerInch <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x > serv.positions.x &&
            newDropLocation.x < serv.positions.x + serviceWidth) ||
          (newDropLocation.x < serv.positions.x &&
            newDropLocation.x + dragServiceWidth / pixelPerInch >
              serv.positions?.x + serviceWidth))
      );
    } else if (!serv?.is_slide && service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x + extraMarginForNormalServices ===
          newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth / pixelPerInch >
            serv.positions?.x + extraMarginForNormalServices &&
            newDropLocation.x + dragServiceWidth / pixelPerInch <
              serv.positions?.x +
                serviceWidth +
                extraMarginForNormalServices) ||
          (newDropLocation.x >
            serv.positions.x + extraMarginForNormalServices &&
            newDropLocation.x <
              serv.positions.x + serviceWidth + extraMarginForNormalServices))
      );
    } else if (serv?.is_slide && !service?.is_slide) {
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x ===
          newDropLocation.x + extraMarginForNormalServices ||
          (newDropLocation.x +
            dragServiceWidth / pixelPerInch +
            extraMarginForNormalServices >
            serv.positions?.x &&
            newDropLocation.x +
              dragServiceWidth / pixelPerInch +
              extraMarginForNormalServices <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x + extraMarginForNormalServices >
            serv.positions.x &&
            newDropLocation.x + extraMarginForNormalServices <
              serv.positions.x + serviceWidth) ||
          //service overlapping over slide service
          (newDropLocation.x + extraMarginForNormalServices <
            serv.positions.x &&
            newDropLocation.x +
              extraMarginForNormalServices +
              dragServiceWidth / pixelPerInch >
              serv.positions.x + serviceWidth))
      );
    } else return false;
  });
  // console.log({ checkHorizontalServicesOverLap });
  if (checkHorizontalServicesOverLap) {
    warningAlert("Sorry, you cannot place new services here.");

    if (arrow === "ArrowDown") {
      newDropLocation.y = prevY;
      newDropLocation.x = dragServicePosition.x;
    }
    //  newDropLocation.y - dragServiceHeight / pixelPerInch;
    else if (arrow === "ArrowUp") {
      newDropLocation.y = prevY;
      newDropLocation.x = dragServicePosition.x;
    }
    //  newDropLocation.y + dragServiceHeight / pixelPerInch;
    else {
      dropLocation = false;
      return;
    }
  }

  if (
    (checkServicesIntersecting.leftTouched &&
      checkServicesIntersecting.rightTouched) ||
    (checkServicesIntersecting.topTouched &&
      checkServicesIntersecting.bottomTouched)
  ) {
    warningAlert("Sorry, you cannot place new services here.");

    if (arrow === "ArrowDown") newDropLocation.y = prevY;
    //  newDropLocation.y - dragServiceHeight / pixelPerInch;
    else if (arrow === "ArrowUp") newDropLocation.y = prevY;
    //  newDropLocation.y + dragServiceHeight / pixelPerInch;
    else {
      dropLocation = false;
      return;
    }
  }
  // else if (
  //   checkServicesIntersecting.leftTouched ||
  //   checkServicesIntersecting.rightTouched ||
  //   checkServicesIntersecting.topTouched ||
  //   checkServicesIntersecting.bottomTouched
  // )

  dragPositions.current = newDropLocation;
  dragItem.service.positions = newDropLocation;

  return dropLocation;
};

const checkConsoleDropLocation = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef
) => {
  const { headwalls, width, sub_model } = values;
  const { service } = dragItem.current;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  if (service?.is_slide && service.name === "Rail Mounted")
    services = services?.filter(
      (ser) => ser?.is_slide && ser.name === "Rail Mounted"
    );
  else services = services?.filter((ser) => ser.name !== "Rail Mounted");
  const consoleWidth = (width.ft * 12 + width.in) / pixelPerInch;
  const dragServicePosition = dragPositions.current;
  const dragServiceWidth = service.width / pixelPerInch;
  const startingPoint = 58.0357142857; //3.25 inches margin from panel starting

  // to manage x on the auto cad
  const panelMargin = 35.7142857143; // 2 inch margin from sides of the panel
  const halfWidth = dragServiceWidth / 2;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  if (service.name === "Track Mounted") {
    dropLocation = false;
    warningAlert("Sorry, you cannot place services here.");
    return;
  }
  if (service.is_slide && service.name === "Rail Mounted") {
    for (let i = 0; i < services?.length; i++) {
      const serviceWidth = services[i].gang_width / pixelPerInch;
      if (service.u_id !== services[i].u_id) {
        //calculation for left side drag
        if (
          dragServicePosition.x >= services[i]?.positions?.x &&
          dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
        ) {
          const newPosition = services[i]?.positions?.x + serviceWidth;
          //to check the margins between last service and rail width
          if (
            newPosition + dragServiceWidth <=
            railDimensionsRef.current.width - railMargins.end
          ) {
            newDropLocation = {
              x: services[i]?.positions?.x + serviceWidth,
              y: 0,
            };
          } else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here.");
          }
          break;
        } //calulation for right side drag
        else if (
          dragServicePosition.x + dragServiceWidth >=
            services[i]?.positions?.x &&
          dragServicePosition.x + dragServiceWidth <=
            services[i]?.positions?.x + dragServiceWidth
        ) {
          const newPosition = services[i]?.positions?.x - dragServiceWidth;
          //to check the margins between first service and rail width
          if (newPosition >= railMargins.start) {
            newDropLocation = {
              x: newPosition,
              y: 0,
            };
            break;
          } else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here.");
          }
        }
      }
    }

    const checkServicesOverLap = services?.some((serv) => {
      const serviceWidth = serv.gang_width / pixelPerInch;
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x === newDropLocation.x ||
          (newDropLocation.x + dragServiceWidth > serv.positions?.x &&
            newDropLocation.x + dragServiceWidth <
              serv.positions?.x + serviceWidth) ||
          (newDropLocation.x > serv.positions.x &&
            newDropLocation.x < serv.positions.x + serviceWidth) ||
          (newDropLocation.x < serv.positions?.x &&
            newDropLocation.x + dragServiceWidth >=
              serv.positions?.x + serviceWidth))
      );
    });

    if (checkServicesOverLap) {
      dropLocation = false;
      warningAlert("Sorry, you cannot place new services here.");
    }
  } else {
    const dropPoints = getConsoleDropPoints(consoleWidth, startingPoint);

    const validDropPoints = dropPoints.filter((point) => {
      const serviceLeft = point - halfWidth;
      const serviceRight = point + halfWidth;
      return (
        serviceLeft >= panelMargin && serviceRight <= consoleWidth - panelMargin
      );
    });

    if (services?.length) {
      const serviceLeft = newDropLocation.x;
      const serviceRight = newDropLocation.x + dragServiceWidth;
      // Check overlapping on this any other service
      const isOverlapping = services.some((existingService) => {
        const existingLeft = existingService.positions.x;
        const existingRight =
          existingLeft + existingService.width / pixelPerInch;
        if (service.u_id !== existingService.u_id)
          return !(
            serviceRight <= existingLeft || serviceLeft >= existingRight
          );
        else return null;
      });

      if (!isOverlapping) {
        const nearestDropPoint = findFirstDropPointInRange(
          validDropPoints,
          newDropLocation.x,
          dragServiceWidth
        );
        if (!nearestDropPoint) {
          dropLocation = false;
          warningAlert("Sorry, you cannot place services here.");
          return;
        } else newDropLocation["x"] = nearestDropPoint - halfWidth;
      }
    } else {
      const nearestDropPoint = findFirstDropPointInRange(
        validDropPoints,
        newDropLocation.x,
        dragServiceWidth
      );
      if (!nearestDropPoint) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place services here.");
        return;
      } else newDropLocation["x"] = nearestDropPoint - halfWidth;
    }

    for (let i = 0; i < services?.length; i++) {
      const serviceWidth = services[i].width / pixelPerInch;
      if (service.u_id !== services[i].u_id) {
        //calculation for right side drag
        if (
          newDropLocation.x >= services[i]?.positions?.x &&
          newDropLocation.x <= services[i]?.positions?.x + serviceWidth
        ) {
          // console.log("1")
          const nearestDropPoint = findAvailableDropPoint(
            validDropPoints,
            halfWidth, // width of service you want to place
            services[i], // all existing services
            service,
            "right",
            sub_model
          );
          if (nearestDropPoint) {
            newDropLocation.x = nearestDropPoint - halfWidth;
          } else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here.");
            return;
          }

          break;
        } //calulation for left side drag
        else if (
          newDropLocation.x + dragServiceWidth >= services[i]?.positions?.x &&
          newDropLocation.x + dragServiceWidth <=
            services[i]?.positions?.x + dragServiceWidth
        ) {
          const nearestDropPoint = findAvailableDropPoint(
            dropPoints,
            halfWidth, // width of service you want to place
            services[i], // all existing services
            service,
            "left",
            sub_model
          );

          if (nearestDropPoint) {
            newDropLocation.x = nearestDropPoint - halfWidth;
          } else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here.");
            return;
          }
          break;
        }
      }
    }

    const checkHorizontalServicesOverLap = services?.some((serv) => {
      const serviceWidth = serv.width / pixelPerInch;
      const serviceMargin =
        serv.category === "Medical Gas Outlet" ||
        service.category === "Medical Gas Outlet"
          ? 44.6428571429
          : 0;
      return (
        serv.u_id !== service.u_id &&
        (serv.positions?.x === newDropLocation.x ||
          (Math.round(newDropLocation.x + dragServiceWidth) >
            Math.round(serv.positions?.x - serviceMargin) &&
            newDropLocation.x + dragServiceWidth <
              serv.positions?.x + serviceWidth + serviceMargin) ||
          (newDropLocation.x > serv.positions.x &&
            newDropLocation.x < serv.positions.x + serviceWidth) ||
          (newDropLocation.x < serv.positions.x - serviceMargin &&
            newDropLocation.x + dragServiceWidth >
              serv.positions?.x + serviceWidth + serviceMargin))
      );
    });

    if (checkHorizontalServicesOverLap) {
      dropLocation = false;
      warningAlert("Sorry, you cannot place new services here.");
    }
  }
  dragPositions.current = newDropLocation;

  return dropLocation;
};

const checkConsoleDropLocation2 = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef,
  arrow, // "left" or "right"
  prevX
) => {
  const { headwalls, width } = values;
  const { service } = dragItem;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services || [];

  // Filter services (Rail Mounted vs normal)
  if (service?.is_slide && service.name === "Rail Mounted")
    services = services.filter(
      (ser) => ser?.is_slide && ser.name === "Rail Mounted"
    );
  else services = services.filter((ser) => ser.name !== "Rail Mounted");

  const consoleWidth = (width.ft * 12 + width.in) / pixelPerInch;
  const dragServiceWidth = service.width / pixelPerInch;
  const halfWidth = dragServiceWidth / 2;
  dragItem.service.positions.x = dragItem.service.positions.x + halfWidth;
  const dragServicePosition = dragItem.service.positions;
  // prevX = dragItem.service.positions.x
  const startingPoint = 58.0357142857; //3.25 inches margin from panel starting
  // to manage x on the auto cad
  const panelMargin = 35.7142857143; // 2 inch margin from sides of the panel
  // const halfWidth = dragServiceWidth / 2;

  let manageXMargin = 0; //0.38inches to

  //  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let dropLocation = true;

  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  const dropPoints = getConsoleDropPoints(consoleWidth, startingPoint);
  // dragServicePosition.x = 100.4464285714
  const validDropPoints = dropPoints.filter((point) => {
    const serviceLeft = point - halfWidth;
    const serviceRight = point + halfWidth;
    return (
      serviceLeft >= panelMargin && serviceRight <= consoleWidth - panelMargin
    );
  });
  // console.log("validDropPoints 3612", validDropPoints);

  // if (!service?.is_slide) {
  newDropLocation.x = moveToClosestDropPointConsole(
    arrow,
    consoleWidth,
    dragServicePosition,
    manageXMargin,
    validDropPoints
  );
  //  service.positions.x = newDropLocation.x
  // console.log("3621",prevX);
  const nearestDropPoint = findNearestValue(validDropPoints, newDropLocation.x);
  newDropLocation["x"] = nearestDropPoint - halfWidth;

  if (newDropLocation.x + dragServiceWidth > consoleWidth) {
    // dropLocation = false
    newDropLocation.x = prevX;
    warningAlert("Sorry, you cannot place services here.");
    // return
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    const serviceWidth = serv.width / pixelPerInch;
    const serviceMargin =
      serv.category === "Medical Gas Outlet" ||
      service.category === "Medical Gas Outlet"
        ? 44.6428571429
        : 0;
    return (
      serv.u_id !== service.u_id &&
      (serv.positions?.x === newDropLocation.x ||
        (Math.round(newDropLocation.x + dragServiceWidth) >
          Math.round(serv.positions?.x - serviceMargin) &&
          newDropLocation.x + dragServiceWidth <
            serv.positions?.x + serviceWidth + serviceMargin) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions.x - serviceMargin &&
          newDropLocation.x + dragServiceWidth >
            serv.positions?.x + serviceWidth + serviceMargin))
    );
  });

  if (checkHorizontalServicesOverLap) {
    // dropLocation = false;
    newDropLocation.x = prevX;

    warningAlert("Sorry, you cannot place new services here.");
  }
  // newDropLocation["x"] = nearestDropPoint;
  // }

  dragServicePosition.x = newDropLocation.x;
  dragPositions.current = newDropLocation;
  dragItem.service.positions = newDropLocation;

  return dropLocation;
};

const checkSecurityConsoleDropLocation = (
  railIndex,
  dragItem,
  values,
  dragPositions
) => {
  const { headwalls, width, sub_model } = values;
  const { service } = dragItem.current;
  const rails = [...headwalls];
  const services = rails[railIndex]?.services;

  //total border area around the panel from both sides
  const borderAreaMapObj = {
    surface_mounted: 7.125,
    enclosure: 6.25,
    recessed: 4.3756,
    insight: 5.375,
  };

  // first point from the starting of the panel edge by subtracting border areas
  const startingPointObj = {
    surface_mounted: 20.0892857143, //1.125
    enclosure: 27.9017857143, //1.5625
    recessed: 29.3809523809, //1.64533333333
    insight: 20.0892857143, //1.125
  };

  const consoleWidth =
    (width.ft * 12 + width.in - borderAreaMapObj[sub_model]) / pixelPerInch;
  // console.log({consoleWidth})
  const dragServicePosition = dragPositions.current;
  const dragServiceWidth = service.width / pixelPerInch;

  const startingPoint = startingPointObj[sub_model];
  // const panelMargin =panelMarginObj[sub_model]
  const panelMargin = 0;
  const halfWidth = dragServiceWidth / 2;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  const dropPoints = getConsoleDropPoints(consoleWidth, startingPoint);
  // console.log({ dropPoints });
  const validDropPoints = dropPoints.filter((point) => {
    const serviceLeft = point - halfWidth;
    const serviceRight = point + halfWidth;
    return (
      serviceLeft >= panelMargin && serviceRight <= consoleWidth - panelMargin
    );
  });
  if (services?.length) {
    const serviceLeft = newDropLocation.x;
    const serviceRight = newDropLocation.x + dragServiceWidth;
    // Check overlapping on this any other service
    const isOverlapping = services.some((existingService) => {
      const existingLeft = existingService.positions.x;
      const existingRight = existingLeft + existingService.width / pixelPerInch;
      if (service.u_id !== existingService.u_id)
        return !(serviceRight <= existingLeft || serviceLeft >= existingRight);
      else return null;
    });

    if (!isOverlapping) {
      const nearestDropPoint = findFirstDropPointInRange(
        validDropPoints,
        newDropLocation.x,
        dragServiceWidth
      );
      if (!nearestDropPoint) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place services here.");
        return;
      } else newDropLocation["x"] = nearestDropPoint - halfWidth;
    }
  } else {
    const nearestDropPoint = findFirstDropPointInRange(
      validDropPoints,
      newDropLocation.x,
      dragServiceWidth
    );
    if (!nearestDropPoint) {
      dropLocation = false;
      warningAlert("Sorry, you cannot place services here.");
      return;
    } else newDropLocation["x"] = nearestDropPoint - halfWidth;
  }

  for (let i = 0; i < services?.length; i++) {
    const serviceWidth = services[i].width / pixelPerInch;
    if (service.u_id !== services[i].u_id) {
      //calculation for right side drag
      if (
        newDropLocation.x >= services[i]?.positions?.x &&
        newDropLocation.x <= services[i]?.positions?.x + serviceWidth
      ) {
        // console.log("1")
        const nearestDropPoint = findAvailableDropPoint(
          validDropPoints,
          halfWidth, // width of service you want to place
          services[i], // all existing services
          service,
          "right",
          sub_model
        );
        if (nearestDropPoint) {
          newDropLocation.x = nearestDropPoint - halfWidth;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }

        break;
      } //calulation for left side drag
      else if (
        newDropLocation.x + dragServiceWidth >= services[i]?.positions?.x &&
        newDropLocation.x + dragServiceWidth <=
          services[i]?.positions?.x + dragServiceWidth
      ) {
        const nearestDropPoint = findAvailableDropPoint(
          validDropPoints,
          halfWidth, // width of service you want to place
          services[i], // all existing services
          service,
          "left",
          sub_model
        );
        if (nearestDropPoint) {
          newDropLocation.x = nearestDropPoint - halfWidth;
        } else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
          return;
        }
        break;
      }
    }
  }
  const checkHorizontalServicesOverLap = services?.some((serv) => {
    const serviceWidth = serv.width / pixelPerInch;
    const serviceMargin =
      serv.category === "Medical Gas Outlet" ||
      service.category === "Medical Gas Outlet"
        ? 44.6428571429
        : 0;
    return (
      serv.u_id !== service.u_id &&
      (serv.positions?.x === newDropLocation.x ||
        (Math.round(newDropLocation.x + dragServiceWidth) >
          Math.round(serv.positions?.x - serviceMargin) &&
          newDropLocation.x + dragServiceWidth <
            serv.positions?.x + serviceWidth + serviceMargin) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions.x - serviceMargin &&
          newDropLocation.x + dragServiceWidth >
            serv.positions?.x + serviceWidth + serviceMargin))
    );
  });
  if (checkHorizontalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }
  dragPositions.current = newDropLocation;
  return dropLocation;
};

const checkSecurityConsoleDropLocation2 = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef,
  arrow, // "left" or "right"
  prevX
) => {
  const { headwalls, width, sub_model } = values;
  const { service } = dragItem;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services || [];
  //total border area around the panel from both sides
  const borderAreaMapObj = {
    surface_mounted: 7.125,
    enclosure: 6.25,
    recessed: 4.3756,
    insight: 5.375,
  };
  // first point from the starting of the panel edge by subtracting border areas
  const startingPointObj = {
    surface_mounted: 20.0892857143, //1.125
    enclosure: 27.9017857143, //1.5625
    recessed: 29.3809523809, //1.64533333333
    insight: 20.0892857143, //1.125
  };

  // Filter services (Rail Mounted vs normal)
  if (service?.is_slide && service.name === "Rail Mounted")
    services = services.filter(
      (ser) => ser?.is_slide && ser.name === "Rail Mounted"
    );
  else services = services.filter((ser) => ser.name !== "Rail Mounted");

  const consoleWidth =
    (width.ft * 12 + width.in - borderAreaMapObj[sub_model]) / pixelPerInch;

  const dragServiceWidth = service.width / pixelPerInch;
  const halfWidth = dragServiceWidth / 2;
  dragItem.service.positions.x = dragItem.service.positions.x + halfWidth;
  const dragServicePosition = dragItem.service.positions;
  // prevX = dragItem.service.positions.x
  const startingPoint = startingPointObj[sub_model];
  // to manage x on the auto cad
  const panelMargin = 0;
  let manageXMargin = 0; //0.38inches to
  // dragServicePosition.x = prevX

  //  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  let dropLocation = true;

  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  const dropPoints = getConsoleDropPoints(consoleWidth, startingPoint);
  // dragServicePosition.x = 100.4464285714
  const validDropPoints = dropPoints.filter((point) => {
    const serviceLeft = point - halfWidth;
    const serviceRight = point + halfWidth;
    return (
      serviceLeft >= panelMargin && serviceRight <= consoleWidth - panelMargin
    );
  });
  // console.log("validDropPoints 3612", validDropPoints);

  // if (!service?.is_slide) {
  newDropLocation.x = moveToClosestDropPointConsole(
    arrow,
    consoleWidth,
    dragServicePosition,
    manageXMargin,
    validDropPoints
  );
  //  service.positions.x = newDropLocation.x
  // console.log("3621",prevX);
  const nearestDropPoint = findNearestValue(validDropPoints, newDropLocation.x);
  newDropLocation["x"] = nearestDropPoint - halfWidth;

  if (newDropLocation.x + dragServiceWidth > consoleWidth) {
    // dropLocation = false
    newDropLocation.x = prevX;
    warningAlert("Sorry, you cannot place services here.");
    // return
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    const serviceWidth = serv.width / pixelPerInch;
    const serviceMargin =
      serv.category === "Medical Gas Outlet" ||
      service.category === "Medical Gas Outlet"
        ? 44.6428571429
        : 0;
    return (
      serv.u_id !== service.u_id &&
      (serv.positions?.x === newDropLocation.x ||
        (Math.round(newDropLocation.x + dragServiceWidth) >
          Math.round(serv.positions?.x - serviceMargin) &&
          newDropLocation.x + dragServiceWidth <
            serv.positions?.x + serviceWidth + serviceMargin) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions.x - serviceMargin &&
          newDropLocation.x + dragServiceWidth >
            serv.positions?.x + serviceWidth + serviceMargin))
    );
  });

  if (checkHorizontalServicesOverLap) {
    // dropLocation = false;
    newDropLocation.x = prevX;

    warningAlert("Sorry, you cannot place new services here.");
  }
  // newDropLocation["x"] = nearestDropPoint;
  // }

  dragServicePosition.x = newDropLocation.x;
  dragPositions.current = newDropLocation;
  dragItem.service.positions = newDropLocation;

  return dropLocation;
};

const checkHiddenHeadwallDropLocation = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef
) => {
  const { headwalls } = values;
  const { service } = dragItem.current;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const dragServicePosition = dragPositions.current;
  const extraMarginForMedicalServices = 2.375;
  const dragServiceWidth =
    service.category === "Medical Gas Outlet"
      ? (service.width + extraMarginForMedicalServices) / pixelPerInch
      : service.width / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  //for x-axis
  for (let i = 0; i < services?.length; i++) {
    let serviceWidth;
    if (services[i].category === "Medical Gas Outlet")
      serviceWidth =
        (services[i].width + extraMarginForMedicalServices) / pixelPerInch;
    else serviceWidth = (services[i].width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
    if (services[i].u_id !== service.u_id) {
      //calculation for left side drag
      if (
        dragServicePosition.x >= services[i]?.positions?.x &&
        dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
      ) {
        //to manage side margins in case of gas

        const newPosition = services[i]?.positions?.x + serviceWidth;
        if (
          newPosition + serviceWidth <=
          railDimensionsRef.current.width - railMargins.end
        )
          newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        dragServicePosition.x + dragServiceWidth >= services[i]?.positions?.x &&
        dragServicePosition.x + dragServiceWidth <=
          services[i]?.positions?.x + dragServiceWidth
      ) {
        let newPosition = 0;
        newPosition = services[i]?.positions?.x - dragServiceWidth;
        if (newPosition > railMargins.start) newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here .");
        }
        break;
      }
    }
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    let serviceWidth;
    if (serv.category === "Medical Gas Outlet")
      serviceWidth =
        (serv.width + extraMarginForMedicalServices) / pixelPerInch;
    else serviceWidth = (serv.width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
    if (serv.u_id === service.u_id) return false;
    // if (!service.is_slide)
    return (
      serv.positions?.x === newDropLocation.x ||
      (service.category !== "Medical Gas Outlet" &&
        newDropLocation.x + dragServiceWidth > serv.positions?.x &&
        newDropLocation.x + dragServiceWidth <
          serv.positions?.x + serviceWidth) ||
      (service.category === "Medical Gas Outlet" &&
        newDropLocation.x + dragServiceWidth - 2.8 > serv.positions?.x &&
        newDropLocation.x + dragServiceWidth - 2.8 <
          serv.positions?.x + serviceWidth) ||
      (newDropLocation.x > serv.positions.x &&
        newDropLocation.x < serv.positions.x + serviceWidth) ||
      (newDropLocation.x < serv.positions?.x &&
        newDropLocation.x + dragServiceWidth >=
          serv.positions?.x + serviceWidth)
    );
    // else if (service.is_slide) return( serv.positions?.x === newDropLocation.x);
    // else return false;
  });

  if (checkHorizontalServicesOverLap) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place new services here.");
  }

  dragPositions.current = newDropLocation;
  return dropLocation;
};

const checkHiddenHeadwallDropLocation2 = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef,
  prevX
) => {
  const { headwalls, width } = values;
  const { service } = dragItem.current;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const dragServicePosition = service.positions;
  const extraMarginForMedicalServices = 2.375;
  const dragServiceWidth =
    service.category === "Medical Gas Outlet"
      ? (service.width + extraMarginForMedicalServices) / pixelPerInch
      : service.width / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  const railWidth = (convertToInches(width) - 2) / pixelPerInch;

  //for x-axis
  for (let i = 0; i < services?.length; i++) {
    let serviceWidth;
    if (services[i].category === "Medical Gas Outlet")
      serviceWidth =
        (services[i].width + extraMarginForMedicalServices) / pixelPerInch;
    else serviceWidth = (services[i].width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
    if (services[i].u_id !== service.u_id) {
      //calculation for left side drag
      if (
        dragServicePosition.x >= services[i]?.positions?.x &&
        dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
      ) {
        //to manage side margins in case of gas

        const newPosition = services[i]?.positions?.x + serviceWidth;
        if (
          newPosition + serviceWidth <=
          railDimensionsRef.current.width - railMargins.end
        )
          newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      } //calulation for right side drag
      else if (
        dragServicePosition.x + dragServiceWidth >= services[i]?.positions?.x &&
        dragServicePosition.x + dragServiceWidth <=
          services[i]?.positions?.x + dragServiceWidth
      ) {
        let newPosition = 0;
        newPosition = services[i]?.positions?.x - dragServiceWidth;
        if (newPosition > railMargins.start) newDropLocation["x"] = newPosition;
        else {
          dropLocation = false;
          warningAlert("Sorry, you cannot place new services here.");
        }
        break;
      }
    }
  }

  const checkHorizontalServicesOverLap = services?.some((serv) => {
    let serviceWidth;
    if (serv.category === "Medical Gas Outlet")
      serviceWidth =
        (serv.width + extraMarginForMedicalServices) / pixelPerInch;
    else serviceWidth = (serv.width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
    if (serv.u_id === service.u_id) return false;
    if (!service.is_slide)
      return (
        serv.positions?.x === newDropLocation.x ||
        (service.category !== "Medical Gas Outlet" &&
          newDropLocation.x + dragServiceWidth > serv.positions?.x &&
          newDropLocation.x + dragServiceWidth <
            serv.positions?.x + serviceWidth) ||
        (service.category === "Medical Gas Outlet" &&
          newDropLocation.x + dragServiceWidth - 2.8 > serv.positions?.x &&
          newDropLocation.x + dragServiceWidth - 2.8 <
            serv.positions?.x + serviceWidth) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions?.x &&
          newDropLocation.x + dragServiceWidth >=
            serv.positions?.x + serviceWidth)
      );
    else if (service.is_slide) return serv.positions?.x === newDropLocation.x;
    else return false;
  });

  if (checkHorizontalServicesOverLap) {
    // dropLocation = false;
    newDropLocation.x = prevX;
    warningAlert("Sorry, you cannot place new services here.");
  }

  const marginWidth = service.category === "Medical Gas Outlet" ? 10 : 60; //margin width end
  if (newDropLocation.x + dragServiceWidth > railWidth - marginWidth) {
    newDropLocation.x = prevX;
    warningAlert("Sorry, you cannot place new services here.");
  }

  if (newDropLocation.x < 24) {
    //margin width start
    newDropLocation.x = prevX;
    warningAlert("Sorry, you cannot place new services here.");
  }

  dragServicePosition.x = newDropLocation.x;
  dragPositions.current = newDropLocation;

  return dropLocation;
};

const checkEloquenceDropLocation = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef
) => {
  debugger;
  const { headwalls, sub_model, accessory_rails, width } = values;
  const { service, dragServiceHeight } = dragItem.current;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const dragServicePosition = dragPositions.current;
  const extraMarginForMedicalServices = 2.375; //  ,1.1875 margin on each side of service;
  const extraMarginForNormalServices = 2.23214285714; //0.125, 0.625 margin on each side
  const dragServiceWidth =
    service.category === "Medical Gas Outlet"
      ? (service.width + extraMarginForMedicalServices) / pixelPerInch
      : service.width / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };
  // if (
  //   (sub_model === "rail" && service.name === "Track Mounted") ||
  //   (sub_model === "standard" && service.name === "Rail Mounted")
  // ) {
  //   dropLocation = false;
  //   warningAlert("Sorry, you cannot place service here.");
  //   return;
  // }
  // code for slide services for equolence
  if (sub_model === "rail" && service.is_slide) {
    if (service.name === "Rail Mounted") {
      const slidesDroppableArea = droppableEloquenceBorderRanges(headwalls);
      const rail = slidesDroppableArea.find(
        (area) =>
          newDropLocation.y <= area.start &&
          newDropLocation.y + dragServiceHeight >= area.end
      );
      if (!rail) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place service here.");
        return;
      } else newDropLocation.y = rail.start - 10;
      services = accessory_rails["direct"].filter(
        (ser) => ser.positions.y === newDropLocation.y
      );
    }
    //  else {
    //   const slidesDroppableArea = droppableEloquenceBorderRanges(headwalls);
    //   const rail = slidesDroppableArea.find(
    //     (area) =>
    //       newDropLocation.y <= area.start &&
    //       newDropLocation.y + dragServiceHeight >= area.end
    //   );
    //   if (rail) {
    //     dropLocation = false;
    //     warningAlert("Sorry, you cannot place service here.");
    //     return;
    //   }
    // }
  } else if (sub_model === "standard" && service.is_slide) {
    // const serviceWidth = service.width / pixelPerInch;
    if (service.name === "Track Mounted") {
      const railWidth = (width.ft * 12 + width.in) / pixelPerInch;
      const borderWidth = 50.7821431429;
      const slidesDroppableArea = [
        { start: 0, end: borderWidth },
        { start: railWidth - borderWidth, end: railWidth },
      ];
      const rail = slidesDroppableArea.find(
        (area) =>
          newDropLocation.x >= area.start && newDropLocation.x <= area.end
      );
      if (!rail) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place service here.");
        return;
      } else {
        if (newDropLocation.x < railWidth / 2) {
          newDropLocation.x = borderWidth / 2 - 10;
        } else {
          newDropLocation.x = railWidth - borderWidth + 5; //5 to adjust position on ui
        }
      }
      services = accessory_rails["direct"].filter(
        (ser) => ser.positions.x === newDropLocation.x
      );
    }
  }
  if (
    sub_model === "standard" &&
    service.is_slide &&
    service.name === "Track Mounted"
  ) {
    //for y axis
    for (let i = 0; i < services?.length; i++) {
      let serviceHeight = services[i].height / pixelPerInch;
      if (services[i].u_id !== service?.u_id) {
        //for vaccum bottom drag
        if (
          newDropLocation.y >= services[i]?.positions?.y &&
          newDropLocation.y <= services[i]?.positions?.y + serviceHeight
        ) {
          const newPosition = services[i]?.positions?.y + dragServiceHeight;
          newDropLocation["y"] = newPosition;
          break;
        } else if (
          service?.is_slide &&
          newDropLocation.y + dragServiceHeight >= services[i]?.positions?.y &&
          newDropLocation.y + dragServiceHeight <=
            services[i]?.positions?.y + dragServiceHeight
        ) {
          const newPosition = services[i]?.positions?.y - dragServiceHeight;
          newDropLocation["y"] = newPosition;
          break;
        }
      }
    }

    const checkVerticalServicesOverLap = services?.some((serv) => {
      const serviceHeight = serv.height / pixelPerInch;
      return (
        (serv.u_id !== service.u_id &&
          ((newDropLocation.y !== serv.positions?.y &&
            ((newDropLocation.y + dragServiceHeight > serv.positions?.y &&
              newDropLocation.y + dragServiceHeight <
                serv.positions?.y + serviceHeight) ||
              (newDropLocation.y > serv.positions?.y &&
                Math.round(newDropLocation.y) <
                  Math.round(serv.positions?.y + serviceHeight)))) ||
            (newDropLocation.y === serv.positions?.y &&
              newDropLocation.y > serv.positions?.y &&
              newDropLocation.y < serv.positions?.y + serviceHeight) ||
            newDropLocation.y + dragServiceHeight >
              railDimensionsRef.current.parentHeight)) ||
        newDropLocation.y < 0 ||
        (service.is_slide && newDropLocation.y === serv.positions?.y)
      );
    });

    if (checkVerticalServicesOverLap) {
      dropLocation = false;
      warningAlert("Sorry, you cannot place new services here.");
      return;
    }
  } else {
    //for x-axis
    for (let i = 0; i < services?.length; i++) {
      let serviceWidth;
      // let serviceWidth=services[i].width / pixelPerInch
      if (
        services[i].category === "Medical Gas Outlet" &&
        service.category === "Medical Gas Outlet"
      )
        serviceWidth =
          (services[i].width + extraMarginForMedicalServices) / pixelPerInch;
      else serviceWidth = services[i].width / pixelPerInch; //0.0625 to manage margins around the service
      // else serviceWidth = (services[i].width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
      if (services[i].u_id !== service.u_id) {
        //calculation for left side drag
        if (
          dragServicePosition.x >= services[i]?.positions?.x &&
          dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
        ) {
          //to manage side margins in case of gas
          let newPosition = 0;
          if (service.category === "Medical Gas Outlet") {
            newPosition = services[i]?.positions?.x + serviceWidth;
          } else
            newPosition =
              services[i]?.positions?.x +
              serviceWidth +
              extraMarginForNormalServices;
          if (
            newPosition + serviceWidth <=
            railDimensionsRef.current.width - railMargins.end
          )
            newDropLocation["x"] = newPosition;
          else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here.");
          }
          break;
        } //calulation for right side drag
        else if (
          dragServicePosition.x + dragServiceWidth >=
            services[i]?.positions?.x &&
          dragServicePosition.x + dragServiceWidth <=
            services[i]?.positions?.x + dragServiceWidth
        ) {
          let newPosition = 0;
          // newPosition = services[i]?.positions?.x - dragServiceWidth;
          if (service.category === "Medical Gas Outlet") {
            newPosition = services[i]?.positions?.x - dragServiceWidth;
          } else
            newPosition =
              services[i]?.positions?.x -
              dragServiceWidth -
              extraMarginForNormalServices;
          if (newPosition > railMargins.start)
            newDropLocation["x"] = newPosition;
          else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here.");
          }
          break;
        }
      }
    }

    const checkHorizontalServicesOverLap = services?.some((serv) => {
      let serviceWidth = serv.width / pixelPerInch;
      // if (serv.category === "Medical Gas Outlet")
      //   serviceWidth =
      //     (serv.width + extraMarginForMedicalServices) / pixelPerInch;
      // else serviceWidth = (serv.width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
      if (serv.u_id === service.u_id) return false;
      // if (!service.is_slide)
      return (
        serv.positions?.x === newDropLocation.x ||
        (service.category !== "Medical Gas Outlet" &&
          newDropLocation.x + dragServiceWidth + extraMarginForNormalServices >
            serv.positions?.x &&
          newDropLocation.x + dragServiceWidth + extraMarginForNormalServices <
            serv.positions?.x + serviceWidth) ||
        (service.category === "Medical Gas Outlet" &&
          newDropLocation.x + dragServiceWidth > serv.positions?.x &&
          newDropLocation.x + dragServiceWidth <
            serv.positions?.x + serviceWidth) ||
        (newDropLocation.x > serv.positions.x &&
          newDropLocation.x < serv.positions.x + serviceWidth) ||
        (newDropLocation.x < serv.positions?.x &&
          newDropLocation.x + dragServiceWidth >=
            serv.positions?.x + serviceWidth)
      );
      // else if (service.is_slide) return( serv.positions?.x === newDropLocation.x);
      // else return false;
    });

    if (checkHorizontalServicesOverLap) {
      dropLocation = false;
      warningAlert("Sorry, you cannot place new services here.");
    }
  }

  dragPositions.current = newDropLocation;
  return dropLocation;
};

const checkEloquenceDropLocation2 = (
  railIndex,
  dragItem,
  values,
  dragPositions,
  railMargins,
  railDimensionsRef,
  prevX
) => {
  const { headwalls, sub_model, accessory_rails, width } = values;
  const { service, dragServiceHeight } = dragItem.current;
  const rails = [...headwalls];
  let services = rails[railIndex]?.services;
  const borderWidth = sub_model === "standard" ? 50.7821431429 : 10;

  // if (service?.is_slide) services = services?.filter((ser) => ser?.is_slide);
  const dragServicePosition = service.positions;
  const railWidth = convertToInches(width) / pixelPerInch;
  const extraMarginForMedicalServices = 2.375;
  const dragServiceWidth =
    service.category === "Medical Gas Outlet"
      ? (service.width + extraMarginForMedicalServices) / pixelPerInch
      : service.width / pixelPerInch;

  let dropLocation = true;
  let newDropLocation = { x: dragServicePosition.x, y: dragServicePosition.y };

  if (newDropLocation.x + dragServiceWidth > railWidth) {
    warningAlert("Sorry, you cannot place service here.3916");
  }
  if (
    (sub_model === "rail" && service.name === "Track Mounted") ||
    (sub_model === "standard" && service.name === "Rail Mounted")
  ) {
    dropLocation = false;
    warningAlert("Sorry, you cannot place service here.");
    return;
  }
  // code for slide services for equolence
  if (sub_model === "rail" && service.is_slide) {
    if (service.name === "Rail Mounted") {
      const slidesDroppableArea = droppableEloquenceBorderRanges(headwalls);
      const rail = slidesDroppableArea.find(
        (area) =>
          newDropLocation.y <= area.start &&
          newDropLocation.y + dragServiceHeight >= area.end
      );
      if (!rail) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place service here.");
        return;
      } else newDropLocation.y = rail.start - 10;
      services = accessory_rails["direct"].filter(
        (ser) => ser.positions.y === newDropLocation.y
      );
    } else {
      const slidesDroppableArea = droppableEloquenceBorderRanges(headwalls);
      const rail = slidesDroppableArea.find(
        (area) =>
          newDropLocation.y <= area.start &&
          newDropLocation.y + dragServiceHeight >= area.end
      );
      if (rail) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place service here.");
        return;
      }
    }
  } else if (sub_model === "standard" && service.is_slide) {
    const serviceWidth = service.width / pixelPerInch;
    if (service.name === "Track Mounted") {
      const railWidth = (width.ft * 12 + width.in) / pixelPerInch;
      const slidesDroppableArea = [
        { start: 0, end: borderWidth },
        { start: railWidth - borderWidth, end: railWidth },
      ];
      const rail = slidesDroppableArea.find(
        (area) =>
          newDropLocation.x >= area.start &&
          newDropLocation.x + serviceWidth <= area.end
      );
      if (!rail) {
        dropLocation = false;
        warningAlert("Sorry, you cannot place service here.");
        return;
      } else {
        if (newDropLocation.x < railWidth / 2) {
          newDropLocation.x = borderWidth / 2 - 10;
        } else {
          newDropLocation.x = railWidth - borderWidth + 5; //5 to adjust position on ui
        }
      }
      services = accessory_rails["direct"].filter(
        (ser) => ser.positions.x === newDropLocation.x
      );
    }
  }
  // console.log({services})
  if (
    sub_model === "standard" &&
    service.is_slide &&
    service.name === "Track Mounted"
  ) {
    //for y axis
    for (let i = 0; i < services?.length; i++) {
      let serviceHeight = services[i].height / pixelPerInch;
      if (services[i].u_id !== service?.u_id) {
        //for vaccum bottom drag
        if (
          newDropLocation.y >= services[i]?.positions?.y &&
          newDropLocation.y <= services[i]?.positions?.y + serviceHeight
        ) {
          const newPosition = services[i]?.positions?.y + dragServiceHeight;
          newDropLocation["y"] = newPosition;
          break;
        } else if (
          service?.is_slide &&
          newDropLocation.y + dragServiceHeight >= services[i]?.positions?.y &&
          newDropLocation.y + dragServiceHeight <=
            services[i]?.positions?.y + dragServiceHeight
        ) {
          const newPosition = services[i]?.positions?.y - dragServiceHeight;
          newDropLocation["y"] = newPosition;
          break;
        }
      }
    }

    const checkVerticalServicesOverLap = services?.some((serv) => {
      const serviceHeight = serv.height / pixelPerInch;
      return (
        (serv.u_id !== service.u_id &&
          ((newDropLocation.y !== serv.positions?.y &&
            ((newDropLocation.y + dragServiceHeight > serv.positions?.y &&
              newDropLocation.y + dragServiceHeight <
                serv.positions?.y + serviceHeight) ||
              (newDropLocation.y > serv.positions?.y &&
                Math.round(newDropLocation.y) <
                  Math.round(serv.positions?.y + serviceHeight)))) ||
            (newDropLocation.y === serv.positions?.y &&
              newDropLocation.y > serv.positions?.y &&
              newDropLocation.y < serv.positions?.y + serviceHeight) ||
            newDropLocation.y + dragServiceHeight >
              railDimensionsRef.current.parentHeight)) ||
        (service.is_slide && newDropLocation.y === serv.positions?.y)
      );
    });

    if (checkVerticalServicesOverLap) {
      dropLocation = false;
      warningAlert("Sorry, you cannot place new services here.");
      return;
    }
  } else {
    //for x-axis
    for (let i = 0; i < services?.length; i++) {
      let serviceWidth;
      if (services[i].category === "Medical Gas Outlet")
        serviceWidth =
          (services[i].width + extraMarginForMedicalServices) / pixelPerInch;
      else serviceWidth = (services[i].width + 0.125) / pixelPerInch; //0.0625 to manage margins around the service
      if (services[i].u_id !== service.u_id) {
        //calculation for left side drag
        if (
          dragServicePosition.x >=
            services[i]?.positions?.x - dragServiceWidth &&
          dragServicePosition.x <= services[i]?.positions?.x + serviceWidth
        ) {
          //to manage side margins in case of gas

          const newPosition = services[i]?.positions?.x + serviceWidth;
          if (
            newPosition + serviceWidth <=
            railDimensionsRef.current.width - railMargins.end
          )
            newDropLocation["x"] = newPosition;
          else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here. 4069");
          }
          break;
        } //calulation for right side drag
        else if (
          dragServicePosition.x + dragServiceWidth >=
            services[i]?.positions?.x &&
          dragServicePosition.x + dragServiceWidth <=
            services[i]?.positions?.x + dragServiceWidth
        ) {
          let newPosition = 0;
          newPosition = services[i]?.positions?.x - dragServiceWidth;
          if (newPosition > railMargins.start)
            newDropLocation["x"] = newPosition;
          else {
            dropLocation = false;
            warningAlert("Sorry, you cannot place new services here. 4085");
          }
          break;
        }
      }
    }

    const checkHorizontalServicesOverLap = services?.some((serv) => {
      let serviceWidth;
      if (serv.category === "Medical Gas Outlet") {
        serviceWidth =
          (serv.width + extraMarginForMedicalServices) / pixelPerInch;
      } else {
        serviceWidth = (serv.width + 0.125) / pixelPerInch; // margin handling
      }

      if (serv.u_id === service.u_id) return false;

      const cond1 = serv.positions?.x === newDropLocation.x;
      const cond2 =
        service.category !== "Medical Gas Outlet" &&
        newDropLocation.x + dragServiceWidth > serv.positions?.x &&
        newDropLocation.x + dragServiceWidth < serv.positions?.x + serviceWidth;

      const cond3 =
        service.category === "Medical Gas Outlet" &&
        newDropLocation.x + dragServiceWidth - 2.8 > serv.positions?.x &&
        newDropLocation.x + dragServiceWidth - 2.8 <
          serv.positions?.x + serviceWidth;

      const cond4 =
        newDropLocation.x > serv.positions.x &&
        newDropLocation.x < serv.positions.x + serviceWidth;

      const cond5 =
        newDropLocation.x < serv.positions?.x &&
        newDropLocation.x + dragServiceWidth >=
          serv.positions?.x + serviceWidth;

      return cond1 || cond2 || cond3 || cond4 || cond5;
    });

    if (checkHorizontalServicesOverLap) {
      // dropLocation = false;
      newDropLocation.x = prevX;
      warningAlert("Sorry, you cannot place new services here.");
    }
  }

  if (
    newDropLocation.x + dragServiceWidth >
    railWidth - borderWidth - borderWidth
  ) {
    newDropLocation.x = prevX;

    warningAlert("Sorry, you cannot place new services here.");
  }

  if (newDropLocation.x < 0) {
    newDropLocation.x = prevX;
    warningAlert("Sorry, you cannot place new services here.");
  }
  dragServicePosition.x = newDropLocation.x;
  dragPositions.current = newDropLocation;
  // dragItem.service.positions = newDropLocation;

  dragPositions.current = newDropLocation;
  return dropLocation;
};

const handleInfinityAxiomDrop = (
  e,
  rails,
  railIndex,
  dragRailIndex,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );
  if (dropLocation && railIndex !== null && dragItemNode.current !== e.target) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null)
        //if user is dragging from one rail to another then remove from dragging rail
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: calculateYDistance(dragPositions),
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      rails[railIndex].services[serviceIndex].positions = dragPositions.current;
      rails[railIndex].services[serviceIndex].x_distance_inches =
        calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        );
      rails[railIndex].services[serviceIndex].y_distance_inches =
        calculateYDistance(dragPositions);
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleEloquenceDrop = (
  e,
  rails,
  railIndex,
  dragRailIndex,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode,
  accessory_rails,
  dropArea
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );
  if (
    dropLocation &&
    railIndex !== null &&
    dragItemNode.current !== e.target &&
    (!service.is_slide || service.name === "Direct Mount")
  ) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null)
        //if user is dragging from one rail to another then remove from dragging rail
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: calculateYDistance(dragPositions),
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      rails[railIndex].services[serviceIndex].positions = dragPositions.current;
      rails[railIndex].services[serviceIndex].x_distance_inches =
        calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        );
      rails[railIndex].services[serviceIndex].y_distance_inches =
        calculateYDistance(dragPositions);
    }
  } else if (
    dropLocation &&
    dragItemNode.current !== e.target &&
    service.is_slide &&
    (service.name === "Rail Mounted" || service.name === "Track Mounted")
  ) {
    if (dropArea === "rail") {
      if (!service.u_id) {
        //drop  services into rails
        const newService = {
          ...service,
          x_distance_inches: calculateXDistance(
            dragPositions,
            railMargins,
            railDimensionsRef,
            values,
            service
          ),
          y_distance_inches: calculateYDistance(dragPositions),
          u_id: generateUniqueId(),
          positions: dragPositions.current,
        };
        accessory_rails["direct"] = [...accessory_rails["direct"], newService];
      } else {
        updateOrDeleteDirectAccessory(
          accessory_rails,
          service?.u_id,
          true,
          dragPositions.current
        );
      }
    } else {
      updateOrDeleteDirectAccessory(accessory_rails, service?.u_id);
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleEloquenceDrop2 = (
  e,
  rails,
  railIndex,
  dragRailIndex,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode,
  accessory_rails,
  dropArea
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );
  if (
    dropLocation &&
    railIndex !== null &&
    (!service.is_slide || service.name === "Direct Mount")
  ) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null)
        //if user is dragging from one rail to another then remove from dragging rail
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: dragPositions.current.x * pixelPerInch,
        y_distance_inches: calculateYDistance(dragPositions),
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      rails[railIndex].services[serviceIndex].positions = dragPositions.current;
      rails[railIndex].services[serviceIndex].x_distance_inches =
        dragPositions.current.x * pixelPerInch;
      // calculateXDistance(
      //   dragPositions,
      //   railMargins,
      //   railDimensionsRef,
      //   values,
      //   service
      // );
      rails[railIndex].services[serviceIndex].y_distance_inches =
        calculateYDistance(dragPositions);
    }
  } else if (
    dropLocation &&
    service.is_slide &&
    (service.name === "Rail Mounted" || service.name === "Track Mounted")
  ) {
    if (dropArea === "rail") {
      if (!service.u_id) {
        //drop  services into rails
        const newService = {
          ...service,
          x_distance_inches: dragPositions.current.x * pixelPerInch,
          y_distance_inches: calculateYDistance(dragPositions),
          u_id: generateUniqueId(),
          positions: dragPositions.current,
        };
        accessory_rails["direct"] = [...accessory_rails["direct"], newService];
      } else {
        updateOrDeleteDirectAccessory(
          accessory_rails,
          service?.u_id,
          true,
          dragPositions.current
        );
      }
    } else {
      updateOrDeleteDirectAccessory(accessory_rails, service?.u_id);
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleInfinityAxiomDrop2 = (
  e,
  rails,
  railIndex,
  dragRailIndex,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );
  // if(dropLocation)
  //   rails[dragRailIndex].services.splice(serviceIndex, 1);

  if (dropLocation && railIndex !== null) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null)
        //if user is dragging from one rail to another then remove from dragging rail
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: calculateYDistance(dragPositions),
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      rails[railIndex].services[serviceIndex].positions = dragPositions.current;
      rails[railIndex].services[serviceIndex].x_distance_inches =
        calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        );
      rails[railIndex].services[serviceIndex].y_distance_inches =
        calculateYDistance(dragPositions);
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleCompassDrop = (
  e,
  rails,
  railIndex, //where service get dropped
  dragRailIndex, //form where service is dragged
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode,
  rowIndex,
  dragRowIndex
) => {
  const serviceIndex = rails[dragRailIndex]?.services.findIndex(
    (serv) => serv.u_id === service.u_id
  );

  if (dropLocation && railIndex !== null && dragItemNode.current !== e.target) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null) {
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      }
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: dragPositions.current.y * pixelPerInch,
        rowPosition: service?.is_slide ? null : rowIndex,
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      //while moving from one row to another in same rail
      if (!service.is_slide) {
        if (dragRowIndex !== rowIndex) {
          rails[railIndex].services[serviceIndex].rowPosition = rowIndex;
          rails[railIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[railIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values,
              service
            );
          rails[railIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch;
        }
        //while moving in same row
        else {
          rails[railIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[railIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values,
              service
            );
          rails[railIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch;
        }
      } else {
        rails[railIndex].services[serviceIndex].positions =
          dragPositions.current;
        rails[railIndex].services[serviceIndex].x_distance_inches =
          calculateXDistance(
            dragPositions,
            railMargins,
            railDimensionsRef,
            values,
            service
          );
        rails[railIndex].services[serviceIndex].y_distance_inches =
          dragPositions.current.y * pixelPerInch;
      }
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleArrayDrop = (
  e,
  rails,
  railIndex, //where service get dropped
  dragRailIndex, //form where service is dragged
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode,
  rowIndex,
  dragRowIndex
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );

  //to manage the y axis while user dragging normal services
  let manageServiceY = 0;
  if (!service.is_slide) {
    if (rowIndex === 1) manageServiceY = 2.875;
    else if (rowIndex === 2) {
      const ceilingHeight =
        values.ceiling_height.ft * 12 + values.ceiling_height.in;
      manageServiceY = ceilingHeight - 64;
    } else if (rowIndex === 3) {
      const ceilingHeight =
        values.ceiling_height.ft * 12 + values.ceiling_height.in;
      manageServiceY = ceilingHeight - 34;
    }
  }

  if (dropLocation && railIndex !== null && dragItemNode.current !== e.target) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null) {
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      }
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: service?.is_slide
          ? dragPositions.current.y * pixelPerInch
          : dragPositions.current.y * pixelPerInch + manageServiceY,
        rowPosition: rowIndex,
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      //while moving from one row to another in same rail
      if (!service.is_slide) {
        if (dragRowIndex !== rowIndex) {
          rails[dragRailIndex].services[serviceIndex].rowPosition = rowIndex;

          rails[dragRailIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[dragRailIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values
            );
          rails[dragRailIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch + manageServiceY;
        }
        //while moving in same row
        else {
          rails[dragRailIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[dragRailIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values
            );
          rails[dragRailIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch + manageServiceY;
        }
      } else {
        rails[dragRailIndex].services[serviceIndex].x_distance_inches =
          calculateXDistance(
            dragPositions,
            railMargins,
            railDimensionsRef,
            values
          );
        rails[dragRailIndex].services[serviceIndex].y_distance_inches =
          calculateYDistance(dragPositions);
        rails[dragRailIndex].services[serviceIndex].positions =
          dragPositions.current;
      }
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleConsoleDrop = (
  e,
  rails,
  railIndex,
  dragRailIndex,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );
  // if(dropLocation)
  //   rails[dragRailIndex].services.splice(serviceIndex, 1);

  if (dropLocation && railIndex !== null && dragItemNode.current !== e.target) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null)
        //if user is dragging from one rail to another then remove from dragging rail
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: calculateYDistance(dragPositions),
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      rails[railIndex].services[serviceIndex].positions = dragPositions.current;
      rails[railIndex].services[serviceIndex].x_distance_inches =
        calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        );
      rails[railIndex].services[serviceIndex].y_distance_inches =
        calculateYDistance(dragPositions);
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleConsoleDrop2 = (
  e,
  rails,
  railIndex,
  dragRailIndex,
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );
  // if(dropLocation)
  //   rails[dragRailIndex].services.splice(serviceIndex, 1);

  if (dropLocation && railIndex !== null) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null)
        //if user is dragging from one rail to another then remove from dragging rail
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      //drop  services into rails

      const newService = {
        ...service,
        x_distance_inches: dragPositions.current.x * pixelPerInch,
        y_distance_inches: calculateYDistance(dragPositions),
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      rails[railIndex].services[serviceIndex].positions = dragPositions.current;
      rails[railIndex].services[serviceIndex].x_distance_inches =
        dragPositions.current.x * pixelPerInch;
      rails[railIndex].services[serviceIndex].y_distance_inches =
        calculateYDistance(dragPositions);
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleCompassDrop2 = (
  e,
  rails,
  railIndex, //where service get dropped
  dragRailIndex, //form where service is dragged
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode,
  rowIndex,
  dragRowIndex
) => {
  const serviceIndex = rails[dragRailIndex]?.services.findIndex(
    (serv) => serv.u_id === service.u_id
  );

  if (dropLocation && railIndex !== null) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null) {
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      }
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: dragPositions.current.y * pixelPerInch,
        rowPosition: service?.is_slide ? null : rowIndex,
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      //while moving from one row to another in same rail
      if (!service.is_slide) {
        if (dragRowIndex !== rowIndex) {
          rails[railIndex].services[serviceIndex].rowPosition = rowIndex;
          rails[railIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[railIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values,
              service
            );
          rails[railIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch;
        }
        //while moving in same row
        else {
          rails[railIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[railIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values,
              service
            );
          rails[railIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch;
        }
      } else {
        rails[railIndex].services[serviceIndex].positions =
          dragPositions.current;
        rails[railIndex].services[serviceIndex].x_distance_inches =
          calculateXDistance(
            dragPositions,
            railMargins,
            railDimensionsRef,
            values,
            service
          );
        rails[railIndex].services[serviceIndex].y_distance_inches =
          dragPositions.current.y * pixelPerInch;
      }
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

const handleArrayDrop2 = (
  e,
  rails,
  railIndex, //where service get dropped
  dragRailIndex, //form where service is dragged
  values,
  dragPositions,
  railDimensionsRef,
  railMargins,
  dropLocation,
  service,
  dragItemNode,
  rowIndex,
  dragRowIndex
) => {
  const serviceIndex = rails[dragRailIndex]?.services?.findIndex(
    (serv) => serv.u_id === service.u_id
  );

  //to manage the y axis while user dragging normal services
  let manageServiceY = 0;
  if (!service.is_slide) {
    if (rowIndex === 1) manageServiceY = 2.875;
    else if (rowIndex === 2) {
      const ceilingHeight =
        values.ceiling_height.ft * 12 + values.ceiling_height.in;
      manageServiceY = ceilingHeight - 64;
    } else if (rowIndex === 3) {
      const ceilingHeight =
        values.ceiling_height.ft * 12 + values.ceiling_height.in;
      manageServiceY = ceilingHeight - 34;
    }
  }

  if (dropLocation && railIndex !== null) {
    if (dragRailIndex !== railIndex) {
      if (dragRailIndex !== null) {
        rails[dragRailIndex].services.splice(serviceIndex, 1);
      }
      //drop  services into rails
      const newService = {
        ...service,
        x_distance_inches: calculateXDistance(
          dragPositions,
          railMargins,
          railDimensionsRef,
          values,
          service
        ),
        y_distance_inches: service?.is_slide
          ? dragPositions.current.y * pixelPerInch
          : dragPositions.current.y * pixelPerInch + manageServiceY,
        rowPosition: rowIndex,
        u_id: generateUniqueId(),
      };
      rails[railIndex].services.push({
        ...newService,
        positions: dragPositions.current,
      });
    } else {
      //moving service inside the rail
      //while moving from one row to another in same rail
      if (!service.is_slide) {
        if (dragRowIndex !== rowIndex) {
          rails[dragRailIndex].services[serviceIndex].rowPosition = rowIndex;

          rails[dragRailIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[dragRailIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values
            );
          rails[dragRailIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch + manageServiceY;
        }
        //while moving in same row
        else {
          rails[dragRailIndex].services[serviceIndex].positions =
            dragPositions.current;
          rails[dragRailIndex].services[serviceIndex].x_distance_inches =
            calculateXDistance(
              dragPositions,
              railMargins,
              railDimensionsRef,
              values
            );
          rails[dragRailIndex].services[serviceIndex].y_distance_inches =
            dragPositions.current.y * pixelPerInch + manageServiceY;
        }
      } else {
        rails[dragRailIndex].services[serviceIndex].x_distance_inches =
          calculateXDistance(
            dragPositions,
            railMargins,
            railDimensionsRef,
            values
          );
        rails[dragRailIndex].services[serviceIndex].y_distance_inches =
          calculateYDistance(dragPositions);
        rails[dragRailIndex].services[serviceIndex].positions =
          dragPositions.current;
      }
    }
  } else if (railIndex === null && dragRailIndex !== null) {
    //delete service from rail if dragged to the wall
    rails[dragRailIndex].services.splice(serviceIndex, 1);
  }
};

// for compass to get drop points
const getDropPoints = (divWidth) => {
  const addend = 16.183035714; //16 px for 0.90625000 inches
  const subtractValue = 8.091517857;
  const sideMargin = 5.296428571; // last margin on the sides of the rails
  const rowWidth = (divWidth - 5.5) / pixelPerInch;
  // const center = (rowWidth / 2) / pixelPerInch;
  const center = rowWidth / 2;

  let startingPoint = center - subtractValue;

  let innerPoints = [];

  // Subtract until the last value is greater than 16.196428571
  while (startingPoint > sideMargin) {
    innerPoints.push(startingPoint);
    startingPoint -= addend;
  }

  // Reset starting point for addition
  startingPoint = center - subtractValue + addend;

  // Add until the last value is less than 116.28
  while (startingPoint < rowWidth - sideMargin) {
    innerPoints.push(startingPoint);
    startingPoint += addend;
  }

  return innerPoints;
};

// for compass to get drop points
const getConsoleDropPoints = (consoleWidth, startingPoint) => {
  const incrementPoint = 42.4107142857; //2.375 inch margin between holes

  let positions = [];
  let currentPosition = startingPoint;
  const limit = consoleWidth - startingPoint;

  while (Math.round(currentPosition) <= Math.round(limit)) {
    positions.push(currentPosition);
    currentPosition += incrementPoint;
  }
  return positions;
};

const findNearestValue = (arr, target) => {
  let nearestValue = arr[0];
  let minDifference = Math.abs(target - nearestValue);

  for (let i = 1; i < arr?.length; i++) {
    const difference = Math.abs(target - arr[i]);

    if (difference < minDifference) {
      minDifference = difference;
      nearestValue = arr[i];
    }
  }

  return nearestValue;
};

//for console
const findFirstDropPointInRange = (dropPoints, x, width) => {
  const rangeStart = x;
  const rangeEnd = x + width;

  return dropPoints.find((point) => point >= rangeStart && point <= rangeEnd);
};

//for console
const findAvailableDropPoint = (
  dropPoints,
  halfWidth,
  existingService,
  draggedService,
  placementType,
  model_type // ✅ Added parameter
) => {
  const existingServicePoint = existingService?.positions?.x;
  const existingServiceWidth = existingService?.width / pixelPerInch;
  const existingServiceRight = existingServicePoint + existingServiceWidth;
  const existingServiceCategory = existingService.category;
  let validPointCount = 0;

  const isMedicalGas =
    draggedService?.category === "Medical Gas Outlet" ||
    existingServiceCategory === "Medical Gas Outlet";

  const requiredPoint =
    model_type === "rail"
      ? 3 // ✅ Third point for rail model
      : isMedicalGas
      ? 2 // ✅ Second point for medical gas outlet
      : 1; // ✅ First point for others

  if (placementType === "right") {
    for (let i = 0; i < dropPoints.length; i++) {
      const point = dropPoints[i];

      // Skip points before or equal to existing service
      if (point <= existingServicePoint) continue;

      const serviceLeft = point - halfWidth;

      // Overlap check
      if (serviceLeft >= existingServiceRight) {
        validPointCount++;
        if (validPointCount === requiredPoint) return point;
      }
    }
  } else if (placementType === "left") {
    dropPoints = [...dropPoints].reverse(); // ✅ Avoid mutating original array
    for (let i = 0; i < dropPoints.length; i++) {
      const point = dropPoints[i];

      // Skip points after or equal to existing service
      if (point >= existingServicePoint) continue;

      const serviceRight = point + halfWidth;

      // Overlap check
      if (serviceRight <= existingServicePoint) {
        validPointCount++;
        if (validPointCount === requiredPoint) return point;
      }
    }
  }

  return null; // ✅ No valid point found
};

const calculateXDistance = (
  dragPositions,
  railMargins,
  railDimensionsRef,
  values,
  service
) => {
  const currentPosition = dragPositions.current.x;
  const railDim = railDimensionsRef.current?.width / 2;
  const { chased, chase_position, model } = values;
  if (chased && chase_position === "center" && currentPosition > railDim) {
    const distance = (currentPosition + railMargins.between) * pixelPerInch;
    // return distance + 4.304; // adding extra 4 inches to manage 13inches for center chase
    return distance; // adding extra 4 inches to manage 13inches for center chase
  } else {
    //calculations for axiom service gas
    if (model === PRODUCT.AXIOM && service?.is_slide) {
      return currentPosition * pixelPerInch;
    } else if (
      model === PRODUCT.ELOQUENCE &&
      service.category === "Medical Gas Outlet"
    ) {
      return currentPosition * pixelPerInch + 1.1875;
    } else if (model === PRODUCT.ARRAY) return currentPosition * pixelPerInch;
    else if (model === PRODUCT.COMPASS) {
      if (service?.is_slide) return currentPosition * pixelPerInch;
      else if (
        service?.name.includes("Call") ||
        service?.name.includes("Staff") ||
        service?.name.includes("Code Blue")
      )
        return currentPosition * pixelPerInch + 0.5;
      else return currentPosition * pixelPerInch + 0.38;
    } else return (currentPosition + railMargins.between) * pixelPerInch;
  }
};

const calculateYDistance = (dragPositions) => {
  const currentPosition = dragPositions.current.y;
  return (currentPosition + 13) * pixelPerInch;
};

const convertInchesToFeetAndInches = (totalInches, model, sub_model) => {
  if (
    model === PRODUCT.CONSOLE ||
    (model === PRODUCT.SECURITY && sub_model !== "enclosure") ||
    model === PRODUCT.HIDDEN
  )
    return { ft: 0, in: totalInches, ftError: "" };
  else {
    // Calculate the number of feet
    const feet = Math.floor(totalInches / 12);
    // Calculate the remaining inches
    const inches = totalInches % 12;

    return { ft: feet, in: inches, ftError: "" };
  }
};

const convertToInches = (measurement) => {
  const feet = Number(measurement.ft) || 0;
  const inches = Number(measurement.in) || 0;
  return feet * 12 + inches;
};

const headwallData = (headwalls, model) => {
  const transformedData = {
    headwalls: headwalls?.map((headwall) => {
      return {
        width: model === PRODUCT.COMPASS ? headwall.width : headwall.width / 12,
        position: headwall.position,
        color: headwall?.color,
        background: headwall?.background,
        services: headwall.services.map((service) => {
          return {
            _id: service.service_type_id,
            rowPosition: service?.rowPosition,
            x_distance_inches: service.x_distance_inches,
            y_distance_inches: service.y_distance_inches,
            specification: service?.specification,
            is_slide: service.is_slide,
            name: service.name,
            image_url: service.service_image,
            height: service.dimension.height,
            width: service.dimension.width,
            gang_width: service.dimension.gang_width,
            u_id: service.u_id,
            positions: service.positions,
            category_id: service.category_id,
            quote_requested: service.quote_requested,
            cad_requested: service.cad_requested,
            category: service?.category_name,
          };
        }),
      };
    }),
  };
  return transformedData;
};

const accessoriesData = (accessories, model) => {
  if (model === PRODUCT.ELOQUENCE) {
    const slideServices = accessories["direct"].map((service) => {
      return {
        _id: service.service_type_id,
        rowPosition: service?.rowPosition,
        x_distance_inches: service.x_distance_inches,
        y_distance_inches: service.y_distance_inches,
        specification: service?.specification,
        is_slide: service.is_slide,
        name: service.name,
        image_url: service.service_image,
        height: service.dimension.height,
        width: service.dimension.width,
        gang_width: service.dimension.gang_width,
        u_id: service.u_id,
        positions: service.positions,
        category_id: service.category_id,
        quote_requested: service.quote_requested,
        cad_requested: service.cad_requested,
        category: service?.category_name,
      };
    });
    accessories["direct"] = slideServices;
    return accessories;
  } else return accessories;
};

//Accessories rails calculations

const checkUnimountRailDrop = (
  service,
  rails,
  dragPositions,
  dropLocation,
  accessory_rails,
  model
) => {
  const dragX = dragPositions.current?.x;
  let dragY = dragPositions.current?.y;
  let cumulativeWidth = 0;
  let nearestValue = -1;
  // For multiple sections, find the nearest
  // Array to hold valid panel boundaries (excluding 0 and total width)
  const validBoundaries = [0];

  if (service.accessories.length) {
    warningAlert("Sorry, you cannot move rail with accessories over it.");
    dropLocation = false;
    return;
  }

  // Populate valid boundaries for panels
  rails.forEach((rail, index) => {
    if (model === PRODUCT.COMPASS) cumulativeWidth += rail.width / pixelPerInch;
    else if (model === PRODUCT.ARRAY)
      cumulativeWidth += (rail.width * 12) / pixelPerInch;
    // if (index < rails.length - 1) {
    // Exclude the last panel's boundary
    validBoundaries.push(cumulativeWidth);
    // }
  });

  // Remove 0 from valid boundaries if it exists (this will ignore 0)
  // const filteredValidBoundaries = validBoundaries.filter((val) => val !== 0);

  // Find the nearest valid boundary
  validBoundaries.forEach((boundary) => {
    if (
      nearestValue === -1 ||
      Math.abs(boundary - dragX) < Math.abs(nearestValue - dragX)
      //to adjust unimout track to the center of the rail
    ) {
      nearestValue = boundary - 10;
    }
  });

  if (model === PRODUCT.COMPASS) {
    if (dragY >= 0 && dragY < COMPASS.SECTION_1_HEIGHT) {
      dragY = 0;
      service.height = COMPASS.SECTION_1_HEIGHT * pixelPerInch;
    } else if (
      dragY > COMPASS.SECTION_1_HEIGHT &&
      dragY < COMPASS.SECTION_1_HEIGHT + COMPASS.SECTION_2_HEIGHT
    ) {
      // dragY = COMPASS.SECTION_1_HEIGHT + 2;
      dragY = COMPASS.SECTION_1_HEIGHT;
      service.height = COMPASS.SECTION_2_HEIGHT * pixelPerInch;
    } else if (
      dragY > COMPASS.SECTION_1_HEIGHT + COMPASS.SECTION_2_HEIGHT &&
      dragY <
        COMPASS.SECTION_1_HEIGHT +
          COMPASS.SECTION_2_HEIGHT +
          COMPASS.SECTION_3_HEIGHT
    ) {
      // dragY = COMPASS.SECTION_1_HEIGHT + COMPASS.SECTION_2_HEIGHT + 4;
      dragY = COMPASS.SECTION_1_HEIGHT + COMPASS.SECTION_2_HEIGHT;
      service.height = COMPASS.SECTION_3_HEIGHT * pixelPerInch;
    }
  } else if (model === PRODUCT.ARRAY) {
    const getArraySection1 = document.getElementById("array-section-1");
    const Array_Section_1_Height = getArraySection1.offsetHeight;

    if (dragY >= 0 && dragY < Array_Section_1_Height) {
      dragY = 0;
      service.height = (Array_Section_1_Height + 16.7857142858) * pixelPerInch; //top border 13.3928571429 + half bottom border 3.39285714286
    } else if (
      dragY > Array_Section_1_Height + 13.3928571429 &&
      dragY < Array_Section_1_Height + 13.3928571429 + ARRAY.SECTION_2_HEIGHT
    ) {
      dragY = Array_Section_1_Height + 16.7857142858; ////top border 13.3928571429 + half bottom border 3.39285714286 +half  upper border
      service.height = (ARRAY.SECTION_2_HEIGHT + 6.78571428571) * pixelPerInch;
    } else if (
      dragY >
        Array_Section_1_Height +
          13.3928571429 +
          ARRAY.SECTION_2_HEIGHT +
          13.5714285714 && ////top border 13.3928571429 + mid border 6.78571428571+ half bottom border 3.39285714286 +half  upper border
      dragY <
        Array_Section_1_Height +
          13.3928571429 +
          ARRAY.SECTION_2_HEIGHT +
          13.5714285714 +
          ARRAY.SECTION_3_HEIGHT
    ) {
      dragY = Array_Section_1_Height + ARRAY.SECTION_2_HEIGHT + 23.5714285715;
      service.height = (ARRAY.SECTION_3_HEIGHT + 16.7857142858) * pixelPerInch;
    }
  }

  let newPosition = { x: nearestValue, y: dragY };

  const serviceOverlaping = checkAccessorieRailOverlap(
    accessory_rails,
    service,
    newPosition
    // "unimount"
  );
  if (serviceOverlaping) {
    warningAlert("Sorry, you cannot place unimount rail here.");
    dropLocation = false;
    return;
  }
  dragPositions.current = newPosition;
  return dropLocation;
};

//for axiom ,array and compass
const checkSurfaceMountedRailDrop = (
  service,
  dragPositions,
  dropLocation,
  accessory_rails,
  railDimensionsRef,
  rails,
  model,
  values,
  railIndex
) => {
  const dragServiceHeight = service.height / pixelPerInch;
  const dragServiceWidth = service.width / pixelPerInch;
  const dragX = dragPositions.current?.x;
  const dragY = dragPositions.current?.y;
  const outerDivWidth = railDimensionsRef.current.parentWidth;
  const outerDivHeight = railDimensionsRef.current.parentHeight;
  const spaceMarginFromService = 17.8571428571;
  let newPosition = { x: dragX, y: dragY };
  const { ceiling_height, width, headwalls } = values;

  //to check with whom existing service ,the service is overlapped
  let overlappedService = {};
  const Buffer = 35.7142857143; //2 inches from bottom and top of each section for array and compass
  let xAxisRanges = [];
  let ranges = [];

  if (model === PRODUCT.COMPASS)
    ranges = generateDropRestrictedRanges(COMPASS, Buffer, model);
  else if (model === PRODUCT.ARRAY) {
    const getArraySection1 = document.getElementById("array-section-1");
    const newObj = Object.assign(
      { SECTION_1_HEIGHT: getArraySection1.offsetHeight },
      ARRAY
    );
    // ARRAY["SECTION_1_HEIGHT"] = getArraySection1.offsetHeight;
    ranges = generateDropRestrictedRanges(newObj, Buffer, model);
  } else if (model === PRODUCT.AXIOM) {
    const axiom_height = Math.round(
      (ceiling_height.ft * 12 + ceiling_height.in - 12.63) / pixelPerInch //12.63 from bottom
    );
    ranges = [{ start: axiom_height - 13.5, end: axiom_height }];
    xAxisRanges = calculateAxiomXAxisRanges(headwalls, width);
  }
  if (service.accessories.length) {
    warningAlert("Sorry, you cannot move rail with accessories over it.");
    dropLocation = false;
    return;
  }

  const notInYaxisRange = ranges.some(
    (range) =>
      (newPosition.y >= range.start && newPosition.y <= range.end) ||
      (model === PRODUCT.AXIOM &&
        newPosition.y + dragServiceHeight >= range.start)
  );
  if (notInYaxisRange) {
    warningAlert("Sorry, you cannot place rail in non droppable area.");
    dropLocation = false;
    return;
  }

  //checking and assigning new positions if service overlaps any of accessorie service on panel
  Object.keys(accessory_rails).forEach((railKey) => {
    const railData = accessory_rails[railKey] || [];
    for (let i = 0; i < railData.length; i++) {
      //dimensions of services dropped on rail
      const serviceHeight = railData[i].height / pixelPerInch;
      const serviceWidth = railData[i].width / pixelPerInch;
      const serviceX = railData[i].positions.x;
      const serviceY = railData[i].positions.y;
      const serviceType = railData[i].type;
      if (service.u_id !== railData[i].u_id) {
        if (
          newPosition.x >= serviceX &&
          newPosition.x <= serviceX + serviceWidth &&
          ((newPosition.y >= serviceY &&
            newPosition.y <= serviceY + serviceHeight) ||
            (newPosition.y + dragServiceHeight >= serviceY &&
              newPosition.y + dragServiceHeight <= serviceY + serviceHeight))
        ) {
          newPosition["x"] =
            serviceType === service.type
              ? serviceX + serviceWidth
              : serviceX + serviceWidth + spaceMarginFromService;
          newPosition["y"] =
            serviceType === "unimount" || railData[i]?.mount_type === "direct"
              ? newPosition.y
              : serviceY;
          overlappedService["touched"] = "right";
          overlappedService["service"] = railData[i];
          break;
        } else if (
          newPosition.x < serviceX &&
          newPosition.x + dragServiceWidth >= serviceX &&
          newPosition.x + dragServiceWidth <= serviceX + serviceWidth &&
          newPosition.y >= serviceY &&
          newPosition.y <= serviceY + serviceHeight
        ) {
          newPosition["x"] =
            serviceType === service.type
              ? serviceX - dragServiceWidth
              : serviceX - dragServiceWidth - spaceMarginFromService;
          newPosition["y"] =
            serviceType === "unimount" || railData[i]?.mount_type === "direct"
              ? newPosition.y
              : serviceY;
          overlappedService["touched"] = "left";
          overlappedService["service"] = railData[i];
          break;
        }
      }
    }
  });

  if (!Object.keys(overlappedService).length && model === PRODUCT.AXIOM) {
    const firstPanelStartPoint = xAxisRanges[0].start;
    const firstPanelendPoint = xAxisRanges[0].end;
    const secondPanelStartPoint = xAxisRanges[1]?.start;
    const secondPanelEndPoint = xAxisRanges[1]?.end;
    // to adjust the slide position on the corners of the axiom
    if (dragX < firstPanelStartPoint) {
      newPosition.x = firstPanelStartPoint;
    } else if (
      !secondPanelStartPoint &&
      dragX > firstPanelStartPoint &&
      dragX + dragServiceWidth > firstPanelendPoint
    ) {
      newPosition.x = firstPanelendPoint - dragServiceWidth;
    } else if (
      secondPanelStartPoint &&
      dragX > firstPanelStartPoint &&
      dragX + dragServiceWidth > firstPanelendPoint &&
      dragX < secondPanelStartPoint &&
      dragX + dragServiceWidth < secondPanelStartPoint
    ) {
      newPosition.x = firstPanelendPoint - dragServiceWidth;
    } else if (dragX > firstPanelendPoint && dragX < secondPanelStartPoint) {
      newPosition.x = secondPanelStartPoint;
    } else if (
      dragX > secondPanelStartPoint &&
      dragX + dragServiceWidth > secondPanelEndPoint
    ) {
      newPosition.x = secondPanelEndPoint - dragServiceWidth;
    }
  }

  if (model === PRODUCT.AXIOM) {
    //for axiom panel
    const inXAxisRange =
      xAxisRanges[railIndex] &&
      (newPosition.x < xAxisRanges[railIndex].start ||
        newPosition.x + dragServiceWidth > xAxisRanges[railIndex].end);

    if (inXAxisRange) {
      warningAlert("Sorry, you cannot place rail in a non-droppable area.");
      dropLocation = false;
      return;
    }
  }
  //check with other rail services
  const findRailServicesInRangeWithAccessorieRail = findSamePositionServices(
    rails,
    newPosition,
    dragServiceWidth,
    dragServiceHeight,
    model,
    ceiling_height,
    width
  );
  // console.log({findRailServicesInRangeWithAccessorieRail})
  for (let serv of findRailServicesInRangeWithAccessorieRail) {
    let serviceWidth;
    if (
      model === PRODUCT.AXIOM &&
      serv.category === "Medical Gas Outlet" &&
      !serv?.is_slide
    )
      serviceWidth = (serv.width + 2.375) / pixelPerInch;
    //2.375 for side margins
    else serviceWidth = serv.width / pixelPerInch;
    const serviceHeight = serv.height / pixelPerInch;
    const serviceX = serv.positions.x;
    const serviceY = serv.positions.y;
    if (dragX >= serviceX && dragX <= serviceX + serviceWidth) {
      newPosition["x"] = serviceX + serviceWidth + spaceMarginFromService;
      break;
    } else if (
      dragX + dragServiceWidth > serviceX &&
      dragX + dragServiceWidth <= serviceX + serviceWidth
    ) {
      newPosition["x"] = serviceX - dragServiceWidth - spaceMarginFromService;
      break;
    } else if (dragY > serviceY - spaceMarginFromService && dragY < serviceY) {
      newPosition["y"] = serviceY - dragServiceWidth - spaceMarginFromService;
      break;
    } else if (
      dragY > serviceY + serviceHeight &&
      dragY < serviceY + serviceHeight + spaceMarginFromService
    ) {
      newPosition["y"] = serviceY + serviceHeight + spaceMarginFromService;
      break;
    }
  }

  if (
    newPosition.x + dragServiceWidth > outerDivWidth || // Exceeds outer div width
    newPosition.y + dragServiceHeight > outerDivHeight || // Exceeds outer div height
    newPosition.x < 0 || // x is less than 0
    newPosition.y < 0
  ) {
    // y is less than 0
    warningAlert("Sorry, you cannot place rail here.");
    dropLocation = false;
    return;
  }

  //accessorie rail overlaping over other accessorie rail
  const accessorieRailOverlapping = checkAccessorieRailOverlap(
    accessory_rails,
    service,
    newPosition
  );
  // console.log({ accessorieRailOverlapping });
  const accessorieRailServiceOverlapping =
    checkAccessorieRailOverlappingServices(
      findRailServicesInRangeWithAccessorieRail,
      service,
      newPosition
    );
  // console.log({ accessorieRailServiceOverlapping });
  if (accessorieRailOverlapping || accessorieRailServiceOverlapping) {
    warningAlert(
      accessorieRailOverlapping
        ? "Sorry, you cannot place rail here."
        : "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides"
    );
    dropLocation = false;
    return;
  }
  // if accessory rail overlaping with any of other rail then update the existing rail's width
  //ca be added only if type of both the rails are same
  if (
    Object.values(overlappedService).length > 0 &&
    overlappedService.service.type === service.type
  ) {
    if (overlappedService.touched === "right") {
      overlappedService.service.width += service.width; //adding increase the width of current accessory rail
    } else if (overlappedService.touched === "left") {
      overlappedService.service.width += service.width;
      overlappedService.service.positions.x = newPosition.x;
      overlappedService.service.positions.y = newPosition.y;
      overlappedService.service.x_distance_inches =
        newPosition.x * pixelPerInch;
      overlappedService.service.y_distance_inches =
        newPosition.y * pixelPerInch;
    }
    if (service.u_id) {
      const serviceIndex = accessory_rails[service.type].findIndex(
        (serv) => serv.u_id === service.u_id
      );
      if (serviceIndex !== -1)
        accessory_rails[service.type].splice(serviceIndex, 1);
      service = overlappedService.service;
    }
    return;
  }

  dragPositions.current = newPosition;
  return dropLocation;
};

const checkEmbeddedRailDrop = (
  service,
  dragPositions,
  dropLocation,
  accessory_rails,
  rails,
  model,
  values
) => {
  const { ceiling_height } = values;
  const dragServiceHeight = service.height / pixelPerInch;
  const dragServiceWidth = service.width / pixelPerInch;
  let dragX = dragPositions.current?.x;
  let dragY = dragPositions.current?.y;
  let newPosition = { x: dragX, y: dragY };
  let overlappedService = {};
  const spaceMarginFromService = 17.8571428571; //to manage 1 inch margin from both sides
  const Buffer = 53.5714285714; // 3 inches from top and bottom of each section
  // Define the ranges to check in which portion of the panel user cant't drop rails
  let nonDroppableAreaforY = [];
  // let manageServiceY = {};
  let onArrayBorder = false;

  // Populate valid boundaries for panels
  if (model === PRODUCT.ARRAY) {
    let cumulativeWidth = 0;
    let tempX = 0;
    let tempWidth = 0;
    const bordersBuffer = {
      0: 3,
      1: 9,
      2: 15,
      3: 21,
      4: 27,
    };

    for (let i = 0; i <= rails.length; i++) {
      tempX = cumulativeWidth + bordersBuffer[i];
      cumulativeWidth += (rails[i].width * 12) / pixelPerInch;

      if (dragX < cumulativeWidth) {
        tempWidth = rails[i].width;
        break; // Exit loop when condition is met
      }
    }

    //to place embedded rail on the borders of panels in horizontal

    const getArraySection1 = document.getElementById("array-section-1");
    const Array_Section_1_Height = getArraySection1.offsetHeight;
    if (
      dragY <= Array_Section_1_Height &&
      dragY + dragServiceHeight >= Array_Section_1_Height
    ) {
      dragY = Array_Section_1_Height;
      newPosition["x"] = tempX;
      service.width = tempWidth;
      onArrayBorder = true;
    } else if (
      dragY <= Array_Section_1_Height + ARRAY.SECTION_2_HEIGHT &&
      dragY + dragServiceHeight >=
        Array_Section_1_Height + ARRAY.SECTION_2_HEIGHT
    ) {
      dragY = Array_Section_1_Height + ARRAY.SECTION_2_HEIGHT;
      newPosition["x"] = tempX;
      service.width = tempWidth * 12;
      onArrayBorder = true;
    }
  }

  if (model === PRODUCT.COMPASS)
    nonDroppableAreaforY = generateDropRestrictedRanges(COMPASS, Buffer, model);
  else if (model === PRODUCT.ARRAY) {
    const getArraySection1 = document.getElementById("array-section-1");
    // ARRAY["SECTION_1_HEIGHT"] = getArraySection1.offsetHeight;
    const newObj = Object.assign(
      { SECTION_1_HEIGHT: getArraySection1.offsetHeight },
      ARRAY
    );
    nonDroppableAreaforY = generateDropRestrictedRanges(newObj, Buffer, model);
  }
  if (service.accessories.length) {
    warningAlert("Sorry, you cannot move rail with accessories over it.");
    dropLocation = false;
    return;
  }

  const droppableAreaforX = calculateRanges(rails, model);
  //checking and assigning new positions if service overlaps any of accessorie service on panel
  Object.keys(accessory_rails).forEach((railKey) => {
    const railData = accessory_rails[railKey] || [];
    for (let i = 0; i < railData.length; i++) {
      //dimensions of services dropped on rail
      const serviceHeight = railData[i].height / pixelPerInch;
      const serviceWidth = railData[i].width / pixelPerInch;
      const serviceX = railData[i].positions.x;
      const serviceY = railData[i].positions.y;
      const serviceType = railData[i].type;
      if (service?.u_id !== railData[i].u_id) {
        if (
          newPosition.x >= serviceX &&
          newPosition.x <= serviceX + serviceWidth &&
          ((newPosition.y >= serviceY &&
            newPosition.y <= serviceY + serviceHeight) ||
            (newPosition.y + dragServiceHeight >= serviceY &&
              newPosition.y + dragServiceHeight <= serviceY + serviceHeight))
        ) {
          newPosition["x"] =
            serviceType === service.type
              ? serviceX + serviceWidth
              : serviceX + serviceWidth + spaceMarginFromService;
          newPosition["y"] = serviceY;
          overlappedService["touched"] = "right";
          overlappedService["service"] = railData[i];
          return;
        } else if (
          newPosition.x < serviceX &&
          newPosition.x + dragServiceWidth >= serviceX &&
          newPosition.x + dragServiceWidth <= serviceX + serviceWidth &&
          newPosition.y >= serviceY &&
          newPosition.y <= serviceY + serviceHeight
        ) {
          newPosition["x"] =
            serviceType === service.type
              ? serviceX - dragServiceWidth
              : serviceX - dragServiceWidth - spaceMarginFromService;
          newPosition["y"] = serviceY;
          overlappedService["touched"] = "left";
          overlappedService["service"] = railData[i];
          return;
        }
      }
    }
  });

  const serviceOverlaping = checkAccessorieRailOverlap(
    accessory_rails,
    service,
    newPosition
  );
  if (serviceOverlaping) {
    warningAlert("Sorry, you cannot place embedded rail here.");
    dropLocation = false;
    return;
  }

  //check with other rail services
  const findRailServicesInRangeWithAccessorieRail = findSamePositionServices(
    rails,
    newPosition,
    dragServiceWidth,
    dragServiceHeight,
    model,
    ceiling_height
    // manageServiceY
  );

  // console.log({ findRailServicesInRangeWithAccessorieRail });
  for (let serv of findRailServicesInRangeWithAccessorieRail) {
    const serviceWidth = serv.width / pixelPerInch;
    const serviceHeight = serv.height / pixelPerInch;
    const serviceX = serv.positions.x;
    // const serviceY = service.positions.y;
    const serviceY = serv.positions.y;

    if (dragX >= serviceX && dragX <= serviceX + serviceWidth) {
      newPosition["x"] = serviceX + serviceWidth + spaceMarginFromService;
      break;
    } else if (
      dragX + dragServiceWidth > serviceX &&
      dragX + dragServiceWidth <= serviceX + serviceWidth
    ) {
      newPosition["x"] = serviceX - dragServiceWidth - spaceMarginFromService;
      break;
    } else if (dragY > serviceY - spaceMarginFromService && dragY < serviceY) {
      newPosition["y"] = serviceY - dragServiceWidth - spaceMarginFromService;
      break;
    } else if (
      dragY > serviceY + serviceHeight &&
      dragY < serviceY + serviceHeight + spaceMarginFromService
    ) {
      newPosition["y"] = serviceY + serviceHeight + spaceMarginFromService;
      break;
    }
  }

  if (!onArrayBorder) {
    const yInRange = nonDroppableAreaforY.some(
      (range) => newPosition.y >= range.start && newPosition.y <= range.end
    );

    const xInRange = droppableAreaforX.some(
      (range) =>
        newPosition.x >= range.start &&
        newPosition.x + dragServiceWidth <= range.end
    );

    if (yInRange || !xInRange) {
      warningAlert("Sorry, you cannot place rail in non droppable area.");
      dropLocation = false;
      return;
    }
  }

  //accessorie rail overlaping over other accessorie rail
  const accessorieRailOverlapping = checkAccessorieRailOverlap(
    accessory_rails,
    service,
    newPosition
  );
  // console.log({ accessorieRailOverlapping });
  const accessorieRailServiceOverlapping =
    checkAccessorieRailOverlappingServices(
      findRailServicesInRangeWithAccessorieRail,
      service,
      newPosition
    );
  // console.log({ accessorieRailServiceOverlapping });
  if (accessorieRailOverlapping || accessorieRailServiceOverlapping) {
    warningAlert(
      accessorieRailOverlapping
        ? "Sorry, you cannot place rail here."
        : "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides"
    );
    dropLocation = false;
    return;
  }

  // if accessory rail overlaping with any of other rail then update the existing rail's width
  if (
    Object.values(overlappedService).length > 0 &&
    overlappedService.service.type === service.type
  ) {
    if (overlappedService.touched === "right") {
      overlappedService.service.width += service.width; //adding  to increase the widht of current accessory rail
    } else if (overlappedService.touched === "left") {
      overlappedService.service.width += service.width;
      overlappedService.service.positions.x = newPosition.x;
      overlappedService.service.positions.y = newPosition.y;
      overlappedService.service.x_distance_inches =
        newPosition.x * pixelPerInch;
      overlappedService.service.y_distance_inches =
        newPosition.y * pixelPerInch;
    }
    if (service.u_id) {
      const serviceIndex = accessory_rails[service.type].findIndex(
        (serv) => serv.u_id === service.u_id
      );
      if (serviceIndex !== -1)
        accessory_rails[service.type].splice(serviceIndex, 1);
      service = overlappedService.service;
    }
    return;
  }

  dragPositions.current = newPosition;
  return dropLocation;
};

//for infinity
const checkInfinitySurfaceMountedRailDrop = (
  service,
  dragPositions,
  dropLocation,
  accessory_rails,
  railDimensionsRef,
  rails,
  model,
  values
) => {
  const dragServiceHeight = service.height / pixelPerInch;
  const dragServiceWidth = service.width / pixelPerInch;
  const dragX = dragPositions.current?.x;
  const dragY = dragPositions.current?.y;
  const outerDivWidth = railDimensionsRef.current.parentWidth;
  const outerDivHeight = railDimensionsRef.current.parentHeight;
  const spaceMarginFromService = 17.8571428571;
  let newPosition = { x: dragX, y: dragY };
  const { ceiling_height, headwalls } = values;

  //to check with whom existing service ,the service is overlapped
  let overlappedService = {};

  const y_axis_ranges = calculateYRestictRanges(headwalls, ceiling_height);

  const notInYaxisRange = y_axis_ranges.some(
    (range) =>
      (newPosition.y >= range.start && newPosition.y <= range.end) ||
      (newPosition.y <= range.start &&
        newPosition.y + dragServiceHeight > range.start)
  );
  if (notInYaxisRange) {
    warningAlert("Sorry, you cannot place rail in non droppable area.");

    dropLocation = false;
    return;
  }
  if (service.accessories.length) {
    warningAlert("Sorry, you cannot move rail with accessories over it.");
    dropLocation = false;
    return;
  }

  //checking and assigning new positions if service overlaps any of accessorie service on panel

  const railData = accessory_rails["surface_mounted"] || [];
  for (let i = 0; i < railData.length; i++) {
    //dimensions of services dropped on rail
    const serviceHeight = railData[i].height / pixelPerInch;
    const serviceWidth = railData[i].width / pixelPerInch;
    const serviceX = railData[i].positions.x;
    const serviceY = railData[i].positions.y;
    const serviceType = railData[i].type;
    if (service.u_id !== railData[i].u_id) {
      if (
        newPosition.x >= serviceX &&
        newPosition.x <= serviceX + serviceWidth &&
        ((newPosition.y >= serviceY &&
          newPosition.y <= serviceY + serviceHeight) ||
          (newPosition.y + dragServiceHeight >= serviceY &&
            newPosition.y + dragServiceHeight <= serviceY + serviceHeight))
      ) {
        newPosition["x"] =
          serviceType === service.type
            ? serviceX + serviceWidth
            : serviceX + serviceWidth + spaceMarginFromService;
        newPosition["y"] =
          serviceType === "unimount" || railData[i]?.mount_type === "direct"
            ? newPosition.y
            : serviceY;
        overlappedService["touched"] = "right";
        overlappedService["service"] = railData[i];
        break;
      } else if (
        newPosition.x < serviceX &&
        newPosition.x + dragServiceWidth >= serviceX &&
        newPosition.x + dragServiceWidth <= serviceX + serviceWidth &&
        newPosition.y >= serviceY &&
        newPosition.y <= serviceY + serviceHeight
      ) {
        newPosition["x"] =
          serviceType === service.type
            ? serviceX - dragServiceWidth
            : serviceX - dragServiceWidth - spaceMarginFromService;
        newPosition["y"] =
          serviceType === "unimount" || railData[i]?.mount_type === "direct"
            ? newPosition.y
            : serviceY;
        overlappedService["touched"] = "left";
        overlappedService["service"] = railData[i];
        break;
      }
    }
  }

  if (
    newPosition.x + dragServiceWidth > outerDivWidth || // Exceeds outer div width
    newPosition.y + dragServiceHeight > outerDivHeight || // Exceeds outer div height
    newPosition.x < 0 || // x is less than 0
    newPosition.y < 0
  ) {
    // y is less than 0
    warningAlert("Sorry, you cannot place rail here.");
    dropLocation = false;
    return;
  }

  // //accessorie rail overlaping over other accessorie rail
  const accessorieRailOverlapping = checkAccessorieRailOverlap(
    accessory_rails,
    service,
    newPosition
  );

  if (accessorieRailOverlapping) {
    warningAlert(
      accessorieRailOverlapping
        ? "Sorry, you cannot place rail here."
        : "Not enough space between services to place a rail. Minimum distance should be 1 inches from both sides"
    );
    dropLocation = false;
    return;
  }
  // if accessory rail overlaping with any of other rail then update the existing rail's width
  //ca be added only if type of both the rails are same
  if (
    Object.values(overlappedService).length > 0 &&
    overlappedService.service.type === service.type
  ) {
    if (overlappedService.touched === "right") {
      overlappedService.service.width += service.width; //adding increase the width of current accessory rail
    } else if (overlappedService.touched === "left") {
      overlappedService.service.width += service.width;
      overlappedService.service.positions.x = newPosition.x;
      overlappedService.service.positions.y = newPosition.y;
      overlappedService.service.x_distance_inches =
        newPosition.x * pixelPerInch;
      overlappedService.service.y_distance_inches =
        newPosition.y * pixelPerInch;
    }
    if (service.u_id) {
      const serviceIndex = accessory_rails[service.type].findIndex(
        (serv) => serv.u_id === service.u_id
      );
      if (serviceIndex !== -1)
        accessory_rails[service.type].splice(serviceIndex, 1);
      service = overlappedService.service;
    }
    return;
  }

  dragPositions.current = newPosition;
  return dropLocation;
};

//calculate restirct ranges for ininity accessorie rails

const calculateYRestictRanges = (headwalls, ceiling_height) => {
  let restrictRangesArray = [];
  const { ft, in: inch } = ceiling_height;
  const panelHeight = (ft * 12 + inch) / pixelPerInch;
  const railWidth = 156.25; //8.75inch
  const safeMargin = 107.142857143;
  if (headwalls.length === 3) {
    restrictRangesArray.push({
      start: panelHeight - 12 / pixelPerInch - railWidth - safeMargin, //12 inch margin of bottom rail from bottom
      end: panelHeight,
    });
    restrictRangesArray.push({
      start: panelHeight - 42 / pixelPerInch - railWidth - safeMargin, //42 inch margin of middle rail from bottom
      end: panelHeight - 36 / pixelPerInch,
    });
    restrictRangesArray.push({
      start: panelHeight - 66 / pixelPerInch - railWidth - safeMargin, // 66 inch margin of top rail from bottom
      end: panelHeight - 60 / pixelPerInch,
    });
    // 6 inch margin from top
    restrictRangesArray.push({ start: 0, end: 6 / pixelPerInch });
  } else if (headwalls.length === 2) {
    const railPosition = headwalls.find(
      (h) => h.position === "top" || h.position === "bottom"
    )?.position;

    if (railPosition === "top") {
      restrictRangesArray.push({
        start: panelHeight - 12, //12 inch margin of bottom rail from bottom
        end: panelHeight,
      });
      restrictRangesArray.push({
        start: panelHeight - 66 / pixelPerInch - railWidth - safeMargin, // 66 inch margin of top rail from bottom
        end: panelHeight - 60 / pixelPerInch,
      });
    } else if (railPosition === "bottom")
      restrictRangesArray.push({
        start: panelHeight - 12 / pixelPerInch - railWidth - safeMargin, //12 inch margin of bottom rail from bottom
        end: panelHeight,
      });

    restrictRangesArray.push({
      start: panelHeight - 42 / pixelPerInch - railWidth - safeMargin, //42 inch margin of middle rail from bottom
      end: panelHeight - 36 / pixelPerInch,
    });

    // 6 inch margin from top
    restrictRangesArray.push({ start: 0, end: 6 / pixelPerInch });
  } else if (headwalls.length === 1) {
    restrictRangesArray.push({
      start: panelHeight - 6 / pixelPerInch, //12 inch margin of bottom rail from bottom
      end: panelHeight,
    });

    restrictRangesArray.push({
      start: panelHeight - 42 / pixelPerInch - railWidth - safeMargin, //42 inch margin of middle rail from bottom
      end: panelHeight - 36 / pixelPerInch,
    });

    // 6 inch margin from top
    restrictRangesArray.push({ start: 0, end: 6 / pixelPerInch });
  }
  return restrictRangesArray;
};

//calculate restirct ranges for ininity accessories

const calculateYRestictRangesForRailAccessories = (
  headwalls,
  ceiling_height
) => {
  let restrictRangesArray = [];
  const { ft, in: inch } = ceiling_height;
  const panelHeight = (ft * 12 + inch) / pixelPerInch;
  const railWidth = 156.25; //8.75inch
  if (headwalls.length === 3) {
    restrictRangesArray.push({
      start: panelHeight - 12 / pixelPerInch - railWidth, //12 inch margin of bottom rail from bottom
      end: panelHeight,
    });
    restrictRangesArray.push({
      start: panelHeight - 42 / pixelPerInch - railWidth, //42 inch margin of middle rail from bottom
      end: panelHeight - 42 / pixelPerInch,
    });
    restrictRangesArray.push({
      start: panelHeight - 66 / pixelPerInch - railWidth, // 66 inch margin of top rail from bottom
      end: panelHeight - 66 / pixelPerInch,
    });
    // 6 inch margin from top
    restrictRangesArray.push({ start: 0, end: 0 });
  } else if (headwalls.length === 2) {
    const railPosition = headwalls.find(
      (h) => h.position === "top" || h.position === "bottom"
    )?.position;

    if (railPosition === "top") {
      restrictRangesArray.push({
        start: panelHeight - 12, //12 inch margin of bottom rail from bottom
        end: panelHeight,
      });
      restrictRangesArray.push({
        start: panelHeight - 66 / pixelPerInch - railWidth, // 66 inch margin of top rail from bottom
        end: panelHeight - 66 / pixelPerInch,
      });
    } else if (railPosition === "bottom")
      restrictRangesArray.push({
        start: panelHeight - 12 / pixelPerInch - railWidth, //12 inch margin of bottom rail from bottom
        end: panelHeight,
      });

    restrictRangesArray.push({
      start: panelHeight - 42 / pixelPerInch - railWidth, //42 inch margin of middle rail from bottom
      end: panelHeight - 42 / pixelPerInch,
    });

    // 6 inch margin from top
    restrictRangesArray.push({ start: 0, end: 0 });
  } else if (headwalls.length === 1) {
    restrictRangesArray.push({
      start: panelHeight - 6 / pixelPerInch, //12 inch margin of bottom rail from bottom
      end: panelHeight,
    });

    restrictRangesArray.push({
      start: panelHeight - 42 / pixelPerInch - railWidth, //42 inch margin of middle rail from bottom
      end: panelHeight - 42 / pixelPerInch,
    });

    // 6 inch margin from top
    restrictRangesArray.push({ start: 0, end: 0 });
  }
  return restrictRangesArray;
};

//calculate droppable infinity borders for rail accessories
const droppableInfinityBorderRanges = (headwalls, ceiling_height) => {
  let restrictRangesArray = [];
  const { ft, in: inch } = ceiling_height;
  const panelHeight = (ft * 12 + inch) / pixelPerInch;
  const railWidth = 156.25; //8.75inch
  if (headwalls.length === 3) {
    restrictRangesArray.unshift({
      start: panelHeight - 12 / pixelPerInch - railWidth, //12 inch margin of bottom rail from bottom
      end: panelHeight - 12 / pixelPerInch,
    });
    restrictRangesArray.unshift({
      start: panelHeight - 42 / pixelPerInch - railWidth, //42 inch margin of middle rail from bottom
      end: panelHeight - 42 / pixelPerInch,
    });
    restrictRangesArray.unshift({
      start: panelHeight - 66 / pixelPerInch - railWidth, // 66 inch margin of top rail from bottom
      end: panelHeight - 66 / pixelPerInch,
    });
  } else if (headwalls.length === 2) {
    const railPosition = headwalls.find(
      (h) => h.position === "top" || h.position === "bottom"
    )?.position;

    if (railPosition === "top") {
      restrictRangesArray.unshift({
        start: panelHeight - 66 / pixelPerInch - railWidth, // 66 inch margin of top rail from bottom
        end: panelHeight - 66 / pixelPerInch,
      });
    } else if (railPosition === "bottom")
      restrictRangesArray.unshift({
        start: panelHeight - 12 / pixelPerInch - railWidth, //12 inch margin of bottom rail from bottom
        end: panelHeight - 12,
      });

    restrictRangesArray.unshift({
      start: panelHeight - 42 / pixelPerInch - railWidth, //42 inch margin of middle rail from bottom
      end: panelHeight - 42 / pixelPerInch,
    });
  } else if (headwalls.length === 1) {
    restrictRangesArray.unshift({
      start: panelHeight - 42 / pixelPerInch - railWidth, //42 inch margin of middle rail from bottom
      end: panelHeight - 42 / pixelPerInch,
    });
  }
  return restrictRangesArray;
};

//calculate droppable eloquence borders for slide
const droppableEloquenceBorderRanges = (headwalls) => {
  const railCount = headwalls.length;
  const RAIL_HEIGHT = 86.45;
  const TOP_BOTTOM_BORDER = 49.1071428571;
  const MIDDLE_BORDER = 44.6428571429;

  const areas = [];

  // Top border
  let start = 0;
  let end = TOP_BOTTOM_BORDER;
  areas.push({ start, end });

  // Track current Y
  let y = TOP_BOTTOM_BORDER;

  // Middle borders (after each rail except last)
  for (let i = 0; i < railCount - 1; i++) {
    y += RAIL_HEIGHT; // move past rail
    start = y;
    end = y + MIDDLE_BORDER;
    areas.push({ start, end });
    y = end; // move past middle border
  }

  // Bottom border
  start = y + RAIL_HEIGHT;
  end = start + TOP_BOTTOM_BORDER;
  areas.push({ start, end });

  return areas;
};

//getting dropable area for x-axis compass and array embedded rail
function calculateRanges(numberOfSections, model) {
  // Convert inches to pixels
  const pixelsPerInch = pixelPerInch; // Assuming pixelPerInch
  const gapInPixels = 53.5714285714; // 3 inches from both sides

  // Create ranges
  const ranges = [];
  let cumulativeWidth = 0; // Tracks the cumulative width of all previous sections

  for (let i = 0; i < numberOfSections.length; i++) {
    const sectionWidthInPixels =
      model === PRODUCT.COMPASS
        ? numberOfSections[i].width / pixelsPerInch
        : (numberOfSections[i].width * 12) / pixelsPerInch;

    // Calculate start and end ranges, including cumulative widths
    const start = cumulativeWidth + gapInPixels;
    const end = cumulativeWidth + sectionWidthInPixels - gapInPixels;

    ranges.push({ start, end });

    // Update cumulative width for the next section
    cumulativeWidth += sectionWidthInPixels;
  }

  return ranges;
}

//getting dropable area for x-axis for axiom
function calculateAxiomXAxisRanges(numberOfSections, width) {
  // Convert inches to pixels
  const pixelsPerInch = pixelPerInch; // Assuming pixelPerInch
  const gapInPixels = 31.3392857142;

  // Create ranges
  const ranges = [];
  let cumulativeWidth = 0; // Tracks the cumulative width of all previous sections
  const sectionWidthInPixels = (width.ft * 12 + width.in) / pixelsPerInch + 6;

  for (let i = 0; i < numberOfSections.length; i++) {
    // Calculate start and end ranges, including cumulative widths
    const start = cumulativeWidth + gapInPixels;
    const end = cumulativeWidth + sectionWidthInPixels - gapInPixels;

    ranges.push({ start, end });
    // Update cumulative width for the next section
    cumulativeWidth += sectionWidthInPixels + 1071.42857143;
  }

  return ranges;
}

// getting vertical restricted areas for surface and embedded rail
const generateDropRestrictedRanges = (obj, buffer, model) => {
  const initialArrayBorder = 13.3928571429; //13.3928571429 to adjust array top border
  const arraySectionGap = 6.78571428571; //6.78571428571 to manage gap between 2 sections
  const InitialBuffer =
    model === PRODUCT.ARRAY ? buffer + initialArrayBorder : buffer;
  let ranges = [{ start: 0, end: InitialBuffer }]; // Initial range from 0 to BUFFER

  let cumulativeHeight = 0;
  Object.values(obj).forEach((height, index) => {
    cumulativeHeight += height;
    ranges.push({
      start: cumulativeHeight - buffer,
      end:
        index === Object.keys(obj).length - 1
          ? cumulativeHeight
          : model === PRODUCT.COMPASS
          ? cumulativeHeight + buffer
          : cumulativeHeight + buffer + arraySectionGap + initialArrayBorder,
    });
  });

  return ranges;
};

const handleAccessorieRailDropLocation = (
  service,
  accessory_rails,
  dragPositions,
  dropArea
) => {
  const serviceIndex = accessory_rails[service.type]?.findIndex(
    (serv) => serv.u_id === service.u_id
  );

  let serviceRails = [...accessory_rails[service.type]];
  if (dropArea === "rail") {
    //if moving services on the rail
    if (service.u_id) {
      serviceRails[serviceIndex].height = service.height;
      serviceRails[serviceIndex].x_distance_inches =
        dragPositions.current.x * pixelPerInch;
      serviceRails[serviceIndex].y_distance_inches =
        dragPositions.current.y * pixelPerInch;
      serviceRails[serviceIndex].positions = dragPositions.current;
    }
    //if adding new service to the rail
    else {
      const newService = {
        ...service,
        x_distance_inches: dragPositions.current.x * pixelPerInch,
        y_distance_inches: dragPositions.current.y * pixelPerInch,
        positions: dragPositions.current,
        u_id: generateUniqueId(),
      };
      serviceRails = [...serviceRails, newService];
    }
    accessory_rails[service.type] = serviceRails;
  } else {
    //delete service from rail if dragged to the wall
    if (serviceIndex !== -1) serviceRails.splice(serviceIndex, 1);
  }
  return serviceRails;
};

const handleAccessoryDropLocation = (
  rails,
  accessory_rails,
  dragPositions,
  service,
  dropArea,
  railDimensionsRef,
  model,
  values,
  railIndex
) => {
  const { ceiling_height, width, headwalls, chased, chase_position } = values;
  const dragServiceWidth = service.width / pixelPerInch;
  const dragServiceHeight = service.height / pixelPerInch;
  const dragX = dragPositions.current?.x;
  const dragY = dragPositions.current?.y;
  let newPosition = { x: dragX, y: dragY };
  const spaceMarginFromService = 17.8571428571;
  const outerDivWidth = railDimensionsRef.current?.parentWidth;
  const outerDivHeight = railDimensionsRef.current?.parentHeight;
  // to match screw points of accessores
  const { offset_x, offset_y, offset_left_x } = service.hook_position;
  const serviceYOffset = offset_y / pixelPerInch;
  const serviceXOffset = offset_x / pixelPerInch;
  if (service.mount_type !== "direct") {
    //for array unimount rail
    if (model === PRODUCT.AXIOM && service.mount_type === "track") {
      if (dropArea === "rail") {
        const rails = [...headwalls];
        const ranges = [];
        const axiomBorder = 10.0892857143; //half border
        let cumulativeWidth = 0; // Tracks the cumulative width of all previous sections
        const sectionWidthInPixels = (width.ft * 12 + width.in) / pixelPerInch;
        for (let i = 0; i < rails.length; i++) {
          // Calculate start and end ranges, including cumulative widths
          const start = cumulativeWidth;
          const end = cumulativeWidth + sectionWidthInPixels;

          ranges.push({ start, end });
          // Update cumulative width for the next section
          cumulativeWidth += sectionWidthInPixels + 1071.42857143; //5ft bed space
        }
        // const firstPanelStartPoint = 20.0892857143;
        const firstPanelStartPoint = 0;
        const firstPanelEndPoint = ranges[0].end;
        const secondPanelStartPoint = ranges[1]?.start;
        const secondPanelEndPoint = ranges[1]?.end;
        const sectionMidPoint = sectionWidthInPixels / 2;
        const hook_position = service.hook_position.offset_x / pixelPerInch;
        // to find track accessories position on the corners of the axiom
        if (dragX >= firstPanelStartPoint && dragX <= sectionMidPoint) {
          newPosition.x = firstPanelStartPoint + axiomBorder - hook_position;
        } else if (
          // !secondPanelStartPoint &&
          dragX >= sectionMidPoint &&
          dragX <= firstPanelEndPoint
        ) {
          newPosition.x = firstPanelEndPoint - axiomBorder - hook_position;
        } else if (
          dragX > firstPanelEndPoint &&
          dragX <= secondPanelStartPoint + sectionMidPoint
        ) {
          newPosition.x = secondPanelStartPoint + axiomBorder - hook_position;
        } else if (
          dragX + dragServiceWidth > secondPanelStartPoint + sectionMidPoint &&
          dragX < secondPanelEndPoint
        ) {
          newPosition.x = secondPanelEndPoint - axiomBorder - hook_position;
        }

        let slideServices = findSamePositionSlideServices(
          rails,
          newPosition,
          width,
          railIndex
        );

        let accessories = [];

        if (newPosition.x <= sectionMidPoint) {
          accessories = accessory_rails["direct"].filter((accessory) => {
            return (
              accessory.mount_type === "track" &&
              accessory.positions.x < firstPanelStartPoint
            );
          });
        } else if (
          newPosition.x > firstPanelStartPoint &&
          newPosition.x <= firstPanelEndPoint
        ) {
          accessories = accessory_rails["direct"].filter((accessory) => {
            return (
              accessory.mount_type === "track" &&
              accessory.positions.x > firstPanelStartPoint + 20 && //20 in few cases some accessories have x greater than fistPanelStart point
              accessory.positions.x <= firstPanelEndPoint
            );
          });
        } else if (
          newPosition.x > firstPanelEndPoint &&
          newPosition.x < secondPanelStartPoint
        ) {
          accessories = accessory_rails["direct"].filter((accessory) => {
            return (
              accessory.mount_type === "track" &&
              accessory.positions.x > firstPanelEndPoint &&
              accessory.positions.x <= secondPanelStartPoint
            );
          });
        } else if (
          newPosition.x > secondPanelStartPoint &&
          newPosition.x < secondPanelEndPoint
        ) {
          accessories = accessory_rails["direct"].filter((accessory) => {
            return (
              accessory.mount_type === "track" &&
              accessory.positions.x > secondPanelStartPoint &&
              accessory.positions.x <= secondPanelEndPoint
            );
          });
        }
        console.log({ accessories });

        slideServices = slideServices?.length ? slideServices : [];
        const newServices = [...slideServices, ...accessories];

        const checkVerticalServicesOverLap = newServices?.some((serv) => {
          const serviceHeight = serv.height / pixelPerInch;
          return (
            serv.u_id !== service.u_id &&
            ((newPosition.y !== serv.positions?.y &&
              ((newPosition.y + dragServiceHeight > serv.positions?.y &&
                newPosition.y + dragServiceHeight <
                  serv.positions?.y + serviceHeight + spaceMarginFromService) ||
                (newPosition.y > serv.positions?.y &&
                  Math.round(newPosition.y) <
                    Math.round(
                      serv.positions?.y + serviceHeight + spaceMarginFromService
                    )))) ||
              newPosition.y === serv.positions?.y ||
              (newPosition.y > serv.positions?.y &&
                newPosition.y <
                  serv.positions?.y + serviceHeight + spaceMarginFromService) ||
              newPosition.y + dragServiceHeight >
                railDimensionsRef.current.parentHeight ||
              (newPosition.y < serv.positions?.y &&
                newPosition.y + dragServiceHeight >
                  serv.positions?.y + serviceHeight))
          );
        });
        if (checkVerticalServicesOverLap) {
          warningAlert(
            "Not enough space between services to place a accessory. Minimum distance should be 1 inches from both sides1"
          );
          return;
        }

        if (!service?.u_id) {
          const newService = {
            ...service,
            x_distance_inches: newPosition.x * pixelPerInch,
            y_distance_inches: newPosition.y * pixelPerInch,
            positions: newPosition,
            u_id: generateUniqueId(),
          };
          // ]; // Modify this line as needed
          accessory_rails["direct"] = [
            ...accessory_rails["direct"],
            newService,
          ]; // Update the accessory rails object
          return accessory_rails; // Return the updated object
        } else
          updateOrDeleteDirectAccessory(
            accessory_rails,
            service?.u_id,
            true,
            newPosition
          );
      } else {
        updateOrDeleteDirectAccessory(accessory_rails, service?.u_id);
      }
    } else if (model === PRODUCT.INFINITY && service.mount_type === "track") {
      if (dropArea === "rail") {
        const infinityBorder = 10.0892857143; //half border
        const chaseWidth = 247.857142857;
        const chaseBorderWidth = 29.1071428571;
        let x_axis_ranges = [];
        const chaseElement = document?.getElementById("infinity_chase");
        const getChaseRect = chaseElement?.getBoundingClientRect();
        if (chased && newPosition.y < getChaseRect?.height) {
          if (chase_position === "left")
            x_axis_ranges = [{ start: 0, end: chaseWidth }];
          else if (chase_position === "center") {
            const railTotalWidth =
              (width.ft * 12 + width.in) / pixelPerInch + chaseWidth;
            const midPoint = railTotalWidth / 2;
            x_axis_ranges = [
              {
                start: midPoint - 94.9107142857 - chaseBorderWidth,
                end: midPoint + 94.9107142857 + chaseBorderWidth,
              },
            ];
          }
          //94.9107142857 half of chase width;
          else if (chase_position === "right") {
            const railTotalWidth = (width.ft * 12 + width.in) / pixelPerInch;

            x_axis_ranges = [
              {
                start: railTotalWidth,
                end: railTotalWidth + chaseWidth,
              },
            ];
          }
        }

        let firstPanelStartPoint = x_axis_ranges[0]?.start;
        const firstPanelEndPoint = x_axis_ranges[0]?.end;
        const sectionMidPoint = (firstPanelStartPoint + firstPanelEndPoint) / 2;
        const hook_position = service.hook_position.offset_x / pixelPerInch;
        let accessories = [];
        if (
          (dragX >= firstPanelStartPoint ||
            dragX + dragServiceWidth > firstPanelStartPoint) &&
          dragX <= firstPanelEndPoint
        ) {
          // to find track accessories position on the corners of the ininity chase
          // if (
          //   (dragX > firstPanelStartPoint &&
          //     dragX + dragServiceWidth <= sectionMidPoint) ||
          //   (dragX <= firstPanelStartPoint &&
          //     dragX + dragServiceWidth >= firstPanelStartPoint)
          // ) {
          if (dragX > firstPanelStartPoint && dragX <= sectionMidPoint) {
            newPosition.x =
              firstPanelStartPoint + infinityBorder - hook_position;
          } else if (
            (dragX > sectionMidPoint && dragX < firstPanelEndPoint) ||
            (dragX < sectionMidPoint &&
              (dragX + dragServiceWidth <= firstPanelEndPoint ||
                dragX + dragServiceWidth >= firstPanelEndPoint))
          ) {
            newPosition.x = firstPanelEndPoint - infinityBorder - hook_position;
          }

          firstPanelStartPoint =
            service.name === "Single (3 hook)"
              ? firstPanelStartPoint + 21
              : firstPanelStartPoint;
          if (newPosition.x <= firstPanelStartPoint) {
            accessories = accessory_rails["direct"].filter((accessory) => {
              if (accessory.name === "Single (3 hook)") {
                return (
                  accessory.mount_type === "track" &&
                  accessory.positions.x < firstPanelStartPoint + 21
                );
              }
              return (
                accessory.mount_type === "track" &&
                accessory.positions.x < firstPanelStartPoint
              );
            });
          } else if (
            newPosition.x > firstPanelStartPoint &&
            newPosition.x <= firstPanelEndPoint
          ) {
            accessories = accessory_rails["direct"].filter((accessory) => {
              return (
                accessory.mount_type === "track" &&
                accessory.positions.x > firstPanelStartPoint &&
                accessory.positions.x <= firstPanelEndPoint
              );
            });
          }

          const checkVerticalServicesOverLap = accessories?.some((serv) => {
            const serviceHeight = serv.height / pixelPerInch;
            return (
              serv.u_id !== service.u_id &&
              ((newPosition.y !== serv.positions?.y &&
                ((newPosition.y + dragServiceHeight > serv.positions?.y &&
                  newPosition.y + dragServiceHeight <
                    serv.positions?.y +
                      serviceHeight +
                      spaceMarginFromService) ||
                  (newPosition.y > serv.positions?.y &&
                    Math.round(newPosition.y) <
                      Math.round(
                        serv.positions?.y +
                          serviceHeight +
                          spaceMarginFromService
                      )))) ||
                newPosition.y === serv.positions?.y ||
                (newPosition.y > serv.positions?.y &&
                  newPosition.y <
                    serv.positions?.y +
                      serviceHeight +
                      spaceMarginFromService) ||
                newPosition.y + dragServiceHeight >
                  railDimensionsRef.current.parentHeight ||
                (newPosition.y < serv.positions?.y &&
                  newPosition.y + dragServiceHeight >
                    serv.positions?.y + serviceHeight))
            );
          });
          if (checkVerticalServicesOverLap) {
            warningAlert(
              "Not enough space between services to place a accessory. Minimum distance should be 1 inches from both sides"
            );
            return;
          }

          if (!service?.u_id) {
            const newService = {
              ...service,
              x_distance_inches: newPosition.x * pixelPerInch,
              y_distance_inches: newPosition.y * pixelPerInch,
              positions: newPosition,
              u_id: generateUniqueId(),
            };
            // ]; // Modify this line as needed
            accessory_rails["direct"] = [
              ...accessory_rails["direct"],
              newService,
            ]; // Update the accessory rails object
            return accessory_rails; // Return the updated object
          } else
            updateOrDeleteDirectAccessory(
              accessory_rails,
              service?.u_id,
              true,
              newPosition
            );
        } else {
          warningAlert(
            "This accessory cannot be placed here. Please change the mount type to 'Direct' to proceed."
          );
          return;
        }
      } else {
        updateOrDeleteDirectAccessory(accessory_rails, service?.u_id);
      }
    } else {
      if (dropArea === "rail") {
        const serviceXRailOffset = offset_left_x / pixelPerInch;
        const result = Object.keys(accessory_rails).reduce((found, railKey) => {
          if (found) return found; // Stop iteration once an overlapping service is found
          const railData = accessory_rails[railKey] || [];
          //iteration over accessory rails to find on which accessory rail service is going to be dropped
          const overlappingIndex = railData.findIndex((existingService) => {
            const existingX = existingService.positions.x;
            const existingY = existingService.positions.y;
            const existingWidth = existingService.width / pixelPerInch;
            const existingHeight = existingService.height / pixelPerInch;

            const serviceX = dragPositions.current.x;
            const serviceY = dragPositions.current.y;
            const serviceWidth = service.width / pixelPerInch;
            const serviceHeight = service.height / pixelPerInch;

            const isXOverlap =
              (serviceX >= existingX &&
                serviceX + serviceWidth < existingX + existingWidth) ||
              (serviceX >= existingX &&
                serviceX <= existingX + existingWidth) ||
              (serviceX < existingX &&
                serviceX + serviceWidth > existingX + existingWidth) ||
              (serviceX < existingX && serviceX + serviceWidth > existingX);

            const isYOverlap =
              (serviceY < existingY &&
                serviceY + serviceHeight > existingY + existingHeight) ||
              (serviceY > existingY &&
                serviceY + serviceHeight < existingY + existingHeight) ||
              (serviceY <= existingY + existingHeight &&
                serviceY + serviceHeight >= existingY + existingHeight) ||
              // railKey !== "unimount" &&
              (serviceY <= existingY && serviceY + serviceHeight >= existingY);
            return isXOverlap && isYOverlap;
          });
          // adding new service on service rail
          if (overlappingIndex !== -1) {
            const railAccessories = railData[overlappingIndex].accessories;
            //for track accessories
            // check drop location for accessory or adjusting drop location
            if (
              railData[overlappingIndex].type === "unimount" &&
              service.mount_type === "track"
            ) {
              newPosition["x"] =
                railData[overlappingIndex].positions.x -
                // dragServiceWidth / 2 +
                serviceXOffset +
                10.265; //10 is equal to half of the width of the rail
              for (let i = 0; i < railAccessories.length; i++) {
                //dimensions of services dropped on rail
                if (service.u_id !== railAccessories[i]?.u_id) {
                  const serviceHeight =
                    railAccessories[i]?.height / pixelPerInch;
                  const serviceY = railAccessories[i]?.positions?.y;
                  if (
                    newPosition.y >= serviceY &&
                    newPosition.y <= serviceY + serviceHeight
                  ) {
                    newPosition["y"] =
                      serviceY + serviceHeight + spaceMarginFromService;
                    break;
                  } else if (
                    newPosition.y < serviceY &&
                    newPosition.y + dragServiceHeight >= serviceY &&
                    newPosition.y + dragServiceHeight <=
                      serviceY + serviceHeight
                  ) {
                    newPosition["y"] =
                      serviceY - dragServiceHeight - spaceMarginFromService;
                    break;
                  }
                }
              }
            }
            //for rail accessories
            else if (
              railData[overlappingIndex].type !== "unimount" &&
              service.mount_type === "rail"
            ) {
              newPosition["y"] =
                railData[overlappingIndex].positions.y - serviceYOffset + 20.53; //half of rail 10.26500
              for (let i = 0; i < railAccessories?.length; i++) {
                //dimensions of services dropped on rail
                if (service.u_id !== railAccessories[i]?.u_id) {
                  const serviceWidth = railAccessories[i]?.width / pixelPerInch;
                  const serviceX = railAccessories[i]?.positions?.x;
                  if (
                    newPosition.x >= serviceX &&
                    newPosition.x <= serviceX + serviceWidth
                  ) {
                    newPosition["x"] = serviceX + serviceWidth + 17.8571428571;
                    break;
                  } else if (
                    newPosition.x < serviceX &&
                    newPosition.x + dragServiceWidth >= serviceX &&
                    newPosition.x + dragServiceWidth <= serviceX + serviceWidth
                  ) {
                    newPosition["x"] =
                      serviceX - dragServiceWidth - 17.8571428571;
                    break;
                  }
                }
              }
            } else if (
              service.mount_type === "track" &&
              railData[overlappingIndex].type !== "unimount"
            ) {
              warningAlert(
                service.u_id
                  ? "Sorry, this accessory cannot be placed on a different mount type."
                  : "This accessory cannot be placed here. Please change the mount type to 'Rails' to proceed."
              );
              return accessory_rails;
            } else {
              warningAlert(
                service.u_id
                  ? "Sorry, this accessory cannot be placed on a different mount type."
                  : "This accessory cannot be placed here. Please change the mount type to 'Track' to proceed."
              );
              return accessory_rails;
            }
            //if x goes outside rail
            if (
              service.mount_type === "rail" &&
              (newPosition.x + serviceXRailOffset <
                railData[overlappingIndex].positions.x ||
                newPosition.x + serviceXRailOffset >
                  railData[overlappingIndex].positions.x +
                    railData[overlappingIndex].width / pixelPerInch ||
                newPosition.x + dragServiceWidth - serviceXRailOffset >
                  railData[overlappingIndex].positions.x +
                    railData[overlappingIndex].width / pixelPerInch ||
                newPosition.y <= 0)
            ) {
              warningAlert(
                "Sorry, you cannot place accessory here because accessory is going outside the rail"
              );
              return accessory_rails;
            }
            if (
              service.mount_type === "track" &&
              (newPosition.y + serviceYOffset <
                railData[overlappingIndex].positions.y ||
                newPosition.y + serviceYOffset >
                  railData[overlappingIndex].positions.y +
                    railData[overlappingIndex].height / pixelPerInch)
            ) {
              warningAlert(
                "Sorry, you cannot place accessory here because accessory is going outside the rail"
              );
              return accessory_rails;
            }

            // check accessory  is not overlaping with other accessories
            const checkAccessoryOverlap =
              checkAccessorieRailOverlappingServices(
                railAccessories,
                service,
                newPosition
              );

            const checkAccessoryOverlapingWithOtherAccessory =
              checkAccessoriesOverlap(accessory_rails, newPosition, service);

            if (model === PRODUCT.INFINITY) {
              const y_axis_ranges = calculateYRestictRangesForRailAccessories(
                headwalls,
                ceiling_height
              );
              const notInYaxisRange = y_axis_ranges.some(
                (range) =>
                  (newPosition.y >= range.start &&
                    newPosition.y <= range.end) ||
                  (newPosition.y <= range.start &&
                    newPosition.y + dragServiceHeight > range.start)
              );
              if (notInYaxisRange) {
                warningAlert(
                  "Sorry, you cannot place accessory here because it's overlaping with rail."
                );
                return accessory_rails;
              }
            }

            if (
              checkAccessoryOverlap ||
              checkAccessoryOverlapingWithOtherAccessory
            ) {
              warningAlert("Sorry, you cannot place accessory here.");
              return accessory_rails;
            }
            if (!service?.u_id) {
              const newService = {
                ...service,
                x_distance_inches: newPosition.x * pixelPerInch,
                y_distance_inches: newPosition.y * pixelPerInch,
                positions: newPosition,
                u_id: generateUniqueId(),
              };
              // Update the service in the current rail
              railData[overlappingIndex].accessories = [
                ...railData[overlappingIndex].accessories,
                newService,
              ]; // Modify this line as needed
              accessory_rails[railKey] = [...railData]; // Update the accessory rails object
              return accessory_rails; // Return the updated object
            } else {
              updateOrDeleteAccessory(
                accessory_rails,
                service?.u_id,
                overlappingIndex,
                railData,
                true,
                newPosition
              );
              return accessory_rails;
            }
          } else if (
            model === PRODUCT.INFINITY &&
            service.mount_type === "rail"
          ) {
            // const infinityTopBorderMidPoint = 43.75 / 2;
            const infinityTopBorderMidPoint = 36.75; //subtracting 7 to manage center point of rail
            // const chaseBorderWidth=29.1071428571
            // const infinityBottomBorderMidPoint = 20.5357142857;
            const chaseWidth = 247.857142857;
            const railWidth = (width.ft * 12 + width.in) / pixelPerInch;
            const minValue =
              railDimensionsRef.current?.width / 2 - 123.928571429; // 123.905px chase width
            const maxValue =
              railDimensionsRef.current?.width / 2 + 123.928571429;
            const lowerBound = newPosition.y;
            const upperBound = newPosition.y + dragServiceHeight;
            let accessoriesOnSameRail = [];
            let slideServices = [];
            let restrictedChaseAreas = [];

            // to check if user is dropping rail accessorie over track
            if (chased) {
              restrictedChaseAreas = getChaseRestrictedAreas(
                chase_position,
                newPosition,
                width,
                chaseWidth
              );

              const isInXAxisRange = restrictedChaseAreas.some(
                (range) =>
                  (newPosition.x >= range.start &&
                    newPosition.x <= range.end) ||
                  (newPosition.x < range.start &&
                    newPosition.x + dragServiceWidth > range.end)
              );

              if (isInXAxisRange) {
                warningAlert(
                  service.u_id
                    ? "Sorry, this accessory cannot be placed on a different mount type."
                    : "This accessory cannot be placed here. Please change the mount type to 'Track' to proceed."
                );
                return accessory_rails;
              }
            }

            const droppableRanges = droppableInfinityBorderRanges(
              headwalls,
              ceiling_height
            );

            const matchedRail = droppableRanges.find(
              (rail) =>
                // Check for any overlap between the ranges
                (rail.start >= lowerBound && rail.start <= upperBound) ||
                (rail.end >= lowerBound && rail.end <= upperBound) ||
                (lowerBound >= rail.start && lowerBound <= rail.end) ||
                (upperBound >= rail.start && upperBound <= rail.end) ||
                (lowerBound <= rail.start && upperBound >= rail.start) ||
                (lowerBound < rail.end && upperBound > rail.end)
            );

            if (matchedRail) {
              const panelStartPoint = matchedRail?.start;
              const panelEndPoint = matchedRail?.end;
              const sectionMidPoint = (panelStartPoint + panelEndPoint) / 2;
              if (
                (chased && chase_position === "left" && dragX < chaseWidth) ||
                (chased && chase_position === "right" && dragX > railWidth)
              ) {
                warningAlert("Sorry, you can't place rail accessory here.");
                return accessory_rails;
              } else if (
                chased &&
                chase_position === "center" &&
                dragX + dragServiceWidth > minValue &&
                dragX < maxValue
              ) {
                warningAlert("Sorry, you can't place rail accessory here.");
                return accessory_rails;
              }
              if (dragY >= panelStartPoint && dragY <= sectionMidPoint) {
                newPosition.y =
                  panelStartPoint -
                  offset_y / pixelPerInch +
                  infinityTopBorderMidPoint;
                accessoriesOnSameRail = accessory_rails["direct"].filter(
                  (serv) => {
                    return (
                      (serv.positions.y >= matchedRail.start &&
                        serv.positions.y < sectionMidPoint) ||
                      (serv.positions.y + dragServiceHeight >
                        matchedRail.start &&
                        serv.positions.y + dragServiceHeight <
                          sectionMidPoint) ||
                      (serv.positions.y < matchedRail.start &&
                        serv.positions.y + dragServiceHeight > sectionMidPoint)
                    );
                  }
                );
              } else if (dragY > sectionMidPoint && dragY < panelEndPoint) {
                newPosition.y = panelEndPoint - offset_y / pixelPerInch;
                accessoriesOnSameRail = accessory_rails["direct"].filter(
                  (serv) => {
                    return (
                      serv.positions.y <= matchedRail.end &&
                      serv.positions.y + serv.height / pixelPerInch >=
                        matchedRail.end
                    );
                  }
                );

                const services = rails[railIndex]?.services;
                slideServices = services?.filter((ser) => ser?.is_slide) || [];
                accessoriesOnSameRail = [
                  ...accessoriesOnSameRail,
                  ...slideServices,
                ];
              } else if (dragY < panelStartPoint) {
                warningAlert("Sorry, you can't place accessory here.");
                return accessory_rails;
              }

              for (let i = 0; i < accessoriesOnSameRail?.length; i++) {
                const serviceWidth =
                  accessoriesOnSameRail[i].width / pixelPerInch;
                if (service.u_id !== accessoriesOnSameRail[i].u_id) {
                  //calculation for left side drag
                  if (
                    dragX >= accessoriesOnSameRail[i]?.positions?.x &&
                    dragX <=
                      accessoriesOnSameRail[i]?.positions?.x + serviceWidth
                  ) {
                    newPosition["x"] =
                      accessoriesOnSameRail[i]?.positions?.x +
                      serviceWidth +
                      spaceMarginFromService;

                    break;
                  } //calulation for right side drag
                  else if (
                    dragX + dragServiceWidth >=
                      accessoriesOnSameRail[i]?.positions?.x &&
                    dragX + dragServiceWidth <=
                      accessoriesOnSameRail[i]?.positions?.x + dragServiceWidth
                  ) {
                    newPosition["x"] =
                      accessoriesOnSameRail[i]?.positions?.x -
                      dragServiceWidth -
                      spaceMarginFromService;
                    break;
                  }
                }
              }

              const checkServicesOverLap = accessoriesOnSameRail?.some(
                (serv) => {
                  const serviceWidth = serv.width / pixelPerInch;
                  const drag_x = newPosition.x;
                  return (
                    serv.u_id !== service.u_id &&
                    (serv.positions?.x === drag_x ||
                      (drag_x + dragServiceWidth >
                        serv.positions?.x - spaceMarginFromService &&
                        drag_x + dragServiceWidth <
                          serv.positions?.x +
                            serviceWidth +
                            spaceMarginFromService) ||
                      (drag_x > serv.positions.x - spaceMarginFromService &&
                        drag_x <
                          serv.positions.x +
                            serviceWidth +
                            spaceMarginFromService) ||
                      (drag_x < serv.positions?.x - spaceMarginFromService &&
                        drag_x + dragServiceWidth >=
                          serv.positions?.x +
                            serviceWidth +
                            spaceMarginFromService) ||
                      (drag_x > serv.positions?.x &&
                        drag_x + dragServiceWidth <
                          serv.positions?.x + serviceWidth) ||
                      drag_x < 0 ||
                      drag_x + dragServiceWidth >
                        railDimensionsRef?.current?.width)
                  );
                }
              );
              if (checkServicesOverLap) {
                warningAlert(
                  "Not enough space between services to place a accessory. Minimum distance should be 1 inches from both sides"
                );
                return accessory_rails;
              }
              if (
                chased &&
                newPosition?.x > restrictedChaseAreas[0]?.start &&
                newPosition?.x < restrictedChaseAreas[1]?.end
              ) {
                warningAlert("Sorry, you can't place accessory here.");
                return accessory_rails;
              }

              if (!service?.u_id) {
                const newService = {
                  ...service,
                  x_distance_inches: newPosition.x * pixelPerInch,
                  y_distance_inches: newPosition.y * pixelPerInch,
                  positions: newPosition,
                  u_id: generateUniqueId(),
                };
                // ]; // Modify this line as needed
                accessory_rails["direct"] = [
                  ...accessory_rails["direct"],
                  newService,
                ]; // Update the accessory rails object
                return accessory_rails; // Return the updated object
              } else {
                updateOrDeleteDirectAccessory(
                  accessory_rails,
                  service?.u_id,
                  true,
                  newPosition,
                  model
                );
                return accessory_rails;
              }
            }
          }
          return found;
        }, null);
        if (!result) {
          warningAlert(
            service.u_id
              ? "Sorry, this accessory cannot be placed on a different mount type."
              : "This accessory cannot be placed here. Please change the mount type to 'Direct' to proceed."
          );
        }
      } else {
        //to remove accessory from panel
        updateOrDeleteAccessory(accessory_rails, service?.u_id);
      }
    }
  } else if (service.mount_type === "direct") {
    if (dropArea === "rail") {
      if (
        !newPosition.x || // x is less than 0
        !newPosition.y
      ) {
        // y is less than 0
        warningAlert("Sorry, you cannot place accessory here.");
        return;
      }
      //check with other rail services
      const findRailServicesInRangeWithAccessorieRail =
        findSamePositionServices(
          rails,
          newPosition,
          dragServiceWidth,
          dragServiceHeight,
          model,
          ceiling_height,
          width
        );

      for (let serv of findRailServicesInRangeWithAccessorieRail) {
        let serviceWidth;
        if (
          model === PRODUCT.AXIOM &&
          serv.category === "Medical Gas Outlet" &&
          !serv?.is_slide
        )
          serviceWidth = (serv.width + 2.375) / pixelPerInch;
        //2.375 for side margins
        else serviceWidth = serv.width / pixelPerInch;
        const serviceHeight = serv.height / pixelPerInch;
        const serviceX = serv.positions.x;
        const serviceY = serv.positions.y;
        if (dragX >= serviceX && dragX <= serviceX + serviceWidth) {
          newPosition["x"] = serviceX + serviceWidth + spaceMarginFromService;
          break;
        } else if (
          dragX + dragServiceWidth > serviceX &&
          dragX + dragServiceWidth <= serviceX + serviceWidth
        ) {
          newPosition["x"] =
            serviceX - dragServiceWidth - spaceMarginFromService;
          break;
        } else if (
          dragY > serviceY - spaceMarginFromService &&
          dragY < serviceY
        ) {
          newPosition["y"] =
            serviceY - dragServiceWidth - spaceMarginFromService;
          break;
        } else if (
          dragY > serviceY + serviceHeight &&
          dragY < serviceY + serviceHeight + spaceMarginFromService
        ) {
          newPosition["y"] = serviceY + serviceHeight + spaceMarginFromService;
          break;
        }
      }

      //checking and assigning new positions if service overlaps any of accessorie service on panel
      Object.keys(accessory_rails).forEach((railKey) => {
        const railData = accessory_rails[railKey] || [];
        for (let i = 0; i < railData.length; i++) {
          //dimensions of services dropped on rail
          const serviceHeight = railData[i].height / pixelPerInch;
          const serviceWidth = railData[i].width / pixelPerInch;
          const serviceX = railData[i].positions.x;
          const serviceY = railData[i].positions.y;
          if (
            newPosition.x >= serviceX &&
            newPosition.x <= serviceX + serviceWidth &&
            newPosition.y <= serviceY &&
            newPosition.y + dragServiceHeight >= serviceY + serviceHeight
          ) {
            newPosition["x"] = serviceX + serviceWidth + spaceMarginFromService;
            break;
          } else if (
            newPosition.x < serviceX &&
            newPosition.x + dragServiceWidth >= serviceX &&
            newPosition.x + dragServiceWidth <= serviceX + serviceWidth &&
            newPosition.y <= serviceY &&
            newPosition.y + dragServiceHeight >= serviceY + serviceHeight
          ) {
            newPosition["x"] =
              serviceX - dragServiceWidth - spaceMarginFromService;
            break;
          }
        }
      });

      //accessorie rail overlaping over other accessorie rail
      const accessorieRailOverlapping = checkAccessorieRailOverlap(
        accessory_rails,
        service,
        newPosition
      );

      const accessorieRailServiceOverlapping =
        checkAccessorieRailOverlappingServices(
          findRailServicesInRangeWithAccessorieRail,
          service,
          newPosition
        );

      const checkAccessoryOverlapingWithOtherAccessory =
        checkAccessoriesOverlap(accessory_rails, newPosition, service);

      if (
        accessorieRailOverlapping ||
        accessorieRailServiceOverlapping ||
        checkAccessoryOverlapingWithOtherAccessory
      ) {
        warningAlert(
          "Not enough space between services to place a accessory. Minimum distance should be 1 inch from both sides"
        );
        return;
      }

      if (model === PRODUCT.AXIOM) {
        const xAxisRanges = calculateAxiomXAxisRanges(headwalls, width);

        //for axiom panel
        const inXAxisRange =
          xAxisRanges[railIndex] &&
          (newPosition.x <= xAxisRanges[railIndex].start ||
            newPosition.x + dragServiceWidth >= xAxisRanges[railIndex].end);

        if (inXAxisRange) {
          warningAlert("Sorry, you cannot place rail in a non-droppable area.");
          return;
        }
      }
      if (model === PRODUCT.INFINITY) {
        const chaseWidth = 247.857142857; //241.87 for chase width
        const chaseBorderWidth = 29.1071428571;
        let x_axis_ranges = [];
        let y_axis_ranges = [];
        const chaseElement = document?.getElementById("infinity_chase");
        const getChaseRect = chaseElement?.getBoundingClientRect();
        if (chased && newPosition.y < getChaseRect?.height) {
          if (chase_position === "left")
            x_axis_ranges = [
              { start: 0, end: 37.9285714286 },
              { start: 209.881428571, end: chaseWidth },
            ];
          else if (chase_position === "center") {
            const railTotalWidth =
              (width.ft * 12 + width.in) / pixelPerInch + chaseWidth;
            const midPoint = railTotalWidth / 2;
            x_axis_ranges = [
              {
                start: midPoint - 94.9107142857 - chaseBorderWidth,
                end: midPoint - 85.9821428571,
              },
              {
                start: midPoint + 85.9821428571,
                end: midPoint + 94.9107142857 + chaseBorderWidth,
              },
            ];
          }
          //94.9107142857 half of chase width; 85.9821428571 chase width minus 0.5 inch for margin
          else if (chase_position === "right") {
            const railTotalWidth = (width.ft * 12 + width.in) / pixelPerInch;

            x_axis_ranges = [
              {
                start: railTotalWidth,
                end: railTotalWidth + chaseBorderWidth + 10,
              }, //10 px for adjustment of right position of validation
              {
                start: railTotalWidth + chaseWidth - chaseBorderWidth - 10,
                end: railTotalWidth + chaseWidth,
              },
            ];
          }

          const inXaxisRange = x_axis_ranges.some(({ start, end }) => {
            const itemStart = newPosition.x;
            const itemEnd = newPosition.x + dragServiceWidth;

            // Check if itemStart or itemEnd falls within the range, or overlaps it
            return (
              (itemStart >= start && itemStart <= end) || // start inside the range
              (itemEnd >= start && itemEnd <= end) || // end inside the range
              (itemStart <= start && itemEnd >= end) // item completely spans the range
            );
          });
          if (inXaxisRange) {
            warningAlert(
              service.u_id
                ? "Sorry, this accessory cannot be placed on a different mount type."
                : "This accessory cannot be placed here. Please change the mount type to 'Track' to proceed."
            );
            return accessory_rails;
          }
        }

        if (
          newPosition.x >= x_axis_ranges[0]?.start &&
          newPosition.x <= x_axis_ranges[1]?.end
        ) {
          const headwall_height =
            (ceiling_height.ft * 12 + ceiling_height.in) / pixelPerInch;
          y_axis_ranges = [
            { start: 0, end: 107.142857143 },
            { start: headwall_height - 107.142857143, end: headwall_height },
          ];
        } else
          y_axis_ranges = calculateYRestictRanges(headwalls, ceiling_height);

        const notInYaxisRange = y_axis_ranges.some(
          (range) =>
            (newPosition.y >= range.start && newPosition.y <= range.end) ||
            (newPosition.y <= range.start &&
              newPosition.y + dragServiceHeight > range.start)
        );
        if (notInYaxisRange) {
          warningAlert(
            "Sorry, you cannot place accessory in non droppable area."
          );
          return;
        }
      }

      if (
        newPosition.x + dragServiceWidth > outerDivWidth || // Exceeds outer div width
        newPosition.y + dragServiceHeight > outerDivHeight || // Exceeds outer div height
        newPosition.x < 0 || // x is less than 0
        newPosition.y < 0
      ) {
        // y is less than 0
        warningAlert("Sorry, you cannot place accessory here.");
        return;
      }
      if (!service?.u_id) {
        const newService = {
          ...service,
          x_distance_inches: newPosition.x * pixelPerInch,
          y_distance_inches: newPosition.y * pixelPerInch,
          positions: newPosition,
          u_id: generateUniqueId(),
        };
        // ]; // Modify this line as needed
        accessory_rails["direct"] = [...accessory_rails["direct"], newService]; // Update the accessory rails object
        return accessory_rails; // Return the updated object
      } else
        updateOrDeleteDirectAccessory(
          accessory_rails,
          service?.u_id,
          true,
          newPosition
        );
    } else {
      updateOrDeleteDirectAccessory(accessory_rails, service?.u_id);
    }
  }
};

//infinity chase border restricted areas for direct and rail mount type

const getChaseRestrictedAreas = (chaseType, newPosition, width, chaseWidth) => {
  const chaseBorderWidth = 29.1071428571;

  let x_axis_ranges = [];
  const chaseElement = document?.getElementById("infinity_chase");
  const getChaseRect = chaseElement?.getBoundingClientRect();
  if (newPosition.y < getChaseRect?.height) {
    if (chaseType === "left")
      x_axis_ranges = [
        { start: 0, end: chaseBorderWidth },
        { start: chaseWidth - chaseBorderWidth, end: chaseWidth },
      ];
    else if (chaseType === "center") {
      const railTotalWidth =
        (width.ft * 12 + width.in) / pixelPerInch + chaseWidth;
      const midPoint = railTotalWidth / 2;
      x_axis_ranges = [
        {
          start: midPoint - 94.9107142857 - chaseBorderWidth,
          end: midPoint - 94.9107142857,
        },
        {
          start: midPoint + 94.9107142857,
          end: midPoint + 94.9107142857 + chaseBorderWidth,
        },
      ];
    }
    //94.9107142857 half of chase width;
    else if (chaseType === "right") {
      const railTotalWidth = (width.ft * 12 + width.in) / pixelPerInch;

      x_axis_ranges = [
        {
          start: railTotalWidth,
          end: railTotalWidth + chaseBorderWidth,
        },
        {
          start: railTotalWidth + chaseWidth - chaseBorderWidth,
          end: railTotalWidth + chaseWidth,
        },
      ];
    }
  }
  return x_axis_ranges;
};

//to check the accessorie rail placement positions
const checkAccessorieRailOverlap = (accessory_rails, service, newPosition) => {
  let overlappingServices = [];
  // Iterate over the keys of `accessory_rails` and collect overlapping services
  overlappingServices = Object.keys(accessory_rails).reduce((acc, railKey) => {
    const railData = accessory_rails[railKey] || [];
    const overlapping = railData.filter((existingService) => {
      if (existingService?.u_id !== service.u_id) {
        const existingX = existingService.positions.x;
        const existingY = existingService.positions.y;
        const existingWidth = existingService.width / pixelPerInch;
        const existingHeight = existingService.height / pixelPerInch;

        const serviceX = newPosition.x;
        const serviceY = newPosition.y;
        const serviceWidth = service.width / pixelPerInch;
        const serviceHeight = service.height / pixelPerInch;
        const serviceType = service.mount_type;

        const verticalSpaceMargin =
          railKey === "unimount" || service?.type === "unimount"
            ? 0
            : railKey === "direct" || serviceType === "direct"
            ? 17.8571428571
            : 107.142857143;
        // Check overlap conditions
        const isXOverlap =
          (serviceX >= existingX && serviceX < existingX + existingWidth) || // Left edge is inside
          (serviceX + serviceWidth > existingX &&
            serviceX + serviceWidth <= existingX + existingWidth) || // Right edge is inside
          (serviceX < existingX &&
            serviceX + serviceWidth > existingX + existingWidth) || // Crosses horizontally
          serviceX + serviceWidth === existingX + existingWidth; // Crosses horizontally

        // const isYOverlap =
        //   (serviceY >= existingY - verticalSpaceMargin &&
        //     Math.round(serviceY) < Math.round(existingY + existingHeight + verticalSpaceMargin)) ||
        //   (Math.round(serviceY + serviceHeight) > Math.round(existingY - verticalSpaceMargin) &&
        //     serviceY + serviceHeight <=
        //       existingY + existingHeight + verticalSpaceMargin) ||
        //   (serviceY < existingY - verticalSpaceMargin &&
        //     serviceY + serviceHeight >
        //       existingY + existingHeight + verticalSpaceMargin);
        const isYOverlap =
          (Math.round(serviceY) <
            Math.round(existingY + existingHeight + verticalSpaceMargin) &&
            Math.round(serviceY + serviceHeight) >
              Math.round(existingY + existingHeight + verticalSpaceMargin)) ||
          (Math.round(serviceY + serviceHeight) >
            Math.round(existingY - verticalSpaceMargin) &&
            serviceY < Math.round(existingY - verticalSpaceMargin)) ||
          (Math.round(serviceY + serviceHeight) >
            Math.round(existingY - verticalSpaceMargin) &&
            serviceY + serviceHeight <=
              existingY + existingHeight + verticalSpaceMargin);
        return isXOverlap && isYOverlap;
      }
      return null;
    });

    // Add overlapping services to the accumulator
    return [...acc, ...overlapping];
  }, []);
  return overlappingServices.length ? true : false;
};

// to check that accessorie rail can't overlap with normal services
const findSamePositionServices = (
  rails,
  newPosition,
  dragServiceWidth,
  dragServiceHeight,
  model,
  ceiling_height,
  panel_width //for axiom
) => {
  const headwalls = JSON.parse(JSON.stringify(rails));
  const { x, y } = newPosition; // Extract the service's position and width
  const overlappingServices = [];
  let currentPosition = 0; // Tracks the start of each section in inches
  let cumulativeWidth = 0; // Keeps track of the cumulative width of all previous sections
  const spaceMarginFromService = 17.8571428571;
  const extraMarginFromSidesForNormalServices =
    model === PRODUCT.COMPASS
      ? 49
      : model === PRODUCT.AXIOM
      ? 31.3392857142
      : 29.1071428571;

  let manageServiceY = {};

  if (model === PRODUCT.ARRAY) {
    const ceilingHeightSection2 = ceiling_height.ft * 12 + ceiling_height.in;
    const ceilingHeightSection3 = ceiling_height.ft * 12 + ceiling_height.in;
    manageServiceY["1"] = 2.875 / pixelPerInch;
    manageServiceY["2"] = (ceilingHeightSection2 - 64) / pixelPerInch;
    manageServiceY["3"] = (ceilingHeightSection3 - 34) / pixelPerInch;
  }

  // Iterate over sections to find overlaps
  for (let i = 0; i < headwalls.length; i++) {
    const section = headwalls[i];
    let sectionWidth = 0;
    let sectionEnd = 0;
    if (model === PRODUCT.AXIOM)
      sectionWidth = panel_width.ft * 12 + panel_width.in;
    else
      sectionWidth =
        model === PRODUCT.COMPASS ? section.width : section.width * 12;
    const currentWidth = cumulativeWidth;
    const sectionStart = currentPosition; // Start of the section
    if (model === PRODUCT.AXIOM)
      sectionEnd = sectionWidth / pixelPerInch + currentPosition + 6;
    //6 in to manage borders
    else sectionEnd = sectionWidth / pixelPerInch + currentPosition; // End of the section
    // const sectionEnd = sectionWidth / pixelPerInch + currentPosition; // End of the section

    // Check horizontal overlap
    const isXOverlapping =
      (x >= sectionStart && x < sectionEnd) || // Service starts in this section
      (x + dragServiceWidth > sectionStart &&
        x + dragServiceWidth <= sectionEnd) || // Service ends in this section
      (x < sectionStart && x + dragServiceWidth > sectionEnd); // Service spans across this section

    if (isXOverlapping) {
      // Check vertical overlap for services within this section
      const verticallyOverlappingServices = section.services.filter(
        (existingService) => {
          let existingY;
          if (model === PRODUCT.ARRAY) {
            existingY =
              existingService.positions.y +
              manageServiceY[existingService.rowPosition];
          } else existingY = existingService.positions.y;
          const existingHeight = existingService.height / pixelPerInch;

          const isYOverlapping =
            (y >= existingY - spaceMarginFromService &&
              y < existingY + existingHeight + spaceMarginFromService) || // Service starts within existing service
            (y + dragServiceHeight > existingY - spaceMarginFromService &&
              y + dragServiceHeight <=
                existingY + existingHeight + spaceMarginFromService) || // Service ends within existing service
            (y < existingY - spaceMarginFromService &&
              y + dragServiceHeight >
                existingY + existingHeight + spaceMarginFromService); // Service spans across existing service
          return isYOverlapping;
        }
      );

      verticallyOverlappingServices.forEach((service) => {
        // Update positions.x based on whether the service is slideable
        if (!service.is_slide) {
          // if (model === PRODUCT.COMPASS)
          service.positions.x =
            currentWidth +
            extraMarginFromSidesForNormalServices +
            service.positions.x;
        }

        // Add the cumulative width of previous sections for services in subsequent sections
        else service.positions.x += currentWidth; // Offset by the total width of previous sections
      });

      // Add the vertically overlapping services to the result
      overlappingServices.push(...verticallyOverlappingServices);
    }

    if (model === PRODUCT.AXIOM) {
      cumulativeWidth += sectionWidth / pixelPerInch + 1071.42857143; //to manage 5ft space for bed
      // Move to the next section
      currentPosition = sectionEnd + 1071.42857143;
    } else {
      cumulativeWidth += sectionWidth / pixelPerInch;
      // Move to the next section
      currentPosition = sectionEnd;
    }
  }

  return overlappingServices;
};

const findSamePositionSlideServices = (
  rails,
  newPosition,
  panel_width,
  railIndex
) => {
  const { x } = newPosition; // Extract the service's position and width
  let overlappingServices = [];
  const sectionWidth =
    (panel_width.ft * 12 + panel_width.in) / pixelPerInch + 6;
  let cumulativeWidth = 0;
  if (railIndex === 1) cumulativeWidth = sectionWidth + 1071.42857143; //6 to adjust border and 1071 for bed

  const services = rails[railIndex]?.services;

  const panelMidPoint = sectionWidth / 2 + cumulativeWidth;
  if (x < panelMidPoint)
    overlappingServices = services?.filter((serv) => {
      return serv.is_slide && serv.positions.x < sectionWidth / 2;
    });
  else if (x > panelMidPoint)
    overlappingServices = services?.filter((serv) => {
      return serv.is_slide && serv.positions.x > sectionWidth / 2;
    });
  // }

  return overlappingServices;
};

const checkAccessorieRailOverlappingServices = (
  services,
  service,
  newPosition
) => {
  let overlapping = [];
  if (service.mount_type === "track") {
    overlapping = services.filter((existingService) => {
      if (service.u_id === existingService.u_id) return null;
      const existingY = existingService.positions.y;
      const existingHeight = existingService.height / pixelPerInch;
      const railMarginFromRailService = 17.8571428571; //manage 3inch space from both side from services

      const serviceY = newPosition.y;
      const serviceHeight = service.height / pixelPerInch;
      // Check overlap conditions
      const isXOverlap =
        (serviceY < existingY + existingHeight + railMarginFromRailService &&
          serviceY + serviceHeight >
            existingY + existingHeight + railMarginFromRailService) || // top bufffer
        (serviceY < existingY &&
          serviceY + serviceHeight + railMarginFromRailService > existingY) || //bottom buffer
        (serviceY <= existingY &&
          serviceY + serviceHeight >= existingY + existingHeight) || // Crosses horizontally
        (serviceY === existingY &&
          serviceY + serviceHeight <= existingY + existingHeight) ||
        (serviceY > existingY &&
          Math.round(serviceY + serviceHeight) ===
            Math.round(existingY + existingHeight)); //start point is same but end point is different
      return isXOverlap;
    });
  } else
    overlapping = services?.filter((existingService) => {
      if (service.u_id === existingService.u_id) return null;
      const existingX = existingService.positions.x;
      const existingWidth = existingService.width / pixelPerInch;
      const railMarginFromRailService = 17.8571428571; //manage 1 inch space from both side from services

      const serviceX = newPosition.x;
      const serviceWidth = service.width / pixelPerInch;
      // Check overlap conditions
      const isXOverlap =
        (serviceX < existingX + existingWidth + railMarginFromRailService &&
          serviceX + serviceWidth >
            existingX + existingWidth + railMarginFromRailService) || // right buffer applied to existingX
        (serviceX < existingX &&
          Math.round(serviceX + serviceWidth + railMarginFromRailService) >
            Math.round(existingX)) || //left side buffer
        (serviceX <= existingX &&
          serviceX + serviceWidth >= existingX + existingWidth) || // Crosses horizontally
        (serviceX === existingX &&
          serviceX + serviceWidth <= existingX + existingWidth) ||
        (serviceX > existingX &&
          Math.round(serviceX + serviceWidth) ===
            Math.round(existingX + existingWidth)); //start point is same but end point is different
      return isXOverlap;
    });
  return overlapping?.length ? true : false;
};

//for rail and track accessories
const updateOrDeleteAccessory = (
  accessory_rails,
  targetUid,
  overlappingIndex,
  railData,
  updateData = null,
  positions = null
) => {
  // Iterate over all accessory types in accessory_rails
  if (updateData) {
    const checkMovedOnSameRail = railData[overlappingIndex].accessories?.find(
      (serv) => {
        return serv.u_id === targetUid;
      }
    );

    if (checkMovedOnSameRail) {
      const targetIndex = railData[overlappingIndex].accessories.findIndex(
        (service) => service.u_id === targetUid
      );
      railData[overlappingIndex].accessories[targetIndex].positions = positions;
      railData[overlappingIndex].accessories[targetIndex].x_distance_inches =
        positions.x * pixelPerInch;
      railData[overlappingIndex].accessories[targetIndex].y_distance_inches =
        positions.y * pixelPerInch;
    } else {
      Object.keys(accessory_rails).forEach((typeKey) => {
        const accessorieRailData = accessory_rails[typeKey];
        if (Array.isArray(accessorieRailData)) {
          if (typeKey === "direct") {
            const targetIndex = accessorieRailData.findIndex(
              (service) => service.u_id === targetUid
            );

            if (targetIndex !== -1) {
              // Update logic
              const service = accessorieRailData[targetIndex];
              service.positions = positions;
              service.x_distance_inches = positions.x * pixelPerInch;
              service.y_distance_inches = positions.y * pixelPerInch;

              railData[overlappingIndex].accessories = [
                ...railData[overlappingIndex].accessories,
                service,
              ];
              accessorieRailData.splice(targetIndex, 1);
              return;
            }
          } else {
            for (const rail of accessorieRailData) {
              if (rail.accessories && Array.isArray(rail.accessories)) {
                const targetIndex = rail.accessories.findIndex(
                  (service) => service.u_id === targetUid
                );

                if (targetIndex !== -1) {
                  // Update logic
                  const service = rail.accessories[targetIndex];
                  service.positions = positions;
                  service.x_distance_inches = positions.x * pixelPerInch;
                  service.y_distance_inches = positions.y * pixelPerInch;

                  railData[overlappingIndex].accessories = [
                    ...railData[overlappingIndex].accessories,
                    service,
                  ];
                  rail.accessories.splice(targetIndex, 1);
                  return;
                }
              }
            }
          }
        }
      });
    }
  }
  // Delete logic
  else {
    Object.keys(accessory_rails).forEach((typeKey) => {
      const accessorieRailData = accessory_rails[typeKey];
      if (typeKey === "direct")
        updateOrDeleteDirectAccessory(accessory_rails, targetUid);
      else if (Array.isArray(accessorieRailData)) {
        for (const rail of accessorieRailData) {
          if (rail.accessories && Array.isArray(rail.accessories)) {
            const targetIndex = rail.accessories.findIndex(
              (service) => service.u_id === targetUid
            );
            if (targetIndex !== -1) {
              // Delete logic
              rail.accessories.splice(targetIndex, 1);
            }
          }
        }
      }
    });
  }

  return accessory_rails;
};

//for direct accessories
const updateOrDeleteDirectAccessory = (
  accessory_rails,
  targetUid,
  updateData = null,
  positions = null,
  model = null // for infinity accessories
) => {
  // Find the index of the matching object using u_id
  const targetIndex = accessory_rails["direct"].findIndex(
    (service) => service.u_id === targetUid
  );
  if (targetIndex !== -1) {
    if (updateData) {
      // Update logic
      accessory_rails["direct"][targetIndex].positions = positions;
      accessory_rails["direct"][targetIndex].x_distance_inches =
        positions.x * pixelPerInch;
      accessory_rails["direct"][targetIndex].y_distance_inches =
        positions.y * pixelPerInch;
    } else {
      // Delete logic
      accessory_rails["direct"].splice(targetIndex, 1);
    }
  } else if (model === PRODUCT.INFINITY) {
    Object.keys(accessory_rails).forEach((typeKey) => {
      const accessorieRailData = accessory_rails[typeKey];
      if (Array.isArray(accessorieRailData)) {
        for (const rail of accessorieRailData) {
          if (rail.accessories && Array.isArray(rail.accessories)) {
            const targetIndex = rail.accessories.findIndex(
              (service) => service.u_id === targetUid
            );
            if (targetIndex !== -1) {
              // Update logic
              const service = rail.accessories[targetIndex];
              service.positions = positions;
              service.x_distance_inches = positions.x * pixelPerInch;
              service.y_distance_inches = positions.y * pixelPerInch;

              accessory_rails["direct"].push(service);
              rail.accessories.splice(targetIndex, 1);
              return;
            }
          }
        }
      }
    });
  }
  return accessory_rails;
};

const checkServiceIntersectingWithAccessoryRail = (
  railIndex,
  rails,
  dragPositions,
  service,
  extraMarginForNormalServices,
  accessory_rails,
  dragServiceWidth,
  dragServiceHeight,
  model,
  manageServiceY //using as width in case of axiom
) => {
  const { x, y } = dragPositions;
  const tempY = model !== PRODUCT.ARRAY ? y : y + manageServiceY;
  const serviceMarginFromRail = 17.8571428571;

  let cumulativeWidth = 0;
  let serviceTouchedAccessoryRail = false;
  // Add cumulative widths of previous rails if railIndex > 0
  for (let i = 0; i < railIndex; i++) {
    if (model !== PRODUCT.AXIOM)
      cumulativeWidth +=
        model === PRODUCT.COMPASS
          ? rails[i].width / pixelPerInch
          : (rails[i].width * 12) / pixelPerInch;
    // Convert rail width to pixels
    else {
      if (model === PRODUCT.AXIOM)
        cumulativeWidth +=
          (manageServiceY.ft * 12 + manageServiceY.in) / pixelPerInch +
          1071.42857143 +
          6; //to manage borders for axiom
    }
  }

  // Add extra margin to the cumulative width
  let targetX = cumulativeWidth + extraMarginForNormalServices + x;

  for (const rail in accessory_rails) {
    const accessoryRails = accessory_rails[rail];
    for (const r of accessoryRails) {
      const accessoryX = r.positions.x;
      const accessoryY = r.positions.y;
      const accessoryWidth = r.width / pixelPerInch;
      const accessoryHeight = r.height / pixelPerInch;
      if (
        targetX > accessoryX &&
        targetX < accessoryX + accessoryWidth &&
        tempY < accessoryY &&
        tempY + dragServiceHeight >= accessoryY + accessoryHeight
      ) {
        targetX = accessoryX + accessoryWidth + serviceMarginFromRail;
        serviceTouchedAccessoryRail = true;
      } else if (
        targetX + dragServiceWidth > accessoryX &&
        targetX + dragServiceWidth < accessoryX + accessoryWidth &&
        tempY < accessoryY &&
        tempY + dragServiceHeight >= accessoryY + accessoryHeight
      ) {
        targetX = accessoryX - dragServiceWidth - serviceMarginFromRail;
        serviceTouchedAccessoryRail = true;
      }
    }
  }

  // Iterate over the keys of `accessory_rails` and collect overlapping services
  const overlappingServices = Object.keys(accessory_rails).reduce(
    (acc, railKey) => {
      const railData = accessory_rails[railKey] || [];
      const overlapping = railData.filter((existingService) => {
        const existingX = existingService.positions.x;
        const existingY = existingService.positions.y;
        const existingWidth = existingService.width / pixelPerInch;
        const existingHeight = existingService.height / pixelPerInch;

        const serviceX = targetX;
        const serviceY = tempY;
        const serviceWidth = service.width / pixelPerInch;
        const serviceHeight = service.height / pixelPerInch;

        // Check overlap conditions
        const isXOverlap =
          (serviceX < existingX + existingWidth + serviceMarginFromRail &&
            serviceX + serviceWidth >
              existingX + existingWidth + serviceMarginFromRail) || // right buffer applied to existingX
          (serviceX < existingX &&
            serviceX + serviceWidth + serviceMarginFromRail > existingX) || //left side buffer
          (serviceX <= existingX &&
            serviceX + serviceWidth >= existingX + existingWidth) || // Crosses horizontally
          (serviceX >= existingX &&
            serviceX + serviceWidth <= existingX + existingWidth) || // service is in between rails
          (serviceX === existingX &&
            serviceX + serviceWidth <= existingX + existingWidth);

        const isYOverlap =
          (serviceY <= existingY &&
            serviceY + serviceHeight + serviceMarginFromRail >
              existingY + existingHeight) ||
          (serviceY <= existingY &&
            serviceY + serviceHeight + serviceMarginFromRail > existingY) ||
          (existingY + existingHeight > serviceY - serviceMarginFromRail &&
            existingY + existingHeight < serviceY + serviceHeight) ||
          (existingY < serviceY &&
            existingY + existingHeight > serviceY + serviceHeight);
        return isXOverlap && isYOverlap;
      });

      // Add overlapping services to the accumulator
      return [...acc, ...overlapping];
    },
    []
  );

  if (overlappingServices?.length) {
    return false;
  } else if (serviceTouchedAccessoryRail) {
    const updatedPosition =
      targetX - cumulativeWidth - extraMarginForNormalServices;
    // dragPositions.current.x = updatedPosition;
    dragPositions["x"] = updatedPosition;
  }

  return true;
};

//to check direct or rail accessories do not intercept with each other
const checkAccessoriesOverlap = (accessory_rails, newPosition, service) => {
  const overlappingServices = Object.keys(accessory_rails).reduce(
    (acc, railKey) => {
      const railData = accessory_rails[railKey] || [];

      // If direct rail, check inside nested accessories
      if (railKey !== "direct") {
        railData.forEach((rail) => {
          const accessories = rail.accessories || [];
          accessories.forEach((existingService) => {
            if (existingService?.u_id !== service.u_id) {
              const existingX = existingService.positions.x;
              const existingY = existingService.positions.y;
              const existingWidth = existingService.width / pixelPerInch;
              const existingHeight = existingService.height / pixelPerInch;

              const serviceX = newPosition.x;
              const serviceY = newPosition.y;
              const serviceWidth = service.width / pixelPerInch;
              const serviceHeight = service.height / pixelPerInch;

              const verticalSpaceMargin = 17.8571428571; // fixed for "direct"

              const isXOverlap =
                (serviceX >= existingX &&
                  serviceX < existingX + existingWidth) ||
                (serviceX + serviceWidth > existingX &&
                  serviceX + serviceWidth <= existingX + existingWidth) ||
                (serviceX < existingX &&
                  serviceX + serviceWidth > existingX + existingWidth) ||
                serviceX + serviceWidth === existingX + existingWidth;

              const isYOverlap =
                (Math.round(serviceY) <
                  Math.round(
                    existingY + existingHeight + verticalSpaceMargin
                  ) &&
                  Math.round(serviceY + serviceHeight) >
                    Math.round(
                      existingY + existingHeight + verticalSpaceMargin
                    )) ||
                (Math.round(serviceY + serviceHeight) >
                  Math.round(existingY - verticalSpaceMargin) &&
                  serviceY < Math.round(existingY - verticalSpaceMargin)) ||
                (Math.round(serviceY + serviceHeight) >
                  Math.round(existingY - verticalSpaceMargin) &&
                  serviceY + serviceHeight <=
                    existingY + existingHeight + verticalSpaceMargin);

              if (isXOverlap && isYOverlap) {
                acc.push(existingService);
              }
            }
          });
        });
      } else {
        // For other mount types: flat railData array
        railData.forEach((existingService) => {
          if (existingService?.u_id !== service.u_id) {
            const existingX = existingService.positions.x;
            const existingY = existingService.positions.y;
            const existingWidth = existingService.width / pixelPerInch;
            const existingHeight = existingService.height / pixelPerInch;

            const serviceX = newPosition.x;
            const serviceY = newPosition.y;
            const serviceWidth = service.width / pixelPerInch;
            const serviceHeight = service.height / pixelPerInch;
            const verticalSpaceMargin = 17.8571428571; //1 inch margin

            const isXOverlap =
              (serviceX >= existingX && serviceX < existingX + existingWidth) ||
              (serviceX + serviceWidth > existingX &&
                serviceX + serviceWidth <= existingX + existingWidth) ||
              (serviceX < existingX &&
                serviceX + serviceWidth > existingX + existingWidth) ||
              serviceX + serviceWidth === existingX + existingWidth;

            const isYOverlap =
              (Math.round(serviceY) <
                Math.round(existingY + existingHeight + verticalSpaceMargin) &&
                Math.round(serviceY + serviceHeight) >
                  Math.round(
                    existingY + existingHeight + verticalSpaceMargin
                  )) ||
              (Math.round(serviceY + serviceHeight) >
                Math.round(existingY - verticalSpaceMargin) &&
                serviceY < Math.round(existingY - verticalSpaceMargin)) ||
              (Math.round(serviceY + serviceHeight) >
                Math.round(existingY - verticalSpaceMargin) &&
                serviceY + serviceHeight <=
                  existingY + existingHeight + verticalSpaceMargin);
            if (isXOverlap && isYOverlap) {
              acc.push(existingService);
            }
          }
        });
      }

      return acc;
    },
    []
  );

  return overlappingServices.length > 0;
};

const alterImageUrl = (url) => {
  return url?.replace(/\(/g, "%28").replace(/\)/g, "%29");
};

const calculateWidth = (acc) => {
  return acc.name === "Dual (6 hook)"
    ? acc.width / pixelPerInch + 45
    : acc.width / pixelPerInch; //45 to adjust UI of dual 6 hook
};

const calculateHeight = (acc) => {
  return acc.name === "Single (3 hook)"
    ? acc.height / pixelPerInch + 90
    : acc.height / pixelPerInch;
};

export {
  checkHiddenHeadwallDropLocation,
  checkHiddenHeadwallDropLocation2,
  handleEloquenceDrop,
  handleEloquenceDrop2,
  handleConsoleDrop,
  handleConsoleDrop2,
  checkSecurityConsoleDropLocation,
  checkConsoleDropLocation,
  checkConsoleDropLocation2,
  checkEloquenceDropLocation,
  checkEloquenceDropLocation2,
  checkSecurityConsoleDropLocation2,
  calculateWidth,
  calculateHeight,
  calculateXDistance,
  calculateYDistance,
  checkInfinityDropLocation,
  checkInfinityDropLocation2,
  checkCompassDropLocation2,
  checkAxiomDropLocation,
  checkAxiomDropLocation2,
  checkCompassDropLocation,
  checkArrayDropLocation,
  checkArrayDropLocation2,
  handleInfinityAxiomDrop,
  handleInfinityAxiomDrop2,
  handleCompassDrop,
  handleArrayDrop,
  handleCompassDrop2,
  handleArrayDrop2,
  convertInchesToFeetAndInches,
  convertToInches,
  headwallData,
  checkUnimountRailDrop,
  handleAccessorieRailDropLocation,
  checkSurfaceMountedRailDrop,
  checkInfinitySurfaceMountedRailDrop,
  checkEmbeddedRailDrop,
  handleAccessoryDropLocation,
  alterImageUrl,
  getConsoleDropPoints,
  accessoriesData,
};
